"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e14) { throw _e14; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e15) { didErr = true; err = _e15; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
/*! For license information please see index.js.LICENSE.txt */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["@bugfender/sdk"] = t() : e["@bugfender/sdk"] = t();
}(self, function () {
  return function () {
    var __webpack_modules__ = {
        7496: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          });
        },
        7431: function _(e, t, r) {
          "use strict";

          var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
              void 0 === n && (n = r);
              var o = Object.getOwnPropertyDescriptor(t, r);
              o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                enumerable: !0,
                get: function get() {
                  return t[r];
                }
              }), Object.defineProperty(e, n, o);
            } : function (e, t, r, n) {
              void 0 === n && (n = r), e[n] = t[r];
            }),
            o = this && this.__exportStar || function (e, t) {
              for (var r in e) {
                "default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
              }
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), o(r(7496), t), o(r(8704), t), o(r(4596), t), o(r(8836), t), o(r(6758), t), o(r(2922), t), o(r(8287), t), o(r(5484), t), o(r(9929), t);
        },
        8704: function _(e, t) {
          "use strict";

          var r;
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.LOG_LEVELS = t.LogLevel = void 0, function (e) {
            e[e.Debug = 0] = "Debug", e[e.Warning = 1] = "Warning", e[e.Error = 2] = "Error", e[e.Trace = 3] = "Trace", e[e.Info = 4] = "Info", e[e.Fatal = 5] = "Fatal";
          }(r = t.LogLevel || (t.LogLevel = {})), t.LOG_LEVELS = [r.Debug, r.Warning, r.Error, r.Trace, r.Info, r.Fatal];
        },
        4596: function _(e, t) {
          "use strict";

          var r = this && this.__assign || function () {
            return r = Object.assign || function (e) {
              for (var t, r = 1, n = arguments.length; r < n; r++) {
                for (var o in t = arguments[r]) {
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                }
              }
              return e;
            }, r.apply(this, arguments);
          };
          function n(e) {
            Object.entries(e).forEach(function (t) {
              var r = t[0];
              void 0 === t[1] && delete e[r];
            });
          }
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.validate = t.removeUndefinedProperties = t.prepareOptions = void 0, t.prepareOptions = function (e) {
            return n(e = r({}, e)), function (e, t) {
              ["build", "version"].forEach(function (t) {
                var r = e[t];
                "string" == typeof r && "" === r.trim() && delete e[t];
              });
            }(e), e;
          }, t.removeUndefinedProperties = n, t.validate = function (e, t) {
            var r = new RegExp(/^http(s)?:\/\//i);
            Object.entries(t).forEach(function (t) {
              var n = t[0],
                o = t[1],
                i = e[n];
              o.forEach(function (e) {
                if ("required" === e) {
                  if (void 0 === i) throw new Error("Bugfender requires '".concat(n, "' option to initialize."));
                } else if ("string" === e) {
                  if (!["string", "undefined"].includes(_typeof(i))) throw new Error("'".concat(n, "' option must be a string."));
                } else if ("url" === e) {
                  if (void 0 !== i && !r.test(i)) throw new Error("'".concat(n, "' option must be a valid URL."));
                } else if ("boolean" === e && !["boolean", "undefined"].includes(_typeof(i))) throw new Error("'".concat(n, "' option must be a boolean."));
              });
            });
          };
        },
        8836: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.PrintToConsole = void 0;
          var n = r(9539),
            o = r(8704),
            i = function () {
              function e(e) {
                this.console = e, this.printToConsole = !1;
              }
              return e.prototype.init = function (e) {
                this.printToConsole = e;
              }, e.prototype.error = function () {
                for (var e, t = [], r = 0; r < arguments.length; r++) {
                  t[r] = arguments[r];
                }
                this.printToConsole && (e = this.console).error.apply(e, t);
              }, e.prototype.info = function () {
                for (var e, t = [], r = 0; r < arguments.length; r++) {
                  t[r] = arguments[r];
                }
                this.printToConsole && (e = this.console).info.apply(e, t);
              }, e.prototype.log = function () {
                for (var e, t = [], r = 0; r < arguments.length; r++) {
                  t[r] = arguments[r];
                }
                this.printToConsole && (e = this.console).log.apply(e, t);
              }, e.prototype.debug = function () {
                for (var e, t = [], r = 0; r < arguments.length; r++) {
                  t[r] = arguments[r];
                }
                this.printToConsole && (e = this.console).debug.apply(e, t);
              }, e.prototype.trace = function () {
                for (var e, t = [], r = 0; r < arguments.length; r++) {
                  t[r] = arguments[r];
                }
                this.printToConsole && (e = this.console).trace.apply(e, t);
              }, e.prototype.warn = function () {
                for (var e, t = [], r = 0; r < arguments.length; r++) {
                  t[r] = arguments[r];
                }
                this.printToConsole && (e = this.console).warn.apply(e, t);
              }, e.prototype.printLog = function (e) {
                if (this.printToConsole) {
                  var t = ["log", "warn", "error", "trace", "info", "error"][e.level || o.LogLevel.Debug],
                    r = e.tag ? "[".concat(e.tag, "] ") : "",
                    i = [e.file || "", e.method || "", e.line || ""].filter(function (e) {
                      return "" !== e;
                    }).join(":"),
                    s = "".concat(r).concat((0, n.format)(e.text), " ").concat(i);
                  this.console[t](s);
                }
              }, e;
            }();
          t.PrintToConsole = i;
        },
        6758: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.RegisterErrorHandler = void 0;
          var r = function () {
            function e(e) {
              this.window = e, this.rejectionsMap = new Map();
            }
            return e.prototype.init = function (e) {
              var t = this;
              this.bugfender = e, this.window.addEventListener("error", function (e) {
                var r = e.message,
                  n = e.lineno,
                  o = e.filename,
                  i = e.error;
                t.logError(r, o, n, i);
              }), this.window.addEventListener("unhandledrejection", function (e) {
                var r = setTimeout(function () {
                  t.logError("Potentially unhandled promise", void 0, void 0, e.reason);
                }, 1);
                t.rejectionsMap.set(e.promise, r), e.preventDefault();
              }), this.window.addEventListener("rejectionhandled", function (e) {
                clearTimeout(t.rejectionsMap.get(e.promise)), t.rejectionsMap.delete(e.promise);
              });
            }, e.prototype.logError = function (e, t, r, n) {
              var o;
              n && n.stack && (o = n.stack), "string" == typeof e && this.bugfender.sendCrash(e, ["Error: ".concat(e), "URL: ".concat(null != t ? t : "N/A"), "Line: ".concat(null != r ? r : "N/A"), "Stack: ".concat(null != o ? o : "N/A")].join("\n"));
            }, e;
          }();
          t.RegisterErrorHandler = r;
        },
        2922: function _(e, t, r) {
          "use strict";

          var n = this && this.__spreadArray || function (e, t, r) {
            if (r || 2 === arguments.length) for (var n, o = 0, i = t.length; o < i; o++) {
              !n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
            }
            return e.concat(n || Array.prototype.slice.call(t));
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.formatLogEntryText = t.format = void 0;
          var o = r(9539),
            i = r(8287);
          function s(e) {
            var t = e.slice(1),
              r = e[0];
            try {
              r = (0, i.mapToString)(r);
            } catch (e) {
              r = (0, o.format)(r);
            }
            return t.length > 0 ? o.format.apply(void 0, n([r], t, !1)) : r;
          }
          t.format = s, t.formatLogEntryText = function (e) {
            return "string" == typeof e ? e : function (e) {
              return Array.isArray(e);
            }(e) ? s(e) : "";
          };
        },
        8287: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.mapToString = t.mapToNumber = void 0, t.mapToNumber = function (e) {
            var t = Number(e);
            if (isNaN(t)) throw new Error("Can't be casted to number");
            return t;
          }, t.mapToString = function (e) {
            if (["string", "symbol", "bigint", "function"].includes(_typeof(e)) || e instanceof Error) try {
              return String(e);
            } catch (t) {
              return JSON.stringify(e);
            } else try {
              return JSON.stringify(e);
            } catch (t) {
              return String(e);
            }
          };
        },
        9929: function _(e, t) {
          "use strict";

          var r = this && this.__assign || function () {
            return r = Object.assign || function (e) {
              for (var t, r = 1, n = arguments.length; r < n; r++) {
                for (var o in t = arguments[r]) {
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                }
              }
              return e;
            }, r.apply(this, arguments);
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.UserFeedbackOptionsValidator = void 0;
          var n = {
              title: "Feedback",
              hint: "Please insert your feedback here and click send",
              subjectPlaceholder: "Subject…",
              feedbackPlaceholder: "Your feedback…",
              submitLabel: "Send",
              closeLabel: "Close"
            },
            o = function () {
              function e() {}
              return e.prototype.init = function (e) {
                return r(r({}, n), null != e ? e : {});
              }, e;
            }();
          t.UserFeedbackOptionsValidator = o;
        },
        5484: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          });
        },
        6177: function _(e, t, r) {
          e = r.nmd(e), function () {
            var t, r, n, o;
            for (n = (null !== e ? e.exports : void 0) || (window.Base58 = {}), t = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", r = {}, o = 0; o < t.length;) {
              r[t.charAt(o)] = o, o++;
            }
            n.encode = function (e) {
              var r, n, i;
              if (0 === e.length) return "";
              for (o = void 0, i = void 0, n = [0], o = 0; o < e.length;) {
                for (i = 0; i < n.length;) {
                  n[i] <<= 8, i++;
                }
                for (n[0] += e[o], r = 0, i = 0; i < n.length;) {
                  n[i] += r, r = n[i] / 58 | 0, n[i] %= 58, ++i;
                }
                for (; r;) {
                  n.push(r % 58), r = r / 58 | 0;
                }
                o++;
              }
              for (o = 0; 0 === e[o] && o < e.length - 1;) {
                n.push(0), o++;
              }
              return n.reverse().map(function (e) {
                return t[e];
              }).join("");
            }, n.decode = function (e) {
              var t, n, i, s;
              if (0 === e.length) return new ("undefined" != typeof Uint8Array && null !== Uint8Array ? Uint8Array : Buffer)(0);
              for (o = void 0, s = void 0, t = [0], o = 0; o < e.length;) {
                if (!((n = e[o]) in r)) throw "Base58.decode received unacceptable input. Character '" + n + "' is not in the Base58 alphabet.";
                for (s = 0; s < t.length;) {
                  t[s] *= 58, s++;
                }
                for (t[0] += r[n], i = 0, s = 0; s < t.length;) {
                  t[s] += i, i = t[s] >> 8, t[s] &= 255, ++s;
                }
                for (; i;) {
                  t.push(255 & i), i >>= 8;
                }
                o++;
              }
              for (o = 0; "1" === e[o] && o < e.length - 1;) {
                t.push(0), o++;
              }
              return new ("undefined" != typeof Uint8Array && null !== Uint8Array ? Uint8Array : Buffer)(t.reverse());
            };
          }.call(this);
        },
        1206: function _(e) {
          e.exports = function (e) {
            var t = {};
            function r(n) {
              if (t[n]) return t[n].exports;
              var o = t[n] = {
                i: n,
                l: !1,
                exports: {}
              };
              return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
            }
            return r.m = e, r.c = t, r.d = function (e, t, n) {
              r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
              });
            }, r.r = function (e) {
              "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
              }), Object.defineProperty(e, "__esModule", {
                value: !0
              });
            }, r.t = function (e, t) {
              if (1 & t && (e = r(e)), 8 & t) return e;
              if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
              var n = Object.create(null);
              if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
              }), 2 & t && "string" != typeof e) for (var o in e) {
                r.d(n, o, function (t) {
                  return e[t];
                }.bind(null, o));
              }
              return n;
            }, r.n = function (e) {
              var t = e && e.__esModule ? function () {
                return e.default;
              } : function () {
                return e;
              };
              return r.d(t, "a", t), t;
            }, r.o = function (e, t) {
              return Object.prototype.hasOwnProperty.call(e, t);
            }, r.p = "", r(r.s = 90);
          }({
            17: function _(e, t, r) {
              "use strict";

              t.__esModule = !0, t.default = void 0;
              var n = r(18),
                o = function () {
                  function e() {}
                  return e.getFirstMatch = function (e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                  }, e.getSecondMatch = function (e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                  }, e.matchAndReturnConst = function (e, t, r) {
                    if (e.test(t)) return r;
                  }, e.getWindowsVersionName = function (e) {
                    switch (e) {
                      case "NT":
                        return "NT";
                      case "XP":
                      case "NT 5.1":
                        return "XP";
                      case "NT 5.0":
                        return "2000";
                      case "NT 5.2":
                        return "2003";
                      case "NT 6.0":
                        return "Vista";
                      case "NT 6.1":
                        return "7";
                      case "NT 6.2":
                        return "8";
                      case "NT 6.3":
                        return "8.1";
                      case "NT 10.0":
                        return "10";
                      default:
                        return;
                    }
                  }, e.getMacOSVersionName = function (e) {
                    var t = e.split(".").splice(0, 2).map(function (e) {
                      return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch (t[1]) {
                      case 5:
                        return "Leopard";
                      case 6:
                        return "Snow Leopard";
                      case 7:
                        return "Lion";
                      case 8:
                        return "Mountain Lion";
                      case 9:
                        return "Mavericks";
                      case 10:
                        return "Yosemite";
                      case 11:
                        return "El Capitan";
                      case 12:
                        return "Sierra";
                      case 13:
                        return "High Sierra";
                      case 14:
                        return "Mojave";
                      case 15:
                        return "Catalina";
                      default:
                        return;
                    }
                  }, e.getAndroidVersionName = function (e) {
                    var t = e.split(".").splice(0, 2).map(function (e) {
                      return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                  }, e.getVersionPrecision = function (e) {
                    return e.split(".").length;
                  }, e.compareVersions = function (t, r, n) {
                    void 0 === n && (n = !1);
                    var o = e.getVersionPrecision(t),
                      i = e.getVersionPrecision(r),
                      s = Math.max(o, i),
                      a = 0,
                      c = e.map([t, r], function (t) {
                        var r = s - e.getVersionPrecision(t),
                          n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function (e) {
                          return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                      });
                    for (n && (a = s - Math.min(o, i)), s -= 1; s >= a;) {
                      if (c[0][s] > c[1][s]) return 1;
                      if (c[0][s] === c[1][s]) {
                        if (s === a) return 0;
                        s -= 1;
                      } else if (c[0][s] < c[1][s]) return -1;
                    }
                  }, e.map = function (e, t) {
                    var r,
                      n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for (r = 0; r < e.length; r += 1) {
                      n.push(t(e[r]));
                    }
                    return n;
                  }, e.find = function (e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for (r = 0, n = e.length; r < n; r += 1) {
                      var o = e[r];
                      if (t(o, r)) return o;
                    }
                  }, e.assign = function (e) {
                    for (var t, r, n = e, o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++) {
                      i[s - 1] = arguments[s];
                    }
                    if (Object.assign) return Object.assign.apply(Object, [e].concat(i));
                    var a = function a() {
                      var e = i[t];
                      "object" == _typeof(e) && null !== e && Object.keys(e).forEach(function (t) {
                        n[t] = e[t];
                      });
                    };
                    for (t = 0, r = i.length; t < r; t += 1) {
                      a();
                    }
                    return e;
                  }, e.getBrowserAlias = function (e) {
                    return n.BROWSER_ALIASES_MAP[e];
                  }, e.getBrowserTypeByAlias = function (e) {
                    return n.BROWSER_MAP[e] || "";
                  }, e;
                }();
              t.default = o, e.exports = t.default;
            },
            18: function _(e, t, r) {
              "use strict";

              t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
              }, t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
              }, t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
              }, t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
              }, t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
              };
            },
            90: function _(e, t, r) {
              "use strict";

              t.__esModule = !0, t.default = void 0;
              var n,
                o = (n = r(91)) && n.__esModule ? n : {
                  default: n
                },
                i = r(18);
              function s(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
              }
              var a = function () {
                function e() {}
                var t, r;
                return e.getParser = function (e, t) {
                  if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                  return new o.default(e, t);
                }, e.parse = function (e) {
                  return new o.default(e).getResult();
                }, t = e, r = [{
                  key: "BROWSER_MAP",
                  get: function get() {
                    return i.BROWSER_MAP;
                  }
                }, {
                  key: "ENGINE_MAP",
                  get: function get() {
                    return i.ENGINE_MAP;
                  }
                }, {
                  key: "OS_MAP",
                  get: function get() {
                    return i.OS_MAP;
                  }
                }, {
                  key: "PLATFORMS_MAP",
                  get: function get() {
                    return i.PLATFORMS_MAP;
                  }
                }], null && s(t.prototype, null), r && s(t, r), e;
              }();
              t.default = a, e.exports = t.default;
            },
            91: function _(e, t, r) {
              "use strict";

              t.__esModule = !0, t.default = void 0;
              var n = c(r(92)),
                o = c(r(93)),
                i = c(r(94)),
                s = c(r(95)),
                a = c(r(17));
              function c(e) {
                return e && e.__esModule ? e : {
                  default: e
                };
              }
              var u = function () {
                function e(e, t) {
                  if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                  this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function () {
                  return this._ua;
                }, t.test = function (e) {
                  return e.test(this._ua);
                }, t.parseBrowser = function () {
                  var e = this;
                  this.parsedResult.browser = {};
                  var t = a.default.find(n.default, function (t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function (t) {
                      return e.test(t);
                    });
                    throw new Error("Browser's test function is not valid");
                  });
                  return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function () {
                  return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function (e) {
                  return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function () {
                  return this.getBrowser().version;
                }, t.getOS = function () {
                  return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function () {
                  var e = this;
                  this.parsedResult.os = {};
                  var t = a.default.find(o.default, function (t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function (t) {
                      return e.test(t);
                    });
                    throw new Error("Browser's test function is not valid");
                  });
                  return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function (e) {
                  var t = this.getOS().name;
                  return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function () {
                  return this.getOS().version;
                }, t.getPlatform = function () {
                  return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function (e) {
                  void 0 === e && (e = !1);
                  var t = this.getPlatform().type;
                  return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function () {
                  var e = this;
                  this.parsedResult.platform = {};
                  var t = a.default.find(i.default, function (t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function (t) {
                      return e.test(t);
                    });
                    throw new Error("Browser's test function is not valid");
                  });
                  return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function () {
                  return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function (e) {
                  return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function () {
                  var e = this;
                  this.parsedResult.engine = {};
                  var t = a.default.find(s.default, function (t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function (t) {
                      return e.test(t);
                    });
                    throw new Error("Browser's test function is not valid");
                  });
                  return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function () {
                  return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function () {
                  return a.default.assign({}, this.parsedResult);
                }, t.satisfies = function (e) {
                  var t = this,
                    r = {},
                    n = 0,
                    o = {},
                    i = 0;
                  if (Object.keys(e).forEach(function (t) {
                    var s = e[t];
                    "string" == typeof s ? (o[t] = s, i += 1) : "object" == _typeof(s) && (r[t] = s, n += 1);
                  }), n > 0) {
                    var s = Object.keys(r),
                      c = a.default.find(s, function (e) {
                        return t.isOS(e);
                      });
                    if (c) {
                      var u = this.satisfies(r[c]);
                      if (void 0 !== u) return u;
                    }
                    var l = a.default.find(s, function (e) {
                      return t.isPlatform(e);
                    });
                    if (l) {
                      var d = this.satisfies(r[l]);
                      if (void 0 !== d) return d;
                    }
                  }
                  if (i > 0) {
                    var f = Object.keys(o),
                      p = a.default.find(f, function (e) {
                        return t.isBrowser(e, !0);
                      });
                    if (void 0 !== p) return this.compareVersion(o[p]);
                  }
                }, t.isBrowser = function (e, t) {
                  void 0 === t && (t = !1);
                  var r = this.getBrowserName().toLowerCase(),
                    n = e.toLowerCase(),
                    o = a.default.getBrowserTypeByAlias(n);
                  return t && o && (n = o.toLowerCase()), n === r;
                }, t.compareVersion = function (e) {
                  var t = [0],
                    r = e,
                    n = !1,
                    o = this.getBrowserVersion();
                  if ("string" == typeof o) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(a.default.compareVersions(o, r, n)) > -1;
                }, t.isOS = function (e) {
                  return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function (e) {
                  return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function (e) {
                  return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function (e, t) {
                  return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function (e) {
                  var t = this;
                  return void 0 === e && (e = []), e.some(function (e) {
                    return t.is(e);
                  });
                }, e;
              }();
              t.default = u, e.exports = t.default;
            },
            92: function _(e, t, r) {
              "use strict";

              t.__esModule = !0, t.default = void 0;
              var n,
                o = (n = r(17)) && n.__esModule ? n : {
                  default: n
                },
                i = /version\/(\d+(\.?_?\d+)+)/i,
                s = [{
                  test: [/googlebot/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Googlebot"
                      },
                      r = o.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/opera/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Opera"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/opr\/|opios/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Opera"
                      },
                      r = o.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/SamsungBrowser/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Samsung Internet for Android"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/Whale/i],
                  describe: function describe(e) {
                    var t = {
                        name: "NAVER Whale Browser"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/MZBrowser/i],
                  describe: function describe(e) {
                    var t = {
                        name: "MZ Browser"
                      },
                      r = o.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/focus/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Focus"
                      },
                      r = o.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/swing/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Swing"
                      },
                      r = o.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/coast/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Opera Coast"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/opt\/\d+(?:.?_?\d+)+/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Opera Touch"
                      },
                      r = o.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/yabrowser/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Yandex Browser"
                      },
                      r = o.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/ucbrowser/i],
                  describe: function describe(e) {
                    var t = {
                        name: "UC Browser"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/Maxthon|mxios/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Maxthon"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/epiphany/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Epiphany"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/puffin/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Puffin"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/sleipnir/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Sleipnir"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/k-meleon/i],
                  describe: function describe(e) {
                    var t = {
                        name: "K-Meleon"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/micromessenger/i],
                  describe: function describe(e) {
                    var t = {
                        name: "WeChat"
                      },
                      r = o.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/qqbrowser/i],
                  describe: function describe(e) {
                    var t = {
                        name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                      },
                      r = o.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/msie|trident/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Internet Explorer"
                      },
                      r = o.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/\sedg\//i],
                  describe: function describe(e) {
                    var t = {
                        name: "Microsoft Edge"
                      },
                      r = o.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/edg([ea]|ios)/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Microsoft Edge"
                      },
                      r = o.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/vivaldi/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Vivaldi"
                      },
                      r = o.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/seamonkey/i],
                  describe: function describe(e) {
                    var t = {
                        name: "SeaMonkey"
                      },
                      r = o.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/sailfish/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Sailfish"
                      },
                      r = o.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/silk/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Amazon Silk"
                      },
                      r = o.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/phantom/i],
                  describe: function describe(e) {
                    var t = {
                        name: "PhantomJS"
                      },
                      r = o.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/slimerjs/i],
                  describe: function describe(e) {
                    var t = {
                        name: "SlimerJS"
                      },
                      r = o.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
                  describe: function describe(e) {
                    var t = {
                        name: "BlackBerry"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/(web|hpw)[o0]s/i],
                  describe: function describe(e) {
                    var t = {
                        name: "WebOS Browser"
                      },
                      r = o.default.getFirstMatch(i, e) || o.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/bada/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Bada"
                      },
                      r = o.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/tizen/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Tizen"
                      },
                      r = o.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/qupzilla/i],
                  describe: function describe(e) {
                    var t = {
                        name: "QupZilla"
                      },
                      r = o.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/firefox|iceweasel|fxios/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Firefox"
                      },
                      r = o.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/electron/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Electron"
                      },
                      r = o.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/MiuiBrowser/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Miui"
                      },
                      r = o.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/chromium/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Chromium"
                      },
                      r = o.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/chrome|crios|crmo/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Chrome"
                      },
                      r = o.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/GSA/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Google Search"
                      },
                      r = o.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: function test(e) {
                    var t = !e.test(/like android/i),
                      r = e.test(/android/i);
                    return t && r;
                  },
                  describe: function describe(e) {
                    var t = {
                        name: "Android Browser"
                      },
                      r = o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/playstation 4/i],
                  describe: function describe(e) {
                    var t = {
                        name: "PlayStation 4"
                      },
                      r = o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/safari|applewebkit/i],
                  describe: function describe(e) {
                    var t = {
                        name: "Safari"
                      },
                      r = o.default.getFirstMatch(i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/.*/i],
                  describe: function describe(e) {
                    var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                    return {
                      name: o.default.getFirstMatch(t, e),
                      version: o.default.getSecondMatch(t, e)
                    };
                  }
                }];
              t.default = s, e.exports = t.default;
            },
            93: function _(e, t, r) {
              "use strict";

              t.__esModule = !0, t.default = void 0;
              var n,
                o = (n = r(17)) && n.__esModule ? n : {
                  default: n
                },
                i = r(18),
                s = [{
                  test: [/Roku\/DVP/],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                    return {
                      name: i.OS_MAP.Roku,
                      version: t
                    };
                  }
                }, {
                  test: [/windows phone/i],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                    return {
                      name: i.OS_MAP.WindowsPhone,
                      version: t
                    };
                  }
                }, {
                  test: [/windows /i],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e),
                      r = o.default.getWindowsVersionName(t);
                    return {
                      name: i.OS_MAP.Windows,
                      version: t,
                      versionName: r
                    };
                  }
                }, {
                  test: [/Macintosh(.*?) FxiOS(.*?)\//],
                  describe: function describe(e) {
                    var t = {
                        name: i.OS_MAP.iOS
                      },
                      r = o.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/macintosh/i],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."),
                      r = o.default.getMacOSVersionName(t),
                      n = {
                        name: i.OS_MAP.MacOS,
                        version: t
                      };
                    return r && (n.versionName = r), n;
                  }
                }, {
                  test: [/(ipod|iphone|ipad)/i],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                    return {
                      name: i.OS_MAP.iOS,
                      version: t
                    };
                  }
                }, {
                  test: function test(e) {
                    var t = !e.test(/like android/i),
                      r = e.test(/android/i);
                    return t && r;
                  },
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e),
                      r = o.default.getAndroidVersionName(t),
                      n = {
                        name: i.OS_MAP.Android,
                        version: t
                      };
                    return r && (n.versionName = r), n;
                  }
                }, {
                  test: [/(web|hpw)[o0]s/i],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e),
                      r = {
                        name: i.OS_MAP.WebOS
                      };
                    return t && t.length && (r.version = t), r;
                  }
                }, {
                  test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || o.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || o.default.getFirstMatch(/\bbb(\d+)/i, e);
                    return {
                      name: i.OS_MAP.BlackBerry,
                      version: t
                    };
                  }
                }, {
                  test: [/bada/i],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                    return {
                      name: i.OS_MAP.Bada,
                      version: t
                    };
                  }
                }, {
                  test: [/tizen/i],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                    return {
                      name: i.OS_MAP.Tizen,
                      version: t
                    };
                  }
                }, {
                  test: [/linux/i],
                  describe: function describe() {
                    return {
                      name: i.OS_MAP.Linux
                    };
                  }
                }, {
                  test: [/CrOS/],
                  describe: function describe() {
                    return {
                      name: i.OS_MAP.ChromeOS
                    };
                  }
                }, {
                  test: [/PlayStation 4/],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                    return {
                      name: i.OS_MAP.PlayStation4,
                      version: t
                    };
                  }
                }];
              t.default = s, e.exports = t.default;
            },
            94: function _(e, t, r) {
              "use strict";

              t.__esModule = !0, t.default = void 0;
              var n,
                o = (n = r(17)) && n.__esModule ? n : {
                  default: n
                },
                i = r(18),
                s = [{
                  test: [/googlebot/i],
                  describe: function describe() {
                    return {
                      type: "bot",
                      vendor: "Google"
                    };
                  }
                }, {
                  test: [/huawei/i],
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/(can-l01)/i, e) && "Nova",
                      r = {
                        type: i.PLATFORMS_MAP.mobile,
                        vendor: "Huawei"
                      };
                    return t && (r.model = t), r;
                  }
                }, {
                  test: [/nexus\s*(?:7|8|9|10).*/i],
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.tablet,
                      vendor: "Nexus"
                    };
                  }
                }, {
                  test: [/ipad/i],
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.tablet,
                      vendor: "Apple",
                      model: "iPad"
                    };
                  }
                }, {
                  test: [/Macintosh(.*?) FxiOS(.*?)\//],
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.tablet,
                      vendor: "Apple",
                      model: "iPad"
                    };
                  }
                }, {
                  test: [/kftt build/i],
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.tablet,
                      vendor: "Amazon",
                      model: "Kindle Fire HD 7"
                    };
                  }
                }, {
                  test: [/silk/i],
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.tablet,
                      vendor: "Amazon"
                    };
                  }
                }, {
                  test: [/tablet(?! pc)/i],
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.tablet
                    };
                  }
                }, {
                  test: function test(e) {
                    var t = e.test(/ipod|iphone/i),
                      r = e.test(/like (ipod|iphone)/i);
                    return t && !r;
                  },
                  describe: function describe(e) {
                    var t = o.default.getFirstMatch(/(ipod|iphone)/i, e);
                    return {
                      type: i.PLATFORMS_MAP.mobile,
                      vendor: "Apple",
                      model: t
                    };
                  }
                }, {
                  test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.mobile,
                      vendor: "Nexus"
                    };
                  }
                }, {
                  test: [/[^-]mobi/i],
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.mobile
                    };
                  }
                }, {
                  test: function test(e) {
                    return "blackberry" === e.getBrowserName(!0);
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.mobile,
                      vendor: "BlackBerry"
                    };
                  }
                }, {
                  test: function test(e) {
                    return "bada" === e.getBrowserName(!0);
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.mobile
                    };
                  }
                }, {
                  test: function test(e) {
                    return "windows phone" === e.getBrowserName();
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.mobile,
                      vendor: "Microsoft"
                    };
                  }
                }, {
                  test: function test(e) {
                    var t = Number(String(e.getOSVersion()).split(".")[0]);
                    return "android" === e.getOSName(!0) && t >= 3;
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.tablet
                    };
                  }
                }, {
                  test: function test(e) {
                    return "android" === e.getOSName(!0);
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.mobile
                    };
                  }
                }, {
                  test: function test(e) {
                    return "macos" === e.getOSName(!0);
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.desktop,
                      vendor: "Apple"
                    };
                  }
                }, {
                  test: function test(e) {
                    return "windows" === e.getOSName(!0);
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.desktop
                    };
                  }
                }, {
                  test: function test(e) {
                    return "linux" === e.getOSName(!0);
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.desktop
                    };
                  }
                }, {
                  test: function test(e) {
                    return "playstation 4" === e.getOSName(!0);
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.tv
                    };
                  }
                }, {
                  test: function test(e) {
                    return "roku" === e.getOSName(!0);
                  },
                  describe: function describe() {
                    return {
                      type: i.PLATFORMS_MAP.tv
                    };
                  }
                }];
              t.default = s, e.exports = t.default;
            },
            95: function _(e, t, r) {
              "use strict";

              t.__esModule = !0, t.default = void 0;
              var n,
                o = (n = r(17)) && n.__esModule ? n : {
                  default: n
                },
                i = r(18),
                s = [{
                  test: function test(e) {
                    return "microsoft edge" === e.getBrowserName(!0);
                  },
                  describe: function describe(e) {
                    if (/\sedg\//i.test(e)) return {
                      name: i.ENGINE_MAP.Blink
                    };
                    var t = o.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                    return {
                      name: i.ENGINE_MAP.EdgeHTML,
                      version: t
                    };
                  }
                }, {
                  test: [/trident/i],
                  describe: function describe(e) {
                    var t = {
                        name: i.ENGINE_MAP.Trident
                      },
                      r = o.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: function test(e) {
                    return e.test(/presto/i);
                  },
                  describe: function describe(e) {
                    var t = {
                        name: i.ENGINE_MAP.Presto
                      },
                      r = o.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: function test(e) {
                    var t = e.test(/gecko/i),
                      r = e.test(/like gecko/i);
                    return t && !r;
                  },
                  describe: function describe(e) {
                    var t = {
                        name: i.ENGINE_MAP.Gecko
                      },
                      r = o.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }, {
                  test: [/(apple)?webkit\/537\.36/i],
                  describe: function describe() {
                    return {
                      name: i.ENGINE_MAP.Blink
                    };
                  }
                }, {
                  test: [/(apple)?webkit/i],
                  describe: function describe(e) {
                    var t = {
                        name: i.ENGINE_MAP.WebKit
                      },
                      r = o.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                  }
                }];
              t.default = s, e.exports = t.default;
            }
          });
        },
        8991: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.OPEN_BROADCAST_CHANNELS = t.BroadcastChannel = void 0, t.clearNodeFolder = function (e) {
            e = (0, i.fillOptionsWithDefaults)(e);
            var t = (0, o.chooseMethod)(e);
            return "node" === t.type ? t.clearNodeFolder().then(function () {
              return !0;
            }) : n.PROMISE_RESOLVED_FALSE;
          }, t.enforceOptions = function (e) {
            a = e;
          };
          var n = r(6202),
            o = r(4632),
            i = r(423),
            s = new Set();
          t.OPEN_BROADCAST_CHANNELS = s;
          var a,
            c = 0,
            u = function u(e, t) {
              var r, u;
              this.id = c++, s.add(this), this.name = e, a && (t = a), this.options = (0, i.fillOptionsWithDefaults)(t), this.method = (0, o.chooseMethod)(this.options), this._iL = !1, this._onML = null, this._addEL = {
                message: [],
                internal: []
              }, this._uMP = new Set(), this._befC = [], this._prepP = null, u = (r = this).method.create(r.name, r.options), (0, n.isPromise)(u) ? (r._prepP = u, u.then(function (e) {
                r._state = e;
              })) : r._state = u;
            };
          function l(e, t, r) {
            var o = {
              time: e.method.microSeconds(),
              type: t,
              data: r
            };
            return (e._prepP ? e._prepP : n.PROMISE_RESOLVED_VOID).then(function () {
              var t = e.method.postMessage(e._state, o);
              return e._uMP.add(t), t.catch().then(function () {
                return e._uMP.delete(t);
              }), t;
            });
          }
          function d(e) {
            return e._addEL.message.length > 0 || e._addEL.internal.length > 0;
          }
          function f(e, t, r) {
            e._addEL[t].push(r), function (e) {
              if (!e._iL && d(e)) {
                var t = function t(_t) {
                    e._addEL[_t.type].forEach(function (e) {
                      var r = e.time - 1e5;
                      _t.time >= r && e.fn(_t.data);
                    });
                  },
                  r = e.method.microSeconds();
                e._prepP ? e._prepP.then(function () {
                  e._iL = !0, e.method.onMessage(e._state, t, r);
                }) : (e._iL = !0, e.method.onMessage(e._state, t, r));
              }
            }(e);
          }
          function p(e, t, r) {
            e._addEL[t] = e._addEL[t].filter(function (e) {
              return e !== r;
            }), function (e) {
              if (e._iL && !d(e)) {
                e._iL = !1;
                var t = e.method.microSeconds();
                e.method.onMessage(e._state, null, t);
              }
            }(e);
          }
          t.BroadcastChannel = u, u._pubkey = !0, u.prototype = {
            postMessage: function postMessage(e) {
              if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + JSON.stringify(e));
              return l(this, "message", e);
            },
            postInternal: function postInternal(e) {
              return l(this, "internal", e);
            },
            set onmessage(e) {
              var t = {
                time: this.method.microSeconds(),
                fn: e
              };
              p(this, "message", this._onML), e && "function" == typeof e ? (this._onML = t, f(this, "message", t)) : this._onML = null;
            },
            addEventListener: function addEventListener(e, t) {
              f(this, e, {
                time: this.method.microSeconds(),
                fn: t
              });
            },
            removeEventListener: function removeEventListener(e, t) {
              p(this, e, this._addEL[e].find(function (e) {
                return e.fn === t;
              }));
            },
            close: function close() {
              var e = this;
              if (!this.closed) {
                s.delete(this), this.closed = !0;
                var t = this._prepP ? this._prepP : n.PROMISE_RESOLVED_VOID;
                return this._onML = null, this._addEL.message = [], t.then(function () {
                  return Promise.all(Array.from(e._uMP));
                }).then(function () {
                  return Promise.all(e._befC.map(function (e) {
                    return e();
                  }));
                }).then(function () {
                  return e.method.close(e._state);
                });
              }
            },
            get type() {
              return this.method.type;
            },
            get isClosed() {
              return this.closed;
            }
          };
        },
        8437: function _(e, t, r) {
          "use strict";

          var n = r(5585);
          e.exports = {
            BroadcastChannel: n.BroadcastChannel,
            createLeaderElection: n.createLeaderElection,
            clearNodeFolder: n.clearNodeFolder,
            enforceOptions: n.enforceOptions,
            beLeader: n.beLeader
          };
        },
        5585: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), Object.defineProperty(t, "BroadcastChannel", {
            enumerable: !0,
            get: function get() {
              return n.BroadcastChannel;
            }
          }), Object.defineProperty(t, "OPEN_BROADCAST_CHANNELS", {
            enumerable: !0,
            get: function get() {
              return n.OPEN_BROADCAST_CHANNELS;
            }
          }), Object.defineProperty(t, "beLeader", {
            enumerable: !0,
            get: function get() {
              return o.beLeader;
            }
          }), Object.defineProperty(t, "clearNodeFolder", {
            enumerable: !0,
            get: function get() {
              return n.clearNodeFolder;
            }
          }), Object.defineProperty(t, "createLeaderElection", {
            enumerable: !0,
            get: function get() {
              return o.createLeaderElection;
            }
          }), Object.defineProperty(t, "enforceOptions", {
            enumerable: !0,
            get: function get() {
              return n.enforceOptions;
            }
          });
          var n = r(8991),
            o = r(6550);
        },
        6550: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.beLeader = a, t.createLeaderElection = function (e, t) {
            if (e._leaderElector) throw new Error("BroadcastChannel already has a leader-elector");
            t = function (e, t) {
              return e || (e = {}), (e = JSON.parse(JSON.stringify(e))).fallbackInterval || (e.fallbackInterval = 3e3), e.responseTime || (e.responseTime = t.method.averageResponseTime(t.options)), e;
            }(t, e);
            var r = new i(e, t);
            return e._befC.push(function () {
              return r.die();
            }), e._leaderElector = r, r;
          };
          var n = r(6202),
            o = r(4810),
            i = function i(e, t) {
              var r = this;
              this.broadcastChannel = e, this._options = t, this.isLeader = !1, this.hasLeader = !1, this.isDead = !1, this.token = (0, n.randomToken)(), this._aplQ = n.PROMISE_RESOLVED_VOID, this._aplQC = 0, this._unl = [], this._lstns = [], this._dpL = function () {}, this._dpLC = !1;
              var o = function o(e) {
                "leader" === e.context && ("death" === e.action && (r.hasLeader = !1), "tell" === e.action && (r.hasLeader = !0));
              };
              this.broadcastChannel.addEventListener("internal", o), this._lstns.push(o);
            };
          function s(e, t) {
            var r = {
              context: "leader",
              action: t,
              token: e.token
            };
            return e.broadcastChannel.postInternal(r);
          }
          function a(e) {
            e.isLeader = !0, e.hasLeader = !0;
            var t = (0, o.add)(function () {
              return e.die();
            });
            e._unl.push(t);
            var r = function r(t) {
              "leader" === t.context && "apply" === t.action && s(e, "tell"), "leader" !== t.context || "tell" !== t.action || e._dpLC || (e._dpLC = !0, e._dpL(), s(e, "tell"));
            };
            return e.broadcastChannel.addEventListener("internal", r), e._lstns.push(r), s(e, "tell");
          }
          i.prototype = {
            applyOnce: function applyOnce(e) {
              var t = this;
              return this.isLeader ? (0, n.sleep)(0, !0) : this.isDead ? (0, n.sleep)(0, !1) : this._aplQC > 1 ? this._aplQ : (this._aplQC = this._aplQC + 1, this._aplQ = this._aplQ.then(function () {
                return function () {
                  if (t.isLeader) return n.PROMISE_RESOLVED_TRUE;
                  var r,
                    o = !1,
                    i = new Promise(function (e) {
                      r = function r() {
                        o = !0, e();
                      };
                    }),
                    c = function c(e) {
                      "leader" === e.context && e.token != t.token && ("apply" === e.action && e.token > t.token && r(), "tell" === e.action && (r(), t.hasLeader = !0));
                    };
                  t.broadcastChannel.addEventListener("internal", c);
                  var u = e ? 4 * t._options.responseTime : t._options.responseTime;
                  return s(t, "apply").then(function () {
                    return Promise.race([(0, n.sleep)(u), i.then(function () {
                      return Promise.reject(new Error());
                    })]);
                  }).then(function () {
                    return s(t, "apply");
                  }).then(function () {
                    return Promise.race([(0, n.sleep)(u), i.then(function () {
                      return Promise.reject(new Error());
                    })]);
                  }).catch(function () {}).then(function () {
                    return t.broadcastChannel.removeEventListener("internal", c), !o && a(t).then(function () {
                      return !0;
                    });
                  });
                }();
              }).then(function () {
                t._aplQC = t._aplQC - 1;
              }), this._aplQ.then(function () {
                return t.isLeader;
              }));
            },
            awaitLeadership: function awaitLeadership() {
              return this._aLP || (this._aLP = (e = this).isLeader ? n.PROMISE_RESOLVED_VOID : new Promise(function (t) {
                var r = !1;
                function o() {
                  r || (r = !0, e.broadcastChannel.removeEventListener("internal", i), t(!0));
                }
                e.applyOnce().then(function () {
                  e.isLeader && o();
                }), function t() {
                  return (0, n.sleep)(e._options.fallbackInterval).then(function () {
                    if (!e.isDead && !r) return e.isLeader ? void o() : e.applyOnce(!0).then(function () {
                      e.isLeader ? o() : t();
                    });
                  });
                }();
                var i = function i(t) {
                  "leader" === t.context && "death" === t.action && (e.hasLeader = !1, e.applyOnce().then(function () {
                    e.isLeader && o();
                  }));
                };
                e.broadcastChannel.addEventListener("internal", i), e._lstns.push(i);
              })), this._aLP;
              var e;
            },
            set onduplicate(e) {
              this._dpL = e;
            },
            die: function die() {
              var e = this;
              return this._lstns.forEach(function (t) {
                return e.broadcastChannel.removeEventListener("internal", t);
              }), this._lstns = [], this._unl.forEach(function (e) {
                return e.remove();
              }), this._unl = [], this.isLeader && (this.hasLeader = !1, this.isLeader = !1), this.isDead = !0, s(this, "death");
            }
          };
        },
        4632: function _(e, t, r) {
          "use strict";

          r(8698), Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.chooseMethod = function (e) {
            var t = [].concat(e.methods, a).filter(Boolean);
            if (e.type) {
              if ("simulate" === e.type) return s.SimulateMethod;
              var r = t.find(function (t) {
                return t.type === e.type;
              });
              if (r) return r;
              throw new Error("method-type " + e.type + " not found");
            }
            e.webWorkerSupport || (t = t.filter(function (e) {
              return "idb" !== e.type;
            }));
            var n = t.find(function (e) {
              return e.canBeUsed();
            });
            if (n) return n;
            throw new Error("No usable method found in " + JSON.stringify(a.map(function (e) {
              return e.type;
            })));
          };
          var n = r(6115),
            o = r(9122),
            i = r(4924),
            s = r(1574),
            a = [n.NativeMethod, o.IndexedDBMethod, i.LocalstorageMethod];
        },
        9122: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.TRANSACTION_SETTINGS = t.IndexedDBMethod = void 0, t.averageResponseTime = E, t.canBeUsed = O, t.cleanOldMessages = g, t.close = S, t.commitIndexedDBTransaction = l, t.create = v, t.createDatabase = d, t.getAllMessages = function (e) {
            var t = e.transaction(a, "readonly", c),
              r = t.objectStore(a),
              n = [];
            return new Promise(function (e) {
              r.openCursor().onsuccess = function (r) {
                var o = r.target.result;
                o ? (n.push(o.value), o.continue()) : (l(t), e(n));
              };
            });
          }, t.getIdb = u, t.getMessagesHigherThan = p, t.getOldMessages = y, t.microSeconds = void 0, t.onMessage = _, t.postMessage = w, t.removeMessagesById = h, t.type = void 0, t.writeMessage = f;
          var n = r(6202),
            o = r(2151),
            i = r(423),
            s = n.microSeconds;
          t.microSeconds = s;
          var a = "messages",
            c = {
              durability: "relaxed"
            };
          function u() {
            if ("undefined" != typeof indexedDB) return indexedDB;
            if ("undefined" != typeof window) {
              if (void 0 !== window.mozIndexedDB) return window.mozIndexedDB;
              if (void 0 !== window.webkitIndexedDB) return window.webkitIndexedDB;
              if (void 0 !== window.msIndexedDB) return window.msIndexedDB;
            }
            return !1;
          }
          function l(e) {
            e.commit && e.commit();
          }
          function d(e) {
            var t = "pubkey.broadcast-channel-0-" + e,
              r = u().open(t);
            return r.onupgradeneeded = function (e) {
              e.target.result.createObjectStore(a, {
                keyPath: "id",
                autoIncrement: !0
              });
            }, new Promise(function (e, t) {
              r.onerror = function (e) {
                return t(e);
              }, r.onsuccess = function () {
                e(r.result);
              };
            });
          }
          function f(e, t, r) {
            var n = {
                uuid: t,
                time: new Date().getTime(),
                data: r
              },
              o = e.transaction([a], "readwrite", c);
            return new Promise(function (e, t) {
              o.oncomplete = function () {
                return e();
              }, o.onerror = function (e) {
                return t(e);
              }, o.objectStore(a).add(n), l(o);
            });
          }
          function p(e, t) {
            var r = e.transaction(a, "readonly", c),
              n = r.objectStore(a),
              o = [],
              i = IDBKeyRange.bound(t + 1, 1 / 0);
            if (n.getAll) {
              var s = n.getAll(i);
              return new Promise(function (e, t) {
                s.onerror = function (e) {
                  return t(e);
                }, s.onsuccess = function (t) {
                  e(t.target.result);
                };
              });
            }
            return new Promise(function (e, s) {
              var a = function () {
                try {
                  return i = IDBKeyRange.bound(t + 1, 1 / 0), n.openCursor(i);
                } catch (e) {
                  return n.openCursor();
                }
              }();
              a.onerror = function (e) {
                return s(e);
              }, a.onsuccess = function (n) {
                var i = n.target.result;
                i ? i.value.id < t + 1 ? i.continue(t + 1) : (o.push(i.value), i.continue()) : (l(r), e(o));
              };
            });
          }
          function h(e, t) {
            if (e.closed) return Promise.resolve([]);
            var r = e.db.transaction(a, "readwrite", c).objectStore(a);
            return Promise.all(t.map(function (e) {
              var t = r.delete(e);
              return new Promise(function (e) {
                t.onsuccess = function () {
                  return e();
                };
              });
            }));
          }
          function y(e, t) {
            var r = new Date().getTime() - t,
              n = e.transaction(a, "readonly", c),
              o = n.objectStore(a),
              i = [];
            return new Promise(function (e) {
              o.openCursor().onsuccess = function (t) {
                var o = t.target.result;
                if (o) {
                  var s = o.value;
                  s.time < r ? (i.push(s), o.continue()) : (l(n), e(i));
                } else e(i);
              };
            });
          }
          function g(e) {
            return y(e.db, e.options.idb.ttl).then(function (t) {
              return h(e, t.map(function (e) {
                return e.id;
              }));
            });
          }
          function v(e, t) {
            return t = (0, i.fillOptionsWithDefaults)(t), d(e).then(function (r) {
              var i = {
                closed: !1,
                lastCursorId: 0,
                channelName: e,
                options: t,
                uuid: (0, n.randomToken)(),
                eMIs: new o.ObliviousSet(2 * t.idb.ttl),
                writeBlockPromise: n.PROMISE_RESOLVED_VOID,
                messagesCallback: null,
                readQueuePromises: [],
                db: r
              };
              return r.onclose = function () {
                i.closed = !0, t.idb.onclose && t.idb.onclose();
              }, b(i), i;
            });
          }
          function b(e) {
            e.closed || m(e).then(function () {
              return (0, n.sleep)(e.options.idb.fallbackInterval);
            }).then(function () {
              return b(e);
            });
          }
          function m(e) {
            return e.closed ? n.PROMISE_RESOLVED_VOID : e.messagesCallback ? p(e.db, e.lastCursorId).then(function (t) {
              var r = t.filter(function (e) {
                return !!e;
              }).map(function (t) {
                return t.id > e.lastCursorId && (e.lastCursorId = t.id), t;
              }).filter(function (t) {
                return function (e, t) {
                  return !(e.uuid === t.uuid || t.eMIs.has(e.id) || e.data.time < t.messagesCallbackTime);
                }(t, e);
              }).sort(function (e, t) {
                return e.time - t.time;
              });
              return r.forEach(function (t) {
                e.messagesCallback && (e.eMIs.add(t.id), e.messagesCallback(t.data));
              }), n.PROMISE_RESOLVED_VOID;
            }) : n.PROMISE_RESOLVED_VOID;
          }
          function S(e) {
            e.closed = !0, e.db.close();
          }
          function w(e, t) {
            return e.writeBlockPromise = e.writeBlockPromise.then(function () {
              return f(e.db, e.uuid, t);
            }).then(function () {
              0 === (0, n.randomInt)(0, 10) && g(e);
            }), e.writeBlockPromise;
          }
          function _(e, t, r) {
            e.messagesCallbackTime = r, e.messagesCallback = t, m(e);
          }
          function O() {
            return !!u();
          }
          function E(e) {
            return 2 * e.idb.fallbackInterval;
          }
          t.TRANSACTION_SETTINGS = c, t.type = "idb";
          var P = {
            create: v,
            close: S,
            onMessage: _,
            postMessage: w,
            canBeUsed: O,
            type: "idb",
            averageResponseTime: E,
            microSeconds: s
          };
          t.IndexedDBMethod = P;
        },
        4924: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.LocalstorageMethod = void 0, t.addStorageEventListener = d, t.averageResponseTime = v, t.canBeUsed = g, t.close = h, t.create = p, t.getLocalStorage = c, t.microSeconds = void 0, t.onMessage = y, t.postMessage = l, t.removeStorageEventListener = f, t.storageKey = u, t.type = void 0;
          var n = r(2151),
            o = r(423),
            i = r(6202),
            s = i.microSeconds;
          t.microSeconds = s;
          var a = "localstorage";
          function c() {
            var e;
            if ("undefined" == typeof window) return null;
            try {
              e = window.localStorage, e = window["ie8-eventlistener/storage"] || window.localStorage;
            } catch (e) {}
            return e;
          }
          function u(e) {
            return "pubkey.broadcastChannel-" + e;
          }
          function l(e, t) {
            return new Promise(function (r) {
              (0, i.sleep)().then(function () {
                var n = u(e.channelName),
                  o = {
                    token: (0, i.randomToken)(),
                    time: new Date().getTime(),
                    data: t,
                    uuid: e.uuid
                  },
                  s = JSON.stringify(o);
                c().setItem(n, s);
                var a = document.createEvent("Event");
                a.initEvent("storage", !0, !0), a.key = n, a.newValue = s, window.dispatchEvent(a), r();
              });
            });
          }
          function d(e, t) {
            var r = u(e),
              n = function n(e) {
                e.key === r && t(JSON.parse(e.newValue));
              };
            return window.addEventListener("storage", n), n;
          }
          function f(e) {
            window.removeEventListener("storage", e);
          }
          function p(e, t) {
            if (t = (0, o.fillOptionsWithDefaults)(t), !g()) throw new Error("BroadcastChannel: localstorage cannot be used");
            var r = (0, i.randomToken)(),
              s = new n.ObliviousSet(t.localstorage.removeTimeout),
              a = {
                channelName: e,
                uuid: r,
                eMIs: s
              };
            return a.listener = d(e, function (e) {
              a.messagesCallback && e.uuid !== r && e.token && !s.has(e.token) && (e.data.time && e.data.time < a.messagesCallbackTime || (s.add(e.token), a.messagesCallback(e.data)));
            }), a;
          }
          function h(e) {
            f(e.listener);
          }
          function y(e, t, r) {
            e.messagesCallbackTime = r, e.messagesCallback = t;
          }
          function g() {
            var e = c();
            if (!e) return !1;
            try {
              var t = "__broadcastchannel_check";
              e.setItem(t, "works"), e.removeItem(t);
            } catch (e) {
              return !1;
            }
            return !0;
          }
          function v() {
            var e = navigator.userAgent.toLowerCase();
            return e.includes("safari") && !e.includes("chrome") ? 240 : 120;
          }
          t.type = a;
          var b = {
            create: p,
            close: h,
            onMessage: y,
            postMessage: l,
            canBeUsed: g,
            type: a,
            averageResponseTime: v,
            microSeconds: s
          };
          t.LocalstorageMethod = b;
        },
        6115: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.NativeMethod = void 0, t.averageResponseTime = d, t.canBeUsed = l, t.close = a, t.create = s, t.microSeconds = void 0, t.onMessage = u, t.postMessage = c, t.type = void 0;
          var n = r(6202),
            o = n.microSeconds;
          t.microSeconds = o;
          var i = "native";
          function s(e) {
            var t = {
              messagesCallback: null,
              bc: new BroadcastChannel(e),
              subFns: []
            };
            return t.bc.onmessage = function (e) {
              t.messagesCallback && t.messagesCallback(e.data);
            }, t;
          }
          function a(e) {
            e.bc.close(), e.subFns = [];
          }
          function c(e, t) {
            try {
              return e.bc.postMessage(t, !1), n.PROMISE_RESOLVED_VOID;
            } catch (e) {
              return Promise.reject(e);
            }
          }
          function u(e, t) {
            e.messagesCallback = t;
          }
          function l() {
            if ("undefined" == typeof window) return !1;
            if ("function" == typeof BroadcastChannel) {
              if (BroadcastChannel._pubkey) throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
              return !0;
            }
            return !1;
          }
          function d() {
            return 150;
          }
          t.type = i;
          var f = {
            create: s,
            close: a,
            onMessage: u,
            postMessage: c,
            canBeUsed: l,
            type: i,
            averageResponseTime: d,
            microSeconds: o
          };
          t.NativeMethod = f;
        },
        1574: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.SimulateMethod = void 0, t.averageResponseTime = d, t.canBeUsed = l, t.close = a, t.create = s, t.microSeconds = void 0, t.onMessage = u, t.postMessage = c, t.type = void 0;
          var n = r(6202).microSeconds;
          t.microSeconds = n;
          var o = "simulate";
          t.type = o;
          var i = new Set();
          function s(e) {
            var t = {
              name: e,
              messagesCallback: null
            };
            return i.add(t), t;
          }
          function a(e) {
            i.delete(e);
          }
          function c(e, t) {
            return new Promise(function (r) {
              return setTimeout(function () {
                Array.from(i).filter(function (t) {
                  return t.name === e.name;
                }).filter(function (t) {
                  return t !== e;
                }).filter(function (e) {
                  return !!e.messagesCallback;
                }).forEach(function (e) {
                  return e.messagesCallback(t);
                }), r();
              }, 5);
            });
          }
          function u(e, t) {
            e.messagesCallback = t;
          }
          function l() {
            return !0;
          }
          function d() {
            return 5;
          }
          var f = {
            create: s,
            close: a,
            onMessage: u,
            postMessage: c,
            canBeUsed: l,
            type: o,
            averageResponseTime: d,
            microSeconds: n
          };
          t.SimulateMethod = f;
        },
        423: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.fillOptionsWithDefaults = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = JSON.parse(JSON.stringify(e));
            return void 0 === t.webWorkerSupport && (t.webWorkerSupport = !0), t.idb || (t.idb = {}), t.idb.ttl || (t.idb.ttl = 45e3), t.idb.fallbackInterval || (t.idb.fallbackInterval = 150), e.idb && "function" == typeof e.idb.onclose && (t.idb.onclose = e.idb.onclose), t.localstorage || (t.localstorage = {}), t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 6e4), e.methods && (t.methods = e.methods), t.node || (t.node = {}), t.node.ttl || (t.node.ttl = 12e4), t.node.maxParallelWrites || (t.node.maxParallelWrites = 2048), void 0 === t.node.useFastPath && (t.node.useFastPath = !0), t;
          };
        },
        6202: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.PROMISE_RESOLVED_VOID = t.PROMISE_RESOLVED_TRUE = t.PROMISE_RESOLVED_FALSE = void 0, t.isPromise = function (e) {
            return e && "function" == typeof e.then;
          }, t.microSeconds = function () {
            var e = new Date().getTime();
            return e === i ? 1e3 * e + ++s : (i = e, s = 0, 1e3 * e);
          }, t.randomInt = function (e, t) {
            return Math.floor(Math.random() * (t - e + 1) + e);
          }, t.randomToken = function () {
            return Math.random().toString(36).substring(2);
          }, t.sleep = function (e, t) {
            return e || (e = 0), new Promise(function (r) {
              return setTimeout(function () {
                return r(t);
              }, e);
            });
          };
          var r = Promise.resolve(!1);
          t.PROMISE_RESOLVED_FALSE = r;
          var n = Promise.resolve(!0);
          t.PROMISE_RESOLVED_TRUE = n;
          var o = Promise.resolve();
          t.PROMISE_RESOLVED_VOID = o;
          var i = 0,
            s = 0;
        },
        1924: function _(e, t, r) {
          "use strict";

          var n = r(210),
            o = r(5559),
            i = o(n("String.prototype.indexOf"));
          e.exports = function (e, t) {
            var r = n(e, !!t);
            return "function" == typeof r && i(e, ".prototype.") > -1 ? o(r) : r;
          };
        },
        5559: function _(e, t, r) {
          "use strict";

          var n = r(8612),
            o = r(210),
            i = o("%Function.prototype.apply%"),
            s = o("%Function.prototype.call%"),
            a = o("%Reflect.apply%", !0) || n.call(s, i),
            c = o("%Object.getOwnPropertyDescriptor%", !0),
            u = o("%Object.defineProperty%", !0),
            l = o("%Math.max%");
          if (u) try {
            u({}, "a", {
              value: 1
            });
          } catch (e) {
            u = null;
          }
          e.exports = function (e) {
            var t = a(n, s, arguments);
            if (c && u) {
              var r = c(t, "length");
              r.configurable && u(t, "length", {
                value: 1 + l(0, e.length - (arguments.length - 1))
              });
            }
            return t;
          };
          var d = function d() {
            return a(n, i, arguments);
          };
          u ? u(e.exports, "apply", {
            value: d
          }) : e.exports.apply = d;
        },
        5415: function _(e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            default: function _default() {
              return a;
            }
          });
          var n = r(8081),
            o = r.n(n),
            i = r(3645),
            s = r.n(i)()(o());
          s.push([e.id, '*{box-sizing:border-box}.bf-backdrop{position:fixed;top:0;left:0;width:100%;height:100%;z-index:var(--bf-z-index, 9999);background:var(--bf-backdrop-bg, rgba(0, 0, 0, 0.5))}.bf-modal{position:fixed;left:50%;top:50%;z-index:calc(var(--bf-z-index, 9999) + 1);width:500px;max-width:calc(100% - 32px);height:400px;max-height:calc(100% - 64px);transform:translate(-50%, -50%);box-shadow:var(--bf-modal-shadow, 0px 4px 12px 0px rgba(0, 0, 0, 0.25));border-radius:var(--bf-border-radius, 4px);background:#fff}.bf-modal *{font-family:var(--bf-font, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol");outline:none;font-weight:normal;color:var(--bf-color, #222)}.bf-modal__title{margin:0 0 16px;width:calc(100% - 24px);font-weight:bold;line-height:1.3;font-family:var(--bf-font-heading, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol");font-size:18px}.bf-modal__hint{margin:-8px 0 20px;line-height:1.25}.bf-modal__hint--hidden{display:none}.bf-modal__content{position:absolute;top:0;bottom:0;left:0;right:0;overflow-y:auto;display:flex;flex-direction:column;padding:24px}.bf-modal__close{position:absolute;z-index:1;top:0px;right:0px;width:40px;height:40px;display:flex;align-items:center;justify-content:center;border:0;background:none;padding:0;font-size:20px;cursor:pointer}.bf-modal__close:active{transform:scale(0.85)}.bf-modal__subject,.bf-modal__feedback{margin-bottom:16px;font-size:16px;padding:8px;border:var(--bf-input-border, 1px solid #ccc);border-radius:var(--bf-border-radius, 4px)}.bf-modal__subject::placeholder,.bf-modal__feedback::placeholder{color:var(--bf-placeholder-color, #757575)}.bf-modal__subject{min-height:32px}.bf-modal__feedback{flex-grow:1;resize:none;min-height:64px}.bf-modal__submit{width:100%;background-color:var(--bf-submit-bg, #ff5060);box-shadow:var(--bf-submit-shadow, 0 2px 0 0 #a93e48);border:0;border-radius:var(--bf-border-radius, 4px);padding:8px 0;color:var(--bf-submit-color, #fff);font-size:18px;cursor:pointer}.bf-modal__submit:active{transform:translateY(2px);box-shadow:none}', ""]);
          var a = s;
        },
        3645: function _(e) {
          "use strict";

          e.exports = function (e) {
            var t = [];
            return t.toString = function () {
              return this.map(function (t) {
                var r = "",
                  n = void 0 !== t[5];
                return t[4] && (r += "@supports (".concat(t[4], ") {")), t[2] && (r += "@media ".concat(t[2], " {")), n && (r += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), r += e(t), n && (r += "}"), t[2] && (r += "}"), t[4] && (r += "}"), r;
              }).join("");
            }, t.i = function (e, r, n, o, i) {
              "string" == typeof e && (e = [[null, e, void 0]]);
              var s = {};
              if (n) for (var a = 0; a < this.length; a++) {
                var c = this[a][0];
                null != c && (s[c] = !0);
              }
              for (var u = 0; u < e.length; u++) {
                var l = [].concat(e[u]);
                n && s[l[0]] || (void 0 !== i && (void 0 === l[5] || (l[1] = "@layer".concat(l[5].length > 0 ? " ".concat(l[5]) : "", " {").concat(l[1], "}")), l[5] = i), r && (l[2] ? (l[1] = "@media ".concat(l[2], " {").concat(l[1], "}"), l[2] = r) : l[2] = r), o && (l[4] ? (l[1] = "@supports (".concat(l[4], ") {").concat(l[1], "}"), l[4] = o) : l[4] = "".concat(o)), t.push(l));
              }
            }, t;
          };
        },
        8081: function _(e) {
          "use strict";

          e.exports = function (e) {
            return e[1];
          };
        },
        9180: function _(e, t, r) {
          var n, o, i;
          !function (s, a) {
            "use strict";

            o = [r(9829)], void 0 === (i = "function" == typeof (n = function n(e) {
              var t = /(^|@)\S+:\d+/,
                r = /^\s*at .*(\S+:\d+|\(native\))/m,
                n = /^(eval@)?(\[native code])?$/;
              return {
                parse: function parse(e) {
                  if (void 0 !== e.stacktrace || void 0 !== e["opera#sourceloc"]) return this.parseOpera(e);
                  if (e.stack && e.stack.match(r)) return this.parseV8OrIE(e);
                  if (e.stack) return this.parseFFOrSafari(e);
                  throw new Error("Cannot parse given Error object");
                },
                extractLocation: function extractLocation(e) {
                  if (-1 === e.indexOf(":")) return [e];
                  var t = /(.+?)(?::(\d+))?(?::(\d+))?$/.exec(e.replace(/[()]/g, ""));
                  return [t[1], t[2] || void 0, t[3] || void 0];
                },
                parseV8OrIE: function parseV8OrIE(t) {
                  return t.stack.split("\n").filter(function (e) {
                    return !!e.match(r);
                  }, this).map(function (t) {
                    t.indexOf("(eval ") > -1 && (t = t.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(,.*$)/g, ""));
                    var r = t.replace(/^\s+/, "").replace(/\(eval code/g, "(").replace(/^.*?\s+/, ""),
                      n = r.match(/ (\(.+\)$)/);
                    r = n ? r.replace(n[0], "") : r;
                    var o = this.extractLocation(n ? n[1] : r),
                      i = n && r || void 0,
                      s = ["eval", "<anonymous>"].indexOf(o[0]) > -1 ? void 0 : o[0];
                    return new e({
                      functionName: i,
                      fileName: s,
                      lineNumber: o[1],
                      columnNumber: o[2],
                      source: t
                    });
                  }, this);
                },
                parseFFOrSafari: function parseFFOrSafari(t) {
                  return t.stack.split("\n").filter(function (e) {
                    return !e.match(n);
                  }, this).map(function (t) {
                    if (t.indexOf(" > eval") > -1 && (t = t.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), -1 === t.indexOf("@") && -1 === t.indexOf(":")) return new e({
                      functionName: t
                    });
                    var r = /((.*".+"[^@]*)?[^@]*)(?:@)/,
                      n = t.match(r),
                      o = n && n[1] ? n[1] : void 0,
                      i = this.extractLocation(t.replace(r, ""));
                    return new e({
                      functionName: o,
                      fileName: i[0],
                      lineNumber: i[1],
                      columnNumber: i[2],
                      source: t
                    });
                  }, this);
                },
                parseOpera: function parseOpera(e) {
                  return !e.stacktrace || e.message.indexOf("\n") > -1 && e.message.split("\n").length > e.stacktrace.split("\n").length ? this.parseOpera9(e) : e.stack ? this.parseOpera11(e) : this.parseOpera10(e);
                },
                parseOpera9: function parseOpera9(t) {
                  for (var r = /Line (\d+).*script (?:in )?(\S+)/i, n = t.message.split("\n"), o = [], i = 2, s = n.length; i < s; i += 2) {
                    var a = r.exec(n[i]);
                    a && o.push(new e({
                      fileName: a[2],
                      lineNumber: a[1],
                      source: n[i]
                    }));
                  }
                  return o;
                },
                parseOpera10: function parseOpera10(t) {
                  for (var r = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, n = t.stacktrace.split("\n"), o = [], i = 0, s = n.length; i < s; i += 2) {
                    var a = r.exec(n[i]);
                    a && o.push(new e({
                      functionName: a[3] || void 0,
                      fileName: a[2],
                      lineNumber: a[1],
                      source: n[i]
                    }));
                  }
                  return o;
                },
                parseOpera11: function parseOpera11(r) {
                  return r.stack.split("\n").filter(function (e) {
                    return !!e.match(t) && !e.match(/^Error created at/);
                  }, this).map(function (t) {
                    var r,
                      n = t.split("@"),
                      o = this.extractLocation(n.pop()),
                      i = n.shift() || "",
                      s = i.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0;
                    i.match(/\(([^)]*)\)/) && (r = i.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
                    var a = void 0 === r || "[arguments not available]" === r ? void 0 : r.split(",");
                    return new e({
                      functionName: s,
                      args: a,
                      fileName: o[0],
                      lineNumber: o[1],
                      columnNumber: o[2],
                      source: t
                    });
                  }, this);
                }
              };
            }) ? n.apply(t, o) : n) || (e.exports = i);
          }();
        },
        9804: function _(e) {
          var t = Object.prototype.hasOwnProperty,
            r = Object.prototype.toString;
          e.exports = function (e, n, o) {
            if ("[object Function]" !== r.call(n)) throw new TypeError("iterator must be a function");
            var i = e.length;
            if (i === +i) for (var s = 0; s < i; s++) {
              n.call(o, e[s], s, e);
            } else for (var a in e) {
              t.call(e, a) && n.call(o, e[a], a, e);
            }
          };
        },
        7648: function _(e) {
          "use strict";

          var t = "Function.prototype.bind called on incompatible ",
            r = Array.prototype.slice,
            n = Object.prototype.toString,
            o = "[object Function]";
          e.exports = function (e) {
            var i = this;
            if ("function" != typeof i || n.call(i) !== o) throw new TypeError(t + i);
            for (var s, a = r.call(arguments, 1), c = function c() {
                if (this instanceof s) {
                  var t = i.apply(this, a.concat(r.call(arguments)));
                  return Object(t) === t ? t : this;
                }
                return i.apply(e, a.concat(r.call(arguments)));
              }, u = Math.max(0, i.length - a.length), l = [], d = 0; d < u; d++) {
              l.push("$" + d);
            }
            if (s = Function("binder", "return function (" + l.join(",") + "){ return binder.apply(this,arguments); }")(c), i.prototype) {
              var f = function f() {};
              f.prototype = i.prototype, s.prototype = new f(), f.prototype = null;
            }
            return s;
          };
        },
        8612: function _(e, t, r) {
          "use strict";

          var n = r(7648);
          e.exports = Function.prototype.bind || n;
        },
        210: function _(e, t, r) {
          "use strict";

          var n,
            o = SyntaxError,
            i = Function,
            s = TypeError,
            a = function a(e) {
              try {
                return i('"use strict"; return (' + e + ").constructor;")();
              } catch (e) {}
            },
            c = Object.getOwnPropertyDescriptor;
          if (c) try {
            c({}, "");
          } catch (e) {
            c = null;
          }
          var u = function u() {
              throw new s();
            },
            l = c ? function () {
              try {
                return u;
              } catch (e) {
                try {
                  return c(arguments, "callee").get;
                } catch (e) {
                  return u;
                }
              }
            }() : u,
            d = r(1405)(),
            f = Object.getPrototypeOf || function (e) {
              return e.__proto__;
            },
            p = {},
            h = "undefined" == typeof Uint8Array ? n : f(Uint8Array),
            y = {
              "%AggregateError%": "undefined" == typeof AggregateError ? n : AggregateError,
              "%Array%": Array,
              "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n : ArrayBuffer,
              "%ArrayIteratorPrototype%": d ? f([][Symbol.iterator]()) : n,
              "%AsyncFromSyncIteratorPrototype%": n,
              "%AsyncFunction%": p,
              "%AsyncGenerator%": p,
              "%AsyncGeneratorFunction%": p,
              "%AsyncIteratorPrototype%": p,
              "%Atomics%": "undefined" == typeof Atomics ? n : Atomics,
              "%BigInt%": "undefined" == typeof BigInt ? n : BigInt,
              "%Boolean%": Boolean,
              "%DataView%": "undefined" == typeof DataView ? n : DataView,
              "%Date%": Date,
              "%decodeURI%": decodeURI,
              "%decodeURIComponent%": decodeURIComponent,
              "%encodeURI%": encodeURI,
              "%encodeURIComponent%": encodeURIComponent,
              "%Error%": Error,
              "%eval%": eval,
              "%EvalError%": EvalError,
              "%Float32Array%": "undefined" == typeof Float32Array ? n : Float32Array,
              "%Float64Array%": "undefined" == typeof Float64Array ? n : Float64Array,
              "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n : FinalizationRegistry,
              "%Function%": i,
              "%GeneratorFunction%": p,
              "%Int8Array%": "undefined" == typeof Int8Array ? n : Int8Array,
              "%Int16Array%": "undefined" == typeof Int16Array ? n : Int16Array,
              "%Int32Array%": "undefined" == typeof Int32Array ? n : Int32Array,
              "%isFinite%": isFinite,
              "%isNaN%": isNaN,
              "%IteratorPrototype%": d ? f(f([][Symbol.iterator]())) : n,
              "%JSON%": "object" == (typeof JSON === "undefined" ? "undefined" : _typeof(JSON)) ? JSON : n,
              "%Map%": "undefined" == typeof Map ? n : Map,
              "%MapIteratorPrototype%": "undefined" != typeof Map && d ? f(new Map()[Symbol.iterator]()) : n,
              "%Math%": Math,
              "%Number%": Number,
              "%Object%": Object,
              "%parseFloat%": parseFloat,
              "%parseInt%": parseInt,
              "%Promise%": "undefined" == typeof Promise ? n : Promise,
              "%Proxy%": "undefined" == typeof Proxy ? n : Proxy,
              "%RangeError%": RangeError,
              "%ReferenceError%": ReferenceError,
              "%Reflect%": "undefined" == typeof Reflect ? n : Reflect,
              "%RegExp%": RegExp,
              "%Set%": "undefined" == typeof Set ? n : Set,
              "%SetIteratorPrototype%": "undefined" != typeof Set && d ? f(new Set()[Symbol.iterator]()) : n,
              "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n : SharedArrayBuffer,
              "%String%": String,
              "%StringIteratorPrototype%": d ? f(""[Symbol.iterator]()) : n,
              "%Symbol%": d ? Symbol : n,
              "%SyntaxError%": o,
              "%ThrowTypeError%": l,
              "%TypedArray%": h,
              "%TypeError%": s,
              "%Uint8Array%": "undefined" == typeof Uint8Array ? n : Uint8Array,
              "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n : Uint8ClampedArray,
              "%Uint16Array%": "undefined" == typeof Uint16Array ? n : Uint16Array,
              "%Uint32Array%": "undefined" == typeof Uint32Array ? n : Uint32Array,
              "%URIError%": URIError,
              "%WeakMap%": "undefined" == typeof WeakMap ? n : WeakMap,
              "%WeakRef%": "undefined" == typeof WeakRef ? n : WeakRef,
              "%WeakSet%": "undefined" == typeof WeakSet ? n : WeakSet
            },
            g = function e(t) {
              var r;
              if ("%AsyncFunction%" === t) r = a("async function () {}");else if ("%GeneratorFunction%" === t) r = a("function* () {}");else if ("%AsyncGeneratorFunction%" === t) r = a("async function* () {}");else if ("%AsyncGenerator%" === t) {
                var n = e("%AsyncGeneratorFunction%");
                n && (r = n.prototype);
              } else if ("%AsyncIteratorPrototype%" === t) {
                var o = e("%AsyncGenerator%");
                o && (r = f(o.prototype));
              }
              return y[t] = r, r;
            },
            v = {
              "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
              "%ArrayPrototype%": ["Array", "prototype"],
              "%ArrayProto_entries%": ["Array", "prototype", "entries"],
              "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
              "%ArrayProto_keys%": ["Array", "prototype", "keys"],
              "%ArrayProto_values%": ["Array", "prototype", "values"],
              "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
              "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
              "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
              "%BooleanPrototype%": ["Boolean", "prototype"],
              "%DataViewPrototype%": ["DataView", "prototype"],
              "%DatePrototype%": ["Date", "prototype"],
              "%ErrorPrototype%": ["Error", "prototype"],
              "%EvalErrorPrototype%": ["EvalError", "prototype"],
              "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
              "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
              "%FunctionPrototype%": ["Function", "prototype"],
              "%Generator%": ["GeneratorFunction", "prototype"],
              "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
              "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
              "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
              "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
              "%JSONParse%": ["JSON", "parse"],
              "%JSONStringify%": ["JSON", "stringify"],
              "%MapPrototype%": ["Map", "prototype"],
              "%NumberPrototype%": ["Number", "prototype"],
              "%ObjectPrototype%": ["Object", "prototype"],
              "%ObjProto_toString%": ["Object", "prototype", "toString"],
              "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
              "%PromisePrototype%": ["Promise", "prototype"],
              "%PromiseProto_then%": ["Promise", "prototype", "then"],
              "%Promise_all%": ["Promise", "all"],
              "%Promise_reject%": ["Promise", "reject"],
              "%Promise_resolve%": ["Promise", "resolve"],
              "%RangeErrorPrototype%": ["RangeError", "prototype"],
              "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
              "%RegExpPrototype%": ["RegExp", "prototype"],
              "%SetPrototype%": ["Set", "prototype"],
              "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
              "%StringPrototype%": ["String", "prototype"],
              "%SymbolPrototype%": ["Symbol", "prototype"],
              "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
              "%TypedArrayPrototype%": ["TypedArray", "prototype"],
              "%TypeErrorPrototype%": ["TypeError", "prototype"],
              "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
              "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
              "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
              "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
              "%URIErrorPrototype%": ["URIError", "prototype"],
              "%WeakMapPrototype%": ["WeakMap", "prototype"],
              "%WeakSetPrototype%": ["WeakSet", "prototype"]
            },
            b = r(8612),
            m = r(7642),
            S = b.call(Function.call, Array.prototype.concat),
            w = b.call(Function.apply, Array.prototype.splice),
            _ = b.call(Function.call, String.prototype.replace),
            O = b.call(Function.call, String.prototype.slice),
            E = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
            P = /\\(\\)?/g,
            A = function A(e) {
              var t = O(e, 0, 1),
                r = O(e, -1);
              if ("%" === t && "%" !== r) throw new o("invalid intrinsic syntax, expected closing `%`");
              if ("%" === r && "%" !== t) throw new o("invalid intrinsic syntax, expected opening `%`");
              var n = [];
              return _(e, E, function (e, t, r, o) {
                n[n.length] = r ? _(o, P, "$1") : t || e;
              }), n;
            },
            I = function I(e, t) {
              var r,
                n = e;
              if (m(v, n) && (n = "%" + (r = v[n])[0] + "%"), m(y, n)) {
                var i = y[n];
                if (i === p && (i = g(n)), void 0 === i && !t) throw new s("intrinsic " + e + " exists, but is not available. Please file an issue!");
                return {
                  alias: r,
                  name: n,
                  value: i
                };
              }
              throw new o("intrinsic " + e + " does not exist!");
            };
          e.exports = function (e, t) {
            if ("string" != typeof e || 0 === e.length) throw new s("intrinsic name must be a non-empty string");
            if (arguments.length > 1 && "boolean" != typeof t) throw new s('"allowMissing" argument must be a boolean');
            var r = A(e),
              n = r.length > 0 ? r[0] : "",
              i = I("%" + n + "%", t),
              a = i.name,
              u = i.value,
              l = !1,
              d = i.alias;
            d && (n = d[0], w(r, S([0, 1], d)));
            for (var f = 1, p = !0; f < r.length; f += 1) {
              var h = r[f],
                g = O(h, 0, 1),
                v = O(h, -1);
              if (('"' === g || "'" === g || "`" === g || '"' === v || "'" === v || "`" === v) && g !== v) throw new o("property names with quotes must have matching quotes");
              if ("constructor" !== h && p || (l = !0), m(y, a = "%" + (n += "." + h) + "%")) u = y[a];else if (null != u) {
                if (!(h in u)) {
                  if (!t) throw new s("base intrinsic for " + e + " exists, but the property is not available.");
                  return;
                }
                if (c && f + 1 >= r.length) {
                  var b = c(u, h);
                  u = (p = !!b) && "get" in b && !("originalValue" in b.get) ? b.get : u[h];
                } else p = m(u, h), u = u[h];
                p && !l && (y[a] = u);
              }
            }
            return u;
          };
        },
        1405: function _(e, t, r) {
          "use strict";

          var n = r.g.Symbol,
            o = r(5419);
          e.exports = function () {
            return "function" == typeof n && "function" == typeof Symbol && "symbol" == _typeof(n("foo")) && "symbol" == _typeof(Symbol("bar")) && o();
          };
        },
        5419: function _(e) {
          "use strict";

          e.exports = function () {
            if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
            if ("symbol" == _typeof(Symbol.iterator)) return !0;
            var e = {},
              t = Symbol("test"),
              r = Object(t);
            if ("string" == typeof t) return !1;
            if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
            if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
            for (t in e[t] = 42, e) {
              return !1;
            }
            if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
            if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
            var n = Object.getOwnPropertySymbols(e);
            if (1 !== n.length || n[0] !== t) return !1;
            if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
            if ("function" == typeof Object.getOwnPropertyDescriptor) {
              var o = Object.getOwnPropertyDescriptor(e, t);
              if (42 !== o.value || !0 !== o.enumerable) return !1;
            }
            return !0;
          };
        },
        9608: function _(e) {
          "use strict";

          e.exports = function () {
            if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return !1;
            if ("symbol" == _typeof(Symbol.iterator)) return !0;
            var e = {},
              t = Symbol("test"),
              r = Object(t);
            if ("string" == typeof t) return !1;
            if ("[object Symbol]" !== Object.prototype.toString.call(t)) return !1;
            if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;
            for (t in e[t] = 42, e) {
              return !1;
            }
            if ("function" == typeof Object.keys && 0 !== Object.keys(e).length) return !1;
            if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e).length) return !1;
            var n = Object.getOwnPropertySymbols(e);
            if (1 !== n.length || n[0] !== t) return !1;
            if (!Object.prototype.propertyIsEnumerable.call(e, t)) return !1;
            if ("function" == typeof Object.getOwnPropertyDescriptor) {
              var o = Object.getOwnPropertyDescriptor(e, t);
              if (42 !== o.value || !0 !== o.enumerable) return !1;
            }
            return !0;
          };
        },
        6410: function _(e, t, r) {
          "use strict";

          var n = r(9608);
          e.exports = function () {
            return n() && !!Symbol.toStringTag;
          };
        },
        7642: function _(e, t, r) {
          "use strict";

          var n = r(8612);
          e.exports = n.call(Function.call, Object.prototype.hasOwnProperty);
        },
        3584: function _(e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            default: function _default() {
              return n;
            }
          });
          var n = '<div class="bf-backdrop" data-bf-backdrop></div> <div class="bf-modal"> <button class="bf-modal__close" data-bf-close>&times;</button> <form class="bf-modal__content" data-bf-form> <h3 class="bf-modal__title" data-bf-title></h3> <p class="bf-modal__hint bf-modal__hint--hidden" data-bf-hint></p> <input class="bf-modal__subject" data-bf-subject type="text" required> <textarea class="bf-modal__feedback" data-bf-feedback required></textarea> <button class="bf-modal__submit" data-bf-submit></button> </form> </div> ';
        },
        5717: function _(e) {
          "function" == typeof Object.create ? e.exports = function (e, t) {
            t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }));
          } : e.exports = function (e, t) {
            if (t) {
              e.super_ = t;
              var r = function r() {};
              r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
            }
          };
        },
        2584: function _(e, t, r) {
          "use strict";

          var n = r(6410)(),
            o = r(1924)("Object.prototype.toString"),
            i = function i(e) {
              return !(n && e && "object" == _typeof(e) && Symbol.toStringTag in e) && "[object Arguments]" === o(e);
            },
            s = function s(e) {
              return !!i(e) || null !== e && "object" == _typeof(e) && "number" == typeof e.length && e.length >= 0 && "[object Array]" !== o(e) && "[object Function]" === o(e.callee);
            },
            a = function () {
              return i(arguments);
            }();
          i.isLegacyArguments = s, e.exports = a ? i : s;
        },
        8662: function _(e, t, r) {
          "use strict";

          var n,
            o = Object.prototype.toString,
            i = Function.prototype.toString,
            s = /^\s*(?:function)?\*/,
            a = r(6410)(),
            c = Object.getPrototypeOf;
          e.exports = function (e) {
            if ("function" != typeof e) return !1;
            if (s.test(i.call(e))) return !0;
            if (!a) return "[object GeneratorFunction]" === o.call(e);
            if (!c) return !1;
            if (void 0 === n) {
              var t = function () {
                if (!a) return !1;
                try {
                  return Function("return function*() {}")();
                } catch (e) {}
              }();
              n = !!t && c(t);
            }
            return c(e) === n;
          };
        },
        5692: function _(e, t, r) {
          "use strict";

          var n = r(9804),
            o = r(3083),
            i = r(1924),
            s = i("Object.prototype.toString"),
            a = r(6410)(),
            c = "undefined" == typeof globalThis ? r.g : globalThis,
            u = o(),
            l = i("Array.prototype.indexOf", !0) || function (e, t) {
              for (var r = 0; r < e.length; r += 1) {
                if (e[r] === t) return r;
              }
              return -1;
            },
            d = i("String.prototype.slice"),
            f = {},
            p = r(882),
            h = Object.getPrototypeOf;
          a && p && h && n(u, function (e) {
            var t = new c[e]();
            if (Symbol.toStringTag in t) {
              var r = h(t),
                n = p(r, Symbol.toStringTag);
              if (!n) {
                var o = h(r);
                n = p(o, Symbol.toStringTag);
              }
              f[e] = n.get;
            }
          }), e.exports = function (e) {
            if (!e || "object" != _typeof(e)) return !1;
            if (!a || !(Symbol.toStringTag in e)) {
              var t = d(s(e), 8, -1);
              return l(u, t) > -1;
            }
            return !!p && function (e) {
              var t = !1;
              return n(f, function (r, n) {
                if (!t) try {
                  t = r.call(e) === n;
                } catch (e) {}
              }), t;
            }(e);
          };
        },
        2023: function _(module, exports, __webpack_require__) {
          var process = __webpack_require__(4155),
            __WEBPACK_AMD_DEFINE_RESULT__;
          (function () {
            "use strict";

            var ERROR = "input is invalid type",
              WINDOW = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)),
              root = WINDOW ? window : {};
            root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
            var WEB_WORKER = !WINDOW && "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)),
              NODE_JS = !root.JS_SHA256_NO_NODE_JS && "object" == _typeof(process) && process.versions && process.versions.node;
            NODE_JS ? root = __webpack_require__.g : WEB_WORKER && (root = self);
            var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && module.exports,
              AMD = __webpack_require__.amdO,
              ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
              HEX_CHARS = "0123456789abcdef".split(""),
              EXTRA = [-2147483648, 8388608, 32768, 128],
              SHIFT = [24, 16, 8, 0],
              K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298],
              OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"],
              blocks = [];
            !root.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function (e) {
              return "[object Array]" === Object.prototype.toString.call(e);
            }), !ARRAY_BUFFER || !root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (e) {
              return "object" == _typeof(e) && e.buffer && e.buffer.constructor === ArrayBuffer;
            });
            var createOutputMethod = function createOutputMethod(e, t) {
                return function (r) {
                  return new Sha256(t, !0).update(r)[e]();
                };
              },
              createMethod = function createMethod(e) {
                var t = createOutputMethod("hex", e);
                NODE_JS && (t = nodeWrap(t, e)), t.create = function () {
                  return new Sha256(e);
                }, t.update = function (e) {
                  return t.create().update(e);
                };
                for (var r = 0; r < OUTPUT_TYPES.length; ++r) {
                  var n = OUTPUT_TYPES[r];
                  t[n] = createOutputMethod(n, e);
                }
                return t;
              },
              nodeWrap = function nodeWrap(method, is224) {
                var crypto = eval("require('crypto')"),
                  Buffer = eval("require('buffer').Buffer"),
                  algorithm = is224 ? "sha224" : "sha256",
                  nodeMethod = function nodeMethod(e) {
                    if ("string" == typeof e) return crypto.createHash(algorithm).update(e, "utf8").digest("hex");
                    if (null == e) throw new Error(ERROR);
                    return e.constructor === ArrayBuffer && (e = new Uint8Array(e)), Array.isArray(e) || ArrayBuffer.isView(e) || e.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(e)).digest("hex") : method(e);
                  };
                return nodeMethod;
              },
              createHmacOutputMethod = function createHmacOutputMethod(e, t) {
                return function (r, n) {
                  return new HmacSha256(r, t, !0).update(n)[e]();
                };
              },
              createHmacMethod = function createHmacMethod(e) {
                var t = createHmacOutputMethod("hex", e);
                t.create = function (t) {
                  return new HmacSha256(t, e);
                }, t.update = function (e, r) {
                  return t.create(e).update(r);
                };
                for (var r = 0; r < OUTPUT_TYPES.length; ++r) {
                  var n = OUTPUT_TYPES[r];
                  t[n] = createHmacOutputMethod(n, e);
                }
                return t;
              };
            function Sha256(e, t) {
              t ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], e ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = e;
            }
            function HmacSha256(e, t, r) {
              var n,
                o = _typeof(e);
              if ("string" === o) {
                var i,
                  s = [],
                  a = e.length,
                  c = 0;
                for (n = 0; n < a; ++n) {
                  (i = e.charCodeAt(n)) < 128 ? s[c++] = i : i < 2048 ? (s[c++] = 192 | i >> 6, s[c++] = 128 | 63 & i) : i < 55296 || i >= 57344 ? (s[c++] = 224 | i >> 12, s[c++] = 128 | i >> 6 & 63, s[c++] = 128 | 63 & i) : (i = 65536 + ((1023 & i) << 10 | 1023 & e.charCodeAt(++n)), s[c++] = 240 | i >> 18, s[c++] = 128 | i >> 12 & 63, s[c++] = 128 | i >> 6 & 63, s[c++] = 128 | 63 & i);
                }
                e = s;
              } else {
                if ("object" !== o) throw new Error(ERROR);
                if (null === e) throw new Error(ERROR);
                if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);
              }
              e.length > 64 && (e = new Sha256(t, !0).update(e).array());
              var u = [],
                l = [];
              for (n = 0; n < 64; ++n) {
                var d = e[n] || 0;
                u[n] = 92 ^ d, l[n] = 54 ^ d;
              }
              Sha256.call(this, t, r), this.update(l), this.oKeyPad = u, this.inner = !0, this.sharedMemory = r;
            }
            Sha256.prototype.update = function (e) {
              if (!this.finalized) {
                var t,
                  r = _typeof(e);
                if ("string" !== r) {
                  if ("object" !== r) throw new Error(ERROR);
                  if (null === e) throw new Error(ERROR);
                  if (ARRAY_BUFFER && e.constructor === ArrayBuffer) e = new Uint8Array(e);else if (!(Array.isArray(e) || ARRAY_BUFFER && ArrayBuffer.isView(e))) throw new Error(ERROR);
                  t = !0;
                }
                for (var n, o, i = 0, s = e.length, a = this.blocks; i < s;) {
                  if (this.hashed && (this.hashed = !1, a[0] = this.block, a[16] = a[1] = a[2] = a[3] = a[4] = a[5] = a[6] = a[7] = a[8] = a[9] = a[10] = a[11] = a[12] = a[13] = a[14] = a[15] = 0), t) for (o = this.start; i < s && o < 64; ++i) {
                    a[o >> 2] |= e[i] << SHIFT[3 & o++];
                  } else for (o = this.start; i < s && o < 64; ++i) {
                    (n = e.charCodeAt(i)) < 128 ? a[o >> 2] |= n << SHIFT[3 & o++] : n < 2048 ? (a[o >> 2] |= (192 | n >> 6) << SHIFT[3 & o++], a[o >> 2] |= (128 | 63 & n) << SHIFT[3 & o++]) : n < 55296 || n >= 57344 ? (a[o >> 2] |= (224 | n >> 12) << SHIFT[3 & o++], a[o >> 2] |= (128 | n >> 6 & 63) << SHIFT[3 & o++], a[o >> 2] |= (128 | 63 & n) << SHIFT[3 & o++]) : (n = 65536 + ((1023 & n) << 10 | 1023 & e.charCodeAt(++i)), a[o >> 2] |= (240 | n >> 18) << SHIFT[3 & o++], a[o >> 2] |= (128 | n >> 12 & 63) << SHIFT[3 & o++], a[o >> 2] |= (128 | n >> 6 & 63) << SHIFT[3 & o++], a[o >> 2] |= (128 | 63 & n) << SHIFT[3 & o++]);
                  }
                  this.lastByteIndex = o, this.bytes += o - this.start, o >= 64 ? (this.block = a[16], this.start = o - 64, this.hash(), this.hashed = !0) : this.start = o;
                }
                return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
              }
            }, Sha256.prototype.finalize = function () {
              if (!this.finalized) {
                this.finalized = !0;
                var e = this.blocks,
                  t = this.lastByteIndex;
                e[16] = this.block, e[t >> 2] |= EXTRA[3 & t], this.block = e[16], t >= 56 && (this.hashed || this.hash(), e[0] = this.block, e[16] = e[1] = e[2] = e[3] = e[4] = e[5] = e[6] = e[7] = e[8] = e[9] = e[10] = e[11] = e[12] = e[13] = e[14] = e[15] = 0), e[14] = this.hBytes << 3 | this.bytes >>> 29, e[15] = this.bytes << 3, this.hash();
              }
            }, Sha256.prototype.hash = function () {
              var e,
                t,
                r,
                n,
                o,
                i,
                s,
                a,
                c,
                u = this.h0,
                l = this.h1,
                d = this.h2,
                f = this.h3,
                p = this.h4,
                h = this.h5,
                y = this.h6,
                g = this.h7,
                v = this.blocks;
              for (e = 16; e < 64; ++e) {
                t = ((o = v[e - 15]) >>> 7 | o << 25) ^ (o >>> 18 | o << 14) ^ o >>> 3, r = ((o = v[e - 2]) >>> 17 | o << 15) ^ (o >>> 19 | o << 13) ^ o >>> 10, v[e] = v[e - 16] + t + v[e - 7] + r << 0;
              }
              for (c = l & d, e = 0; e < 64; e += 4) {
                this.first ? (this.is224 ? (i = 300032, g = (o = v[0] - 1413257819) - 150054599 << 0, f = o + 24177077 << 0) : (i = 704751109, g = (o = v[0] - 210244248) - 1521486534 << 0, f = o + 143694565 << 0), this.first = !1) : (t = (u >>> 2 | u << 30) ^ (u >>> 13 | u << 19) ^ (u >>> 22 | u << 10), n = (i = u & l) ^ u & d ^ c, g = f + (o = g + (r = (p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) + (p & h ^ ~p & y) + K[e] + v[e]) << 0, f = o + (t + n) << 0), t = (f >>> 2 | f << 30) ^ (f >>> 13 | f << 19) ^ (f >>> 22 | f << 10), n = (s = f & u) ^ f & l ^ i, y = d + (o = y + (r = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7)) + (g & p ^ ~g & h) + K[e + 1] + v[e + 1]) << 0, t = ((d = o + (t + n) << 0) >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10), n = (a = d & f) ^ d & u ^ s, h = l + (o = h + (r = (y >>> 6 | y << 26) ^ (y >>> 11 | y << 21) ^ (y >>> 25 | y << 7)) + (y & g ^ ~y & p) + K[e + 2] + v[e + 2]) << 0, t = ((l = o + (t + n) << 0) >>> 2 | l << 30) ^ (l >>> 13 | l << 19) ^ (l >>> 22 | l << 10), n = (c = l & d) ^ l & f ^ a, p = u + (o = p + (r = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7)) + (h & y ^ ~h & g) + K[e + 3] + v[e + 3]) << 0, u = o + (t + n) << 0;
              }
              this.h0 = this.h0 + u << 0, this.h1 = this.h1 + l << 0, this.h2 = this.h2 + d << 0, this.h3 = this.h3 + f << 0, this.h4 = this.h4 + p << 0, this.h5 = this.h5 + h << 0, this.h6 = this.h6 + y << 0, this.h7 = this.h7 + g << 0;
            }, Sha256.prototype.hex = function () {
              this.finalize();
              var e = this.h0,
                t = this.h1,
                r = this.h2,
                n = this.h3,
                o = this.h4,
                i = this.h5,
                s = this.h6,
                a = this.h7,
                c = HEX_CHARS[e >> 28 & 15] + HEX_CHARS[e >> 24 & 15] + HEX_CHARS[e >> 20 & 15] + HEX_CHARS[e >> 16 & 15] + HEX_CHARS[e >> 12 & 15] + HEX_CHARS[e >> 8 & 15] + HEX_CHARS[e >> 4 & 15] + HEX_CHARS[15 & e] + HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 4 & 15] + HEX_CHARS[15 & t] + HEX_CHARS[r >> 28 & 15] + HEX_CHARS[r >> 24 & 15] + HEX_CHARS[r >> 20 & 15] + HEX_CHARS[r >> 16 & 15] + HEX_CHARS[r >> 12 & 15] + HEX_CHARS[r >> 8 & 15] + HEX_CHARS[r >> 4 & 15] + HEX_CHARS[15 & r] + HEX_CHARS[n >> 28 & 15] + HEX_CHARS[n >> 24 & 15] + HEX_CHARS[n >> 20 & 15] + HEX_CHARS[n >> 16 & 15] + HEX_CHARS[n >> 12 & 15] + HEX_CHARS[n >> 8 & 15] + HEX_CHARS[n >> 4 & 15] + HEX_CHARS[15 & n] + HEX_CHARS[o >> 28 & 15] + HEX_CHARS[o >> 24 & 15] + HEX_CHARS[o >> 20 & 15] + HEX_CHARS[o >> 16 & 15] + HEX_CHARS[o >> 12 & 15] + HEX_CHARS[o >> 8 & 15] + HEX_CHARS[o >> 4 & 15] + HEX_CHARS[15 & o] + HEX_CHARS[i >> 28 & 15] + HEX_CHARS[i >> 24 & 15] + HEX_CHARS[i >> 20 & 15] + HEX_CHARS[i >> 16 & 15] + HEX_CHARS[i >> 12 & 15] + HEX_CHARS[i >> 8 & 15] + HEX_CHARS[i >> 4 & 15] + HEX_CHARS[15 & i] + HEX_CHARS[s >> 28 & 15] + HEX_CHARS[s >> 24 & 15] + HEX_CHARS[s >> 20 & 15] + HEX_CHARS[s >> 16 & 15] + HEX_CHARS[s >> 12 & 15] + HEX_CHARS[s >> 8 & 15] + HEX_CHARS[s >> 4 & 15] + HEX_CHARS[15 & s];
              return this.is224 || (c += HEX_CHARS[a >> 28 & 15] + HEX_CHARS[a >> 24 & 15] + HEX_CHARS[a >> 20 & 15] + HEX_CHARS[a >> 16 & 15] + HEX_CHARS[a >> 12 & 15] + HEX_CHARS[a >> 8 & 15] + HEX_CHARS[a >> 4 & 15] + HEX_CHARS[15 & a]), c;
            }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function () {
              this.finalize();
              var e = this.h0,
                t = this.h1,
                r = this.h2,
                n = this.h3,
                o = this.h4,
                i = this.h5,
                s = this.h6,
                a = this.h7,
                c = [e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e, t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, 255 & t, r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, 255 & r, n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, 255 & n, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o, i >> 24 & 255, i >> 16 & 255, i >> 8 & 255, 255 & i, s >> 24 & 255, s >> 16 & 255, s >> 8 & 255, 255 & s];
              return this.is224 || c.push(a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, 255 & a), c;
            }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function () {
              this.finalize();
              var e = new ArrayBuffer(this.is224 ? 28 : 32),
                t = new DataView(e);
              return t.setUint32(0, this.h0), t.setUint32(4, this.h1), t.setUint32(8, this.h2), t.setUint32(12, this.h3), t.setUint32(16, this.h4), t.setUint32(20, this.h5), t.setUint32(24, this.h6), this.is224 || t.setUint32(28, this.h7), e;
            }, HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function () {
              if (Sha256.prototype.finalize.call(this), this.inner) {
                this.inner = !1;
                var e = this.array();
                Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(e), Sha256.prototype.finalize.call(this);
              }
            };
            var exports = createMethod();
            exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224, AMD && (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return exports;
            }.call(exports, __webpack_require__, exports, module), void 0 === __WEBPACK_AMD_DEFINE_RESULT__ || (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)));
          })();
        },
        2151: function _(e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            ObliviousSet: function ObliviousSet() {
              return n;
            },
            now: function now() {
              return i;
            },
            removeTooOldValues: function removeTooOldValues() {
              return o;
            }
          });
          var n = function () {
            function e(e) {
              this.ttl = e, this.map = new Map(), this._to = !1;
            }
            return e.prototype.has = function (e) {
              return this.map.has(e);
            }, e.prototype.add = function (e) {
              var t = this;
              this.map.set(e, i()), this._to || (this._to = !0, setTimeout(function () {
                t._to = !1, o(t);
              }, 0));
            }, e.prototype.clear = function () {
              this.map.clear();
            }, e;
          }();
          function o(e) {
            for (var t = i() - e.ttl, r = e.map[Symbol.iterator]();;) {
              var n = r.next().value;
              if (!n) return;
              var o = n[0];
              if (!(n[1] < t)) return;
              e.map.delete(o);
            }
          }
          function i() {
            return new Date().getTime();
          }
        },
        4155: function _(e) {
          var t,
            r,
            n = e.exports = {};
          function o() {
            throw new Error("setTimeout has not been defined");
          }
          function i() {
            throw new Error("clearTimeout has not been defined");
          }
          function s(e) {
            if (t === setTimeout) return setTimeout(e, 0);
            if ((t === o || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
            try {
              return t(e, 0);
            } catch (r) {
              try {
                return t.call(null, e, 0);
              } catch (r) {
                return t.call(this, e, 0);
              }
            }
          }
          !function () {
            try {
              t = "function" == typeof setTimeout ? setTimeout : o;
            } catch (e) {
              t = o;
            }
            try {
              r = "function" == typeof clearTimeout ? clearTimeout : i;
            } catch (e) {
              r = i;
            }
          }();
          var a,
            c = [],
            u = !1,
            l = -1;
          function d() {
            u && a && (u = !1, a.length ? c = a.concat(c) : l = -1, c.length && f());
          }
          function f() {
            if (!u) {
              var e = s(d);
              u = !0;
              for (var t = c.length; t;) {
                for (a = c, c = []; ++l < t;) {
                  a && a[l].run();
                }
                l = -1, t = c.length;
              }
              a = null, u = !1, function (e) {
                if (r === clearTimeout) return clearTimeout(e);
                if ((r === i || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);
                try {
                  r(e);
                } catch (t) {
                  try {
                    return r.call(null, e);
                  } catch (t) {
                    return r.call(this, e);
                  }
                }
              }(e);
            }
          }
          function p(e, t) {
            this.fun = e, this.array = t;
          }
          function h() {}
          n.nextTick = function (e) {
            var t = new Array(arguments.length - 1);
            if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
              t[r - 1] = arguments[r];
            }
            c.push(new p(e, t)), 1 !== c.length || u || s(f);
          }, p.prototype.run = function () {
            this.fun.apply(null, this.array);
          }, n.title = "browser", n.browser = !0, n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = h, n.addListener = h, n.once = h, n.off = h, n.removeListener = h, n.removeAllListeners = h, n.emit = h, n.prependListener = h, n.prependOnceListener = h, n.listeners = function (e) {
            return [];
          }, n.binding = function (e) {
            throw new Error("process.binding is not supported");
          }, n.cwd = function () {
            return "/";
          }, n.chdir = function (e) {
            throw new Error("process.chdir is not supported");
          }, n.umask = function () {
            return 0;
          };
        },
        4595: function _(e, t, r) {
          var n, o, i;
          !function (s, a) {
            "use strict";

            o = [r(9829)], n = function n(e) {
              return {
                backtrace: function backtrace(t) {
                  var r = [],
                    n = 10;
                  "object" == _typeof(t) && "number" == typeof t.maxStackSize && (n = t.maxStackSize);
                  for (var o = arguments.callee; o && r.length < n && o.arguments;) {
                    for (var i = new Array(o.arguments.length), s = 0; s < i.length; ++s) {
                      i[s] = o.arguments[s];
                    }
                    /function(?:\s+([\w$]+))+\s*\(/.test(o.toString()) ? r.push(new e({
                      functionName: RegExp.$1 || void 0,
                      args: i
                    })) : r.push(new e({
                      args: i
                    }));
                    try {
                      o = o.caller;
                    } catch (e) {
                      break;
                    }
                  }
                  return r;
                }
              };
            }, void 0 === (i = n.apply(t, o)) || (e.exports = i);
          }();
        },
        9829: function _(e, t) {
          var r, n, o;
          !function (i, s) {
            "use strict";

            n = [], void 0 === (o = "function" == typeof (r = function r() {
              function e(e) {
                return e.charAt(0).toUpperCase() + e.substring(1);
              }
              function t(e) {
                return function () {
                  return this[e];
                };
              }
              var r = ["isConstructor", "isEval", "isNative", "isToplevel"],
                n = ["columnNumber", "lineNumber"],
                o = ["fileName", "functionName", "source"],
                i = r.concat(n, o, ["args"], ["evalOrigin"]);
              function s(t) {
                if (t) for (var r = 0; r < i.length; r++) {
                  void 0 !== t[i[r]] && this["set" + e(i[r])](t[i[r]]);
                }
              }
              s.prototype = {
                getArgs: function getArgs() {
                  return this.args;
                },
                setArgs: function setArgs(e) {
                  if ("[object Array]" !== Object.prototype.toString.call(e)) throw new TypeError("Args must be an Array");
                  this.args = e;
                },
                getEvalOrigin: function getEvalOrigin() {
                  return this.evalOrigin;
                },
                setEvalOrigin: function setEvalOrigin(e) {
                  if (e instanceof s) this.evalOrigin = e;else {
                    if (!(e instanceof Object)) throw new TypeError("Eval Origin must be an Object or StackFrame");
                    this.evalOrigin = new s(e);
                  }
                },
                toString: function toString() {
                  var e = this.getFileName() || "",
                    t = this.getLineNumber() || "",
                    r = this.getColumnNumber() || "",
                    n = this.getFunctionName() || "";
                  return this.getIsEval() ? e ? "[eval] (" + e + ":" + t + ":" + r + ")" : "[eval]:" + t + ":" + r : n ? n + " (" + e + ":" + t + ":" + r + ")" : e + ":" + t + ":" + r;
                }
              }, s.fromString = function (e) {
                var t = e.indexOf("("),
                  r = e.lastIndexOf(")"),
                  n = e.substring(0, t),
                  o = e.substring(t + 1, r).split(","),
                  i = e.substring(r + 1);
                if (0 === i.indexOf("@")) var a = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(i, ""),
                  c = a[1],
                  u = a[2],
                  l = a[3];
                return new s({
                  functionName: n,
                  args: o || void 0,
                  fileName: c,
                  lineNumber: u || void 0,
                  columnNumber: l || void 0
                });
              };
              for (var a = 0; a < r.length; a++) {
                s.prototype["get" + e(r[a])] = t(r[a]), s.prototype["set" + e(r[a])] = function (e) {
                  return function (t) {
                    this[e] = Boolean(t);
                  };
                }(r[a]);
              }
              for (var c = 0; c < n.length; c++) {
                s.prototype["get" + e(n[c])] = t(n[c]), s.prototype["set" + e(n[c])] = function (e) {
                  return function (t) {
                    if (r = t, isNaN(parseFloat(r)) || !isFinite(r)) throw new TypeError(e + " must be a Number");
                    var r;
                    this[e] = Number(t);
                  };
                }(n[c]);
              }
              for (var u = 0; u < o.length; u++) {
                s.prototype["get" + e(o[u])] = t(o[u]), s.prototype["set" + e(o[u])] = function (e) {
                  return function (t) {
                    this[e] = String(t);
                  };
                }(o[u]);
              }
              return s;
            }) ? r.apply(t, n) : r) || (e.exports = o);
          }();
        },
        1562: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.ApiClient = void 0, t.ApiClient = /*#__PURE__*/function () {
            function _class(e, t) {
              _classCallCheck(this, _class);
              this.appKey = e, this.http = t;
            }
            _createClass(_class, [{
              key: "getDeviceStatus",
              value: function getDeviceStatus(e) {
                var t = {
                  app_token: this.appKey,
                  device: e
                };
                return this.http.post("/app/device-status", t).then(function (e) {
                  var t = void 0 !== e.error,
                    r = !t || t && -1004 !== e.error.code;
                  return {
                    isDeviceEnabled: void 0 !== e.logger_enabled && e.logger_enabled,
                    isAppValid: r
                  };
                });
              }
            }, {
              key: "sendSession",
              value: function sendSession(e) {
                return this.http.post("/session", e);
              }
            }, {
              key: "sendLogs",
              value: function sendLogs(e, t) {
                return this.http.post("/log/batch", {
                  session_id: e,
                  logs: t
                });
              }
            }, {
              key: "sendIssue",
              value: function sendIssue(e, t, r, n, o, i) {
                var s = {
                  uid: e,
                  title: r,
                  text: n,
                  app: {
                    key: this.appKey
                  },
                  type: o,
                  session_id: i
                };
                return this.http.post("/issue", s).then(function () {
                  return {
                    uuid: e,
                    issueURL: t
                  };
                });
              }
            }, {
              key: "setDeviceKey",
              value: function setDeviceKey(e, t, r) {
                return this.http.post("/device/keyvalue", {
                  app_key: this.appKey,
                  device_id: e,
                  key: t,
                  value: r
                });
              }
            }]);
            return _class;
          }();
        },
        4319: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.EventPrinter = void 0;
          var n = r(8593);
          t.EventPrinter = /*#__PURE__*/function () {
            function _class2(e, t) {
              _classCallCheck(this, _class2);
              this.console = e, this.printToConsole = t, this.styles = {
                bold: "font-weight:bold",
                icon: "color:#ff5060",
                italic: "font-style:italic",
                neutral: "color:#999",
                regular: "color:#222"
              };
            }
            _createClass(_class2, [{
              key: "print",
              value: function print(e, t, r, o) {
                var _this$console, _this$console2;
                if (!this.printToConsole) return;
                var i = "%c".concat(e, "%c ").concat(t);
                o = [this.styles.icon, this.styles.regular].concat(_toConsumableArray(null != o ? o : [])), r ? (_this$console = this.console).info.apply(_this$console, [i].concat(_toConsumableArray(o), [(0, n.getElByXPath)(r)])) : (_this$console2 = this.console).info.apply(_this$console2, [i].concat(_toConsumableArray(o)));
              }
            }, {
              key: "printDeviceKey",
              value: function printDeviceKey(e, t) {
                null === t ? this.print("◆", "Device key %c\"".concat(e, "\"%c removed"), void 0, [this.styles.italic, this.styles.bold]) : this.print("◆", "Device key %c\"".concat(e, "\" %cset%c to %c\"").concat(t, "\""), void 0, [this.styles.italic, this.styles.bold, this.styles.regular, this.styles.italic]);
              }
            }, {
              key: "printJsEvent",
              value: function printJsEvent(e) {
                var t = JSON.parse(e.text);
                switch (t.event) {
                  case "DOMContentLoaded":
                    this.print("●", "DOM content %cloaded", void 0, [this.styles.bold]);
                    break;
                  case "PageLoaded":
                    this.print("●", "Page %cloaded", void 0, [this.styles.bold]);
                    break;
                  case "hashchange":
                    this.print("#", "URL %chash changed%c to %c\"".concat(t.hash, "\""), void 0, [this.styles.bold, this.styles.regular, this.styles.italic]);
                    break;
                  case "blur":
                  case "click":
                  case "focus":
                  case "keyup":
                    {
                      var _e = "click" === t.event ? "⊙" : "▭",
                        _r = t.text && "keyup" === t.event ? " value=".concat(this.truncate(t.text)) : "",
                        _n = {
                          blur: "blurred",
                          click: "clicked",
                          focus: "focused",
                          keyup: "keyup"
                        };
                      this.print(_e, "Element %c".concat(_n[t.event], "%c").concat(_r, "%c:"), t.xpath, [this.styles.bold, this.styles.neutral, this.styles.regular]);
                      break;
                    }
                  case "submit":
                    this.print("↑", "Form %csubmited", t.xpath, [this.styles.bold]);
                    break;
                  case "popstate":
                  case "pushstate":
                    this.print("↦", "Navigation %cstate changed", void 0, [this.styles.bold]);
                    break;
                  default:
                    throw new n.UnreachableCaseError(t);
                }
              }
            }, {
              key: "truncate",
              value: function truncate(e) {
                return e.length > 15 ? "".concat(e.substring(0, 15), "\u2026 [").concat(e.length, "]") : e;
              }
            }]);
            return _class2;
          }();
        },
        2329: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.OverrideConsoleMethods = void 0;
          var n = r(7431);
          t.OverrideConsoleMethods = /*#__PURE__*/function () {
            function _class3(e, t) {
              _classCallCheck(this, _class3);
              this.commands = e, this.window = t;
            }
            _createClass(_class3, [{
              key: "init",
              value: function init(e) {
                var t = this,
                  r = {
                    log: n.LogLevel.Debug,
                    trace: n.LogLevel.Trace,
                    info: n.LogLevel.Info,
                    warn: n.LogLevel.Warning,
                    error: n.LogLevel.Error
                  };
                this.window.console = function (n) {
                  return Object.assign(Object.assign({}, n), Object.fromEntries(Object.keys(r).map(function (o) {
                    return [o, function () {
                      for (var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++) {
                        i[_key] = arguments[_key];
                      }
                      t.commands.addLogMessage(r[o], i), e || n[o].apply(n, i);
                    }];
                  })));
                }(this.window.console);
              }
            }]);
            return _class3;
          }();
        },
        277: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.RegisterBrowserEventsHandler = void 0;
          var n = r(7725);
          var o = /*#__PURE__*/function (_n$RegisterEventsHand) {
            _inherits(o, _n$RegisterEventsHand);
            var _super = _createSuper(o);
            function o(e, t) {
              var _this;
              _classCallCheck(this, o);
              _this = _super.call(this, e, t), _this.commands = e, _this.window = t;
              return _this;
            }
            _createClass(o, [{
              key: "init",
              value: function init() {
                var _this2 = this;
                if (!this.window.document.addEventListener) return;
                var e = !this.supportsPassiveEvents() || {
                  passive: !0,
                  capture: !0
                };
                this.window.addEventListener("load", function () {
                  _this2.addJsEventLogEntry({
                    event: "PageLoaded",
                    performance: _this2.window.performance
                  });
                }, e), this.window.addEventListener("DOMContentLoaded", function () {
                  _this2.addJsEventLogEntry({
                    event: "DOMContentLoaded"
                  });
                }, e), this.window.addEventListener("popstate", function (e) {
                  _this2.addJsEventLogEntry({
                    event: "popstate",
                    location: _this2.window.location.href,
                    state: JSON.stringify(e.state)
                  });
                }, e), this.window.addEventListener("hashchange", function () {
                  _this2.addJsEventLogEntry({
                    event: "hashchange",
                    hash: _this2.window.location.hash
                  });
                }, e);
                var t = function t(e) {
                  var t = _this2;
                  return function () {
                    for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                      r[_key2] = arguments[_key2];
                    }
                    var n = r.length > 2 ? r[2] : void 0;
                    return n && t.addJsEventLogEntry({
                      event: "pushstate",
                      to: String(n),
                      state: r.length > 1 ? JSON.stringify(r[1]) : null
                    }), e.apply(this, r);
                  };
                };
                this.override(this.window.history, "pushState", t), this.override(this.window.history, "replaceState", t);
              }
            }, {
              key: "override",
              value: function override(e, t, r) {
                if (!(t in e)) return;
                var n = r(e[t]);
                e[t] = n;
              }
            }]);
            return o;
          }(n.RegisterEventsHandlerBase);
          t.RegisterBrowserEventsHandler = o;
        },
        7725: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.RegisterEventsHandlerBase = void 0, t.RegisterEventsHandlerBase = /*#__PURE__*/function () {
            function _class4(e, t) {
              _classCallCheck(this, _class4);
              this.commands = e, this.window = t;
            }
            _createClass(_class4, [{
              key: "addJsEventLogEntry",
              value: function addJsEventLogEntry(e) {
                var t = {
                  tag: "js_event",
                  text: JSON.stringify(e),
                  url: this.getURL()
                };
                this.commands.addLogEntry(t);
              }
            }, {
              key: "getURL",
              value: function getURL() {
                return this.window ? this.window.location.href : "";
              }
            }, {
              key: "supportsPassiveEvents",
              value: function supportsPassiveEvents() {
                var e = !1;
                try {
                  var _t2 = function _t2() {},
                    r = {
                      get passive() {
                        return e = !0, !1;
                      }
                    };
                  this.window.addEventListener("offline", _t2, r), this.window.removeEventListener("offline", _t2, !1);
                } catch (t) {
                  e = !1;
                }
                return e;
              }
            }]);
            return _class4;
          }();
        },
        5881: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.RegisterUIEventsHandler = void 0;
          var n = r(8593),
            o = r(7725);
          var i = /*#__PURE__*/function (_o$RegisterEventsHand) {
            _inherits(i, _o$RegisterEventsHand);
            var _super2 = _createSuper(i);
            function i(e, t) {
              var _this3;
              _classCallCheck(this, i);
              _this3 = _super2.call(this, e, t), _this3.commands = e, _this3.window = t;
              return _this3;
            }
            _createClass(i, [{
              key: "init",
              value: function init() {
                var _this4 = this;
                if (!this.window.document.addEventListener) return;
                var e = !this.supportsPassiveEvents() || {
                  passive: !0,
                  capture: !0
                };
                document.addEventListener("click", function (e) {
                  e.target instanceof Element && _this4.addJsEventLogEntry(_this4.getEventData(e.target, "click"));
                }, e), document.addEventListener("focusin", function (e) {
                  e.target instanceof Element && _this4.addJsEventLogEntry(_this4.getEventData(e.target, "focus"));
                }, e), document.addEventListener("focusout", function (e) {
                  e.target instanceof Element && _this4.addJsEventLogEntry(_this4.getEventData(e.target, "blur"));
                }, e), this.window.addEventListener("submit", function (e) {
                  e.target instanceof Element && _this4.addJsEventLogEntry(_this4.getEventData(e.target, "submit"));
                }, e);
                var t = new n.DebounceByElement(400),
                  r = ["Tab", "Meta", "MetaLeft", "MetaRight", "Alt", "AltLeft", "AltRight", "Control", "ControlLeft", "ControlRight", "Shift", "ShiftLeft", "ShiftRight", "ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown", "PageDown", "PageUp", "Home", "End", "CapsLock"];
                this.window.addEventListener("keyup", function (e) {
                  if (!(e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) || !e.composedPath || r.includes(e.code)) return;
                  var n = e.target,
                    o = e.composedPath();
                  t.run(n, function () {
                    _this4.sendKeyupLog(n, o);
                  });
                }, e);
              }
            }, {
              key: "sendKeyupLog",
              value: function sendKeyupLog(e, t) {
                var r;
                var n = "password" === (null !== (r = e.getAttribute("type")) && void 0 !== r ? r : "").toLowerCase(),
                  o = t.filter(function (e) {
                    return e instanceof HTMLElement;
                  }).some(function (e) {
                    return "bfIgnoreKeypress" in e.dataset;
                  }),
                  _i = n || o;
                this.addJsEventLogEntry(Object.assign(Object.assign({}, this.getEventData(e, "keyup")), {
                  text: _i ? void 0 : e.value
                }));
              }
            }, {
              key: "getEventData",
              value: function getEventData(e, t) {
                var r = e.childElementCount <= 1 ? e.textContent : void 0,
                  o = "FORM" === e.tagName ? e : null;
                return {
                  event: t,
                  url: this.window ? this.window.location.href : "",
                  xpath: (0, n.getXPath)(e),
                  tag: e.tagName,
                  id: e.id,
                  text: null != r ? r : void 0,
                  action: o && o.action ? o.action : ""
                };
              }
            }]);
            return i;
          }(o.RegisterEventsHandlerBase);
          t.RegisterUIEventsHandler = i;
        },
        7722: function _(e, t, r) {
          "use strict";

          var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
              void 0 === n && (n = r);
              var o = Object.getOwnPropertyDescriptor(t, r);
              o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                enumerable: !0,
                get: function get() {
                  return t[r];
                }
              }), Object.defineProperty(e, n, o);
            } : function (e, t, r, n) {
              void 0 === n && (n = r), e[n] = t[r];
            }),
            o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
              Object.defineProperty(e, "default", {
                enumerable: !0,
                value: t
              });
            } : function (e, t) {
              e.default = t;
            }),
            i = this && this.__importStar || function (e) {
              if (e && e.__esModule) return e;
              var t = {};
              if (null != e) for (var r in e) {
                "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
              }
              return o(t, e), t;
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Browser = void 0;
          var s = i(r(1206));
          t.Browser = /*#__PURE__*/function () {
            function _class5(e) {
              _classCallCheck(this, _class5);
              this.window = e, this.browser = s.getParser(this.window.navigator.userAgent);
            }
            _createClass(_class5, [{
              key: "getDeviceName",
              value: function getDeviceName() {
                return "".concat(this.browser.getBrowserName(), " ").concat(this.browser.getBrowserVersion(), " on ").concat(this.browser.getOSName(), " ").concat(this.browser.getOSVersion());
              }
            }, {
              key: "getLanguage",
              value: function getLanguage() {
                var e;
                return null !== (e = this.window.navigator.language) && void 0 !== e ? e : this.window.navigator.userLanguage;
              }
            }, {
              key: "getName",
              value: function getName() {
                return this.browser.getBrowserName();
              }
            }, {
              key: "getOSVersion",
              value: function getOSVersion() {
                return this.browser.getOSVersion();
              }
            }]);
            return _class5;
          }();
        },
        2853: function _(e, t, r) {
          "use strict";

          var n = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Bugfender = void 0;
          var o = r(7431),
            i = r(2607),
            s = r(7935),
            a = r(8593);
          var c = /*#__PURE__*/function () {
            function c(e, t, r) {
              _classCallCheck(this, c);
              this.preInitProvider = e, this.sdkUserAgent = t, this.version = r, this.LogLevel = o.LogLevel, this.initDeferred = (0, a.createDeferred)(), this.commands = this.preInitProvider.provideCommandsQueue();
            }
            _createClass(c, [{
              key: "init",
              value: function init(e) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                  var _this5 = this;
                  var t, r, _e2, o, i, a;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          t = this.preInitProvider.provideOperationModes(), r = this.preInitProvider.provideSDKOptionsValidator();
                          this.options = r.init(e);
                          this.provider = new s.MainProvider(this.options, this.preInitProvider, this.sdkUserAgent, this.version);
                          _context2.next = 5;
                          return this.provider.getStorageProcessor();
                        case 5:
                          this.processor = _context2.sent;
                          if (!this.options.debug) {
                            _context2.next = 32;
                            break;
                          }
                          _e2 = this.preInitProvider.provideAPIFeatureDetection();
                          _context2.t0 = this.provider.getLogger(c.name);
                          _context2.t1 = this.options.debug;
                          _context2.next = 12;
                          return t.getMode();
                        case 12:
                          _context2.t2 = _context2.sent;
                          _context2.next = 15;
                          return t.isMultiTab();
                        case 15:
                          _context2.t3 = _context2.sent;
                          _context2.next = 18;
                          return t.isMultiThread();
                        case 18:
                          _context2.t4 = _context2.sent;
                          _context2.t5 = {
                            mode: _context2.t2,
                            isMultiTab: _context2.t3,
                            isMultiThread: _context2.t4
                          };
                          _context2.next = 22;
                          return _e2.isBroadcastChannelSupported();
                        case 22:
                          _context2.t6 = _context2.sent;
                          _context2.next = 25;
                          return _e2.isIndexedDBSupported();
                        case 25:
                          _context2.t7 = _context2.sent;
                          _context2.t8 = _e2.isLocalStorageSupported();
                          _context2.t9 = _e2.isSessionStorageSupported();
                          _context2.t10 = _e2.isWorkerSupported();
                          _context2.t11 = {
                            broadcastChannel: _context2.t6,
                            indexedDB: _context2.t7,
                            localStorage: _context2.t8,
                            sessionStorage: _context2.t9,
                            worker: _context2.t10
                          };
                          _context2.t12 = {
                            debug: _context2.t1,
                            operation: _context2.t5,
                            features: _context2.t11
                          };
                          _context2.t0.log.call(_context2.t0, "DEBUG", _context2.t12);
                        case 32:
                          _context2.next = 34;
                          return this.provider.getResetStorage();
                        case 34:
                          o = _context2.sent;
                          _context2.next = 37;
                          return o.resetIfAppChanged(this.options.appID);
                        case 37:
                          _context2.next = 39;
                          return this.provider.getStorageWriterHub();
                        case 39:
                          i = _context2.sent;
                          i.init(this.options), this.options.logBrowserEvents && this.provider.getRegisterBrowserEventsHandler().init(), this.options.logUIEvents && this.provider.getRegisterUIEventsHandler().init(), this.options.registerErrorHandler && this.provider.getRegisterErrorHandler().init(this), this.options.overrideConsoleMethods && this.provider.getOverrideConsoleMethods().init(this.options.printToConsole), this.provider.getPrintToConsole().init(this.options.printToConsole), window.addEventListener("beforeunload", function () {
                            return n(_this5, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                              return _regeneratorRuntime().wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      this.processor.run();
                                    case 1:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, this);
                            }));
                          }), this.commands.init(i);
                          a = this.preInitProvider.provideBrowser();
                          this.setDeviceKey("$browser", a.getName()), this.initDeferred.resolve();
                        case 43:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));
              }
            }, {
              key: "forceSendOnce",
              value: function forceSendOnce() {
                this.commands.forceSendOnce();
              }
            }, {
              key: "getDeviceURL",
              value: function getDeviceURL() {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  var e;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return this.initDeferred.promise;
                        case 2:
                          _context3.next = 4;
                          return this.provider.getDevice();
                        case 4:
                          e = _context3.sent;
                          return _context3.abrupt("return", "".concat(this.options.baseURL, "/intent/").concat(this.options.appID, "/device/").concat(e.getUDID()));
                        case 6:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, this);
                }));
              }
            }, {
              key: "getSessionURL",
              value: function getSessionURL() {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  var e;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return this.initDeferred.promise;
                        case 2:
                          _context4.next = 4;
                          return this.provider.getCurrentSession();
                        case 4:
                          e = _context4.sent;
                          return _context4.abrupt("return", "".concat(this.options.baseURL, "/intent/").concat(this.options.appID, "/session/").concat(e.getUUID()));
                        case 6:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, this);
                }));
              }
            }, {
              key: "getUserFeedback",
              value: function getUserFeedback(e) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          return _context5.abrupt("return", this.preInitProvider.provideUserFeedback().show(e));
                        case 1:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, this);
                }));
              }
            }, {
              key: "log",
              value: function log() {
                for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                  e[_key3] = arguments[_key3];
                }
                this.commands.addLogMessage(o.LogLevel.Debug, [].concat(e));
              }
            }, {
              key: "warn",
              value: function warn() {
                for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                  e[_key4] = arguments[_key4];
                }
                this.commands.addLogMessage(o.LogLevel.Warning, [].concat(e));
              }
            }, {
              key: "error",
              value: function error() {
                for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  e[_key5] = arguments[_key5];
                }
                this.commands.addLogMessage(o.LogLevel.Error, [].concat(e));
              }
            }, {
              key: "trace",
              value: function trace() {
                for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                  e[_key6] = arguments[_key6];
                }
                this.commands.addLogMessage(o.LogLevel.Trace, [].concat(e));
              }
            }, {
              key: "info",
              value: function info() {
                for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                  e[_key7] = arguments[_key7];
                }
                this.commands.addLogMessage(o.LogLevel.Info, [].concat(e));
              }
            }, {
              key: "fatal",
              value: function fatal() {
                for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
                  e[_key8] = arguments[_key8];
                }
                this.commands.addLogMessage(o.LogLevel.Fatal, [].concat(e));
              }
            }, {
              key: "removeDeviceKey",
              value: function removeDeviceKey(e) {
                this.commands.setDeviceKey(e, null);
              }
            }, {
              key: "sendLog",
              value: function sendLog(e) {
                this.commands.addLogEntry(e);
              }
            }, {
              key: "sendIssue",
              value: function sendIssue(e, t) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          return _context6.abrupt("return", this.commands.addIssue(i.IssueType.Issue, e, t));
                        case 1:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6, this);
                }));
              }
            }, {
              key: "sendCrash",
              value: function sendCrash(e, t) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          return _context7.abrupt("return", this.commands.addIssue(i.IssueType.Crash, e, t));
                        case 1:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7, this);
                }));
              }
            }, {
              key: "sendUserFeedback",
              value: function sendUserFeedback(e, t) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                  return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          return _context8.abrupt("return", this.commands.addIssue(i.IssueType.Feedback, e, t));
                        case 1:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8, this);
                }));
              }
            }, {
              key: "setDeviceKey",
              value: function setDeviceKey(e, t) {
                this.commands.setDeviceKey(e, t);
              }
            }, {
              key: "setForceEnabled",
              value: function setForceEnabled(e) {
                var _this6 = this;
                this.initDeferred.promise.then(function () {
                  _this6.provider.getStorageGuard().setDeviceForceEnabled(e);
                });
              }
            }]);
            return c;
          }();
          t.Bugfender = c;
        },
        1667: function _(e, t, r) {
          "use strict";

          var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
              void 0 === n && (n = r);
              var o = Object.getOwnPropertyDescriptor(t, r);
              o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
                enumerable: !0,
                get: function get() {
                  return t[r];
                }
              }), Object.defineProperty(e, n, o);
            } : function (e, t, r, n) {
              void 0 === n && (n = r), e[n] = t[r];
            }),
            o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
              Object.defineProperty(e, "default", {
                enumerable: !0,
                value: t
              });
            } : function (e, t) {
              e.default = t;
            }),
            i = this && this.__importStar || function (e) {
              if (e && e.__esModule) return e;
              var t = {};
              if (null != e) for (var r in e) {
                "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
              }
              return o(t, e), t;
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.CallInfoFactory = void 0;
          var s = i(r(9180)),
            a = i(r(4595));
          t.CallInfoFactory = /*#__PURE__*/function () {
            function _class6() {
              _classCallCheck(this, _class6);
            }
            _createClass(_class6, [{
              key: "create",
              value: function create() {
                try {
                  throw new Error();
                } catch (e) {
                  return this.getCallInfo(e);
                }
              }
            }, {
              key: "getCallInfo",
              value: function getCallInfo(e) {
                try {
                  var _t3 = this.getStackTraceSync(e),
                    _r2 = _t3[_t3.length - 1];
                  return {
                    file: "/" + _r2.fileName.substring(_r2.fileName.lastIndexOf("/") + 1),
                    line: _r2.lineNumber,
                    method: _r2.functionName
                  };
                } catch (e) {
                  return {
                    file: void 0,
                    line: void 0,
                    method: void 0
                  };
                }
              }
            }, {
              key: "getStackTraceSync",
              value: function getStackTraceSync(e) {
                return e.stack || e["opera#sourceloc"] ? s.parse(e) : a.backtrace();
              }
            }]);
            return _class6;
          }();
        },
        6110: function _(e, t, r) {
          "use strict";

          var n = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.MonoChannel = t.Channel = t.createBroadcastChannel = t.MessageType = void 0;
          var o = r(8437);
          var i;
          !function (e) {
            e.ForceSend = "force-send", e.Ping = "ping", e.Pong = "pong";
          }(i = t.MessageType || (t.MessageType = {})), t.createBroadcastChannel = function () {
            return new o.BroadcastChannel("bf-sdk");
          }, t.Channel = /*#__PURE__*/function () {
            function _class7(e, t) {
              var _this7 = this;
              _classCallCheck(this, _class7);
              this.channel = e, this.logger = t, this.leader = !1, this.onForceSendCb = function () {}, this.sessionsStatus = {}, this.channel.onmessage = function (e) {
                return _this7.handleMessage(e);
              }, this.elector = (0, o.createLeaderElection)(this.channel, {
                fallbackInterval: 2e3,
                responseTime: 1e3
              }), this.leaderPromise = this.elector.awaitLeadership(), this.leaderPromise.then(function () {
                _this7.logger.log("Now I'm the leader. 💪"), _this7.leader = !0;
              });
            }
            _createClass(_class7, [{
              key: "setCurrentSession",
              value: function setCurrentSession(e) {
                this.session = e;
              }
            }, {
              key: "handleMessage",
              value: function handleMessage(e) {
                var t, r;
                switch (e.type) {
                  case i.ForceSend:
                    this.leader && this.onForceSendCb();
                    break;
                  case i.Ping:
                    e.toSessionUUID === (null === (t = this.session) || void 0 === t ? void 0 : t.getUUID()) && this.channel.postMessage({
                      type: i.Pong,
                      fromSessionUUID: e.toSessionUUID,
                      toSessionUUID: e.fromSessionUUID
                    });
                    break;
                  case i.Pong:
                    e.toSessionUUID === (null === (r = this.session) || void 0 === r ? void 0 : r.getUUID()) && (this.sessionsStatus[e.fromSessionUUID] = !0);
                }
              }
            }, {
              key: "isLeader",
              value: function isLeader() {
                return this.leader;
              }
            }, {
              key: "notifyForceSend",
              value: function notifyForceSend() {
                this.leader ? this.onForceSendCb() : this.channel.postMessage({
                  type: i.ForceSend
                });
              }
            }, {
              key: "onForceSend",
              value: function onForceSend(e) {
                this.onForceSendCb = e;
              }
            }, {
              key: "onHasBecomeLeader",
              value: function onHasBecomeLeader() {
                return this.leaderPromise;
              }
            }, {
              key: "isSessionActive",
              value: function isSessionActive(e) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                  var _this8 = this;
                  var t;
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          t = !!this.session;
                          return _context9.abrupt("return", !(t && (!t || this.session.getUUID() !== e)) || new Promise(function (t) {
                            _this8.sessionsStatus[e] = !1, _this8.channel.postMessage({
                              type: i.Ping,
                              fromSessionUUID: _this8.session.getUUID(),
                              toSessionUUID: e
                            }), setTimeout(function () {
                              return t(_this8.sessionsStatus[e]);
                            }, 250);
                          }));
                        case 2:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9, this);
                }));
              }
            }]);
            return _class7;
          }(), t.MonoChannel = /*#__PURE__*/function () {
            function _class8() {
              _classCallCheck(this, _class8);
              this.onForceSendCb = function () {}, this.leaderPromise = Promise.resolve();
            }
            _createClass(_class8, [{
              key: "setCurrentSession",
              value: function setCurrentSession(e) {
                this.session = e;
              }
            }, {
              key: "isLeader",
              value: function isLeader() {
                return !0;
              }
            }, {
              key: "isSessionActive",
              value: function isSessionActive(e) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
                  var t;
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          t = !!this.session;
                          return _context10.abrupt("return", !this.session || t && this.session.getUUID() === e);
                        case 2:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10, this);
                }));
              }
            }, {
              key: "notifyForceSend",
              value: function notifyForceSend() {
                this.onForceSendCb();
              }
            }, {
              key: "onForceSend",
              value: function onForceSend(e) {
                this.onForceSendCb = e;
              }
            }, {
              key: "onHasBecomeLeader",
              value: function onHasBecomeLeader() {
                return this.leaderPromise;
              }
            }]);
            return _class8;
          }();
        },
        7442: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.CommandsQueue = void 0;
          var n = r(5049),
            o = r(8593);
          t.CommandsQueue = /*#__PURE__*/function () {
            function _class9(e, t, r) {
              _classCallCheck(this, _class9);
              this.callInfoFactory = e, this.timer = t, this.uuidFactory = r, this.queue = [], this.storageDeferred = (0, o.createDeferred)();
            }
            _createClass(_class9, [{
              key: "init",
              value: function init(e) {
                var _this9 = this;
                this.storageDeferred.resolve(e), this.queue.forEach(function (e) {
                  _this9.handleCommand(e);
                });
              }
            }, {
              key: "handleCommand",
              value: function handleCommand(e) {
                if (this.storageDeferred.isResolved) switch (e.type) {
                  case n.CommandType.AddIssue:
                    this.storageDeferred.value.addIssue(e);
                    break;
                  case n.CommandType.AddLogEntry:
                    this.storageDeferred.value.addLogEntry(e);
                    break;
                  case n.CommandType.AddLogMessage:
                    this.storageDeferred.value.addLogMessage(e);
                    break;
                  case n.CommandType.ForceSendOnce:
                    this.storageDeferred.value.forceSendOnce();
                    break;
                  case n.CommandType.SetDeviceKey:
                    this.storageDeferred.value.addDeviceKey(e);
                    break;
                  default:
                    throw new o.UnreachableCaseError(e);
                }
              }
            }, {
              key: "add",
              value: function add(e) {
                this.storageDeferred.isFulfilled ? this.handleCommand(e) : this.queue.push(e);
              }
            }, {
              key: "addIssue",
              value: function addIssue(e, t, r) {
                var i = (0, o.createDeferred)();
                return this.add({
                  type: n.CommandType.AddIssue,
                  issueType: e,
                  title: t,
                  text: r,
                  uuid: this.uuidFactory.create(),
                  callInfo: this.callInfoFactory.create(),
                  url: i,
                  time: this.timer.getTime()
                }), i.promise;
              }
            }, {
              key: "addLogEntry",
              value: function addLogEntry(e) {
                this.add({
                  type: n.CommandType.AddLogEntry,
                  log: e,
                  callInfo: this.callInfoFactory.create(),
                  time: this.timer.getTime()
                });
              }
            }, {
              key: "addLogMessage",
              value: function addLogMessage(e, t) {
                this.add({
                  type: n.CommandType.AddLogMessage,
                  level: e,
                  parameters: t,
                  callInfo: this.callInfoFactory.create(),
                  time: this.timer.getTime()
                });
              }
            }, {
              key: "forceSendOnce",
              value: function forceSendOnce() {
                this.add({
                  type: n.CommandType.ForceSendOnce
                });
              }
            }, {
              key: "setDeviceKey",
              value: function setDeviceKey(e, t) {
                this.add({
                  type: n.CommandType.SetDeviceKey,
                  key: e,
                  value: t,
                  callInfo: this.callInfoFactory.create(),
                  time: this.timer.getTime()
                });
              }
            }]);
            return _class9;
          }();
        },
        5049: function _(e, t) {
          "use strict";

          var r;
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.CommandType = void 0, (r = t.CommandType || (t.CommandType = {})).AddIssue = "add-issue", r.AddLogEntry = "add-log-entry", r.AddLogMessage = "add-log-message", r.ForceSendOnce = "force-send-once", r.SetDeviceKey = "set-device-key";
        },
        6871: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Connection = void 0, t.Connection = /*#__PURE__*/function () {
            function _class10(e) {
              _classCallCheck(this, _class10);
              this.window = e;
            }
            _createClass(_class10, [{
              key: "isOnline",
              value: function isOnline() {
                return this.window.navigator.onLine;
              }
            }]);
            return _class10;
          }();
        },
        3256: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.CurrentSession = void 0;
          var n = r(8177);
          t.CurrentSession = /*#__PURE__*/function () {
            function _class11(e, t, r, n, o) {
              _classCallCheck(this, _class11);
              this.device = e, this.logger = t, this.sessionStorage = r, this.sessionsTable = n, this.uuidFactory = o, this.reset();
            }
            _createClass(_class11, [{
              key: "getUUID",
              value: function getUUID() {
                return this.uuid;
              }
            }, {
              key: "initSession",
              value: function initSession() {
                var e = this.device.getUDID();
                this.logger.log("Init session"), this.uuid = this.uuidFactory.create(), this.sessionStorage.setItem(n.SessionStorageKey.SessionUUID, this.uuid), this.sessionStorage.setItem(n.SessionStorageKey.SessionUDID, e);
              }
            }, {
              key: "reset",
              value: function reset() {
                var e = this.sessionStorage.getItem(n.SessionStorageKey.SessionUUID);
                null === e ? (this.logger.log("Session not available"), this.initSession()) : (this.uuid = e, this.sessionStorage.getItem(n.SessionStorageKey.SessionUDID) !== this.device.getUDID() ? (this.logger.log("Session Device UDID changed"), this.initSession()) : this.logger.log("Session UUID: ".concat(this.uuid))), this.sessionsTable.addIfMissing({
                  uuid: this.uuid,
                  udid: this.device.getUDID()
                });
              }
            }]);
            return _class11;
          }();
        },
        6422: function _(e, t, r) {
          "use strict";

          var n = this && this.__awaiter || function (e, t, r, n) {
              return new (r || (r = Promise))(function (o, i) {
                function s(e) {
                  try {
                    c(n.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function a(e) {
                  try {
                    c(n.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function c(e) {
                  var t;
                  e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                    e(t);
                  })).then(s, a);
                }
                c((n = n.apply(e, t || [])).next());
              });
            },
            o = this && this.__asyncValues || function (e) {
              if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
              var t,
                r = e[Symbol.asyncIterator];
              return r ? r.call(e) : (e = "function" == typeof __values ? __values(e) : e[Symbol.iterator](), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function () {
                return this;
              }, t);
              function n(r) {
                t[r] = e[r] && function (t) {
                  return new Promise(function (n, o) {
                    !function (e, t, r, n) {
                      Promise.resolve(n).then(function (t) {
                        e({
                          value: t,
                          done: r
                        });
                      }, t);
                    }(n, o, (t = e[r](t)).done, t.value);
                  });
                };
              }
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Database = void 0;
          var i = r(2998),
            s = r(8593);
          var a;
          !function (e) {
            e[e.New = 0] = "New", e[e.V1 = 10] = "V1", e[e.V2 = 20] = "V2";
          }(a || (a = {})), t.Database = /*#__PURE__*/function () {
            function _class12(e) {
              _classCallCheck(this, _class12);
              this.db = (0, s.createDeferred)(), this.name = null != e ? e : "bf_sdk", this.init();
            }
            _createClass(_class12, [{
              key: "init",
              value: function init() {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
                  var e;
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          _context12.next = 2;
                          return (0, i.openDB)(this.name, a.V2, {
                            upgrade: function upgrade(e, t, r, i) {
                              var s, c, u, l;
                              return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
                                var _e3, r, n, d, _e4, _t4;
                                return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                                  while (1) {
                                    switch (_context11.prev = _context11.next) {
                                      case 0:
                                        if (!(t === a.New && (e.createObjectStore("devicekeys", {
                                          keyPath: "id",
                                          autoIncrement: !0
                                        }).createIndex("sessionUUID", "sessionUUID"), e.createObjectStore("issues", {
                                          keyPath: "id",
                                          autoIncrement: !0
                                        }).createIndex("sessionUUID", "sessionUUID"), e.createObjectStore("logs", {
                                          keyPath: "id",
                                          autoIncrement: !0
                                        }).createIndex("sessionUUID", "sessionUUID"), e.createObjectStore("sessions", {
                                          keyPath: "uuid"
                                        })), t === a.V1)) {
                                          _context11.next = 28;
                                          break;
                                        }
                                        _e3 = i.objectStore("issues");
                                        _context11.prev = 2;
                                        n = !0, d = o(_e3);
                                      case 4:
                                        _context11.next = 6;
                                        return d.next();
                                      case 6:
                                        r = _context11.sent;
                                        if (s = r.done) {
                                          _context11.next = 12;
                                          break;
                                        }
                                        l = r.value, n = !1;
                                        try {
                                          _e4 = l, _t4 = Object.assign({}, _e4.value);
                                          _t4.data.text = _t4.data.markdown, delete _t4.data.markdown, _e4.update(_t4);
                                        } finally {
                                          n = !0;
                                        }
                                      case 10:
                                        _context11.next = 4;
                                        break;
                                      case 12:
                                        _context11.next = 17;
                                        break;
                                      case 14:
                                        _context11.prev = 14;
                                        _context11.t0 = _context11["catch"](2);
                                        c = {
                                          error: _context11.t0
                                        };
                                      case 17:
                                        _context11.prev = 17;
                                        _context11.prev = 18;
                                        _context11.t1 = n || s || !(u = d.return);
                                        if (_context11.t1) {
                                          _context11.next = 23;
                                          break;
                                        }
                                        _context11.next = 23;
                                        return u.call(d);
                                      case 23:
                                        _context11.prev = 23;
                                        if (!c) {
                                          _context11.next = 26;
                                          break;
                                        }
                                        throw c.error;
                                      case 26:
                                        return _context11.finish(23);
                                      case 27:
                                        return _context11.finish(17);
                                      case 28:
                                      case "end":
                                        return _context11.stop();
                                    }
                                  }
                                }, _callee11, null, [[2, 14, 17, 28], [18,, 23, 27]]);
                              }));
                            }
                          });
                        case 2:
                          e = _context12.sent;
                          this.db.resolve(e);
                        case 4:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12, this);
                }));
              }
            }, {
              key: "get",
              value: function get() {
                return this.db.promise;
              }
            }]);
            return _class12;
          }();
        },
        1177: function _(e, t) {
          "use strict";

          var r = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.InMemoryDeviceKeysTable = t.IDBDeviceKeysTable = void 0, t.IDBDeviceKeysTable = /*#__PURE__*/function () {
            function _class13(e) {
              _classCallCheck(this, _class13);
              this.table = e;
            }
            _createClass(_class13, [{
              key: "add",
              value: function add(e) {
                return this.table.add(e);
              }
            }, {
              key: "count",
              value: function count(e) {
                return this.table.countBy("sessionUUID", e);
              }
            }, {
              key: "deleteBatch",
              value: function deleteBatch(e) {
                return this.table.deleteBatch(0, e);
              }
            }, {
              key: "getAll",
              value: function getAll() {
                return this.table.getAll();
              }
            }]);
            return _class13;
          }(), t.InMemoryDeviceKeysTable = /*#__PURE__*/function () {
            function _class14() {
              _classCallCheck(this, _class14);
              this.data = [], this.idCounter = 0;
            }
            _createClass(_class14, [{
              key: "getNextID",
              value: function getNextID() {
                return this.idCounter++;
              }
            }, {
              key: "add",
              value: function add(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
                  var t;
                  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          t = this.getNextID();
                          this.data.push(Object.assign(Object.assign({}, e), {
                            id: t
                          }));
                        case 2:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13, this);
                }));
              }
            }, {
              key: "count",
              value: function count(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
                  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          return _context14.abrupt("return", this.data.filter(function (t) {
                            return t.sessionUUID === e;
                          }).length);
                        case 1:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee14, this);
                }));
              }
            }, {
              key: "deleteBatch",
              value: function deleteBatch(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
                  return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                    while (1) {
                      switch (_context15.prev = _context15.next) {
                        case 0:
                          this.data.splice(0, e);
                        case 1:
                        case "end":
                          return _context15.stop();
                      }
                    }
                  }, _callee15, this);
                }));
              }
            }, {
              key: "getAll",
              value: function getAll() {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) {
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          return _context16.abrupt("return", _toConsumableArray(this.data));
                        case 1:
                        case "end":
                          return _context16.stop();
                      }
                    }
                  }, _callee16, this);
                }));
              }
            }]);
            return _class14;
          }();
        },
        8808: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.InMemoryStorage = void 0, t.InMemoryStorage = /*#__PURE__*/function () {
            function _class15() {
              _classCallCheck(this, _class15);
              this.inMemoryStorage = {};
            }
            _createClass(_class15, [{
              key: "clear",
              value: function clear() {
                this.inMemoryStorage = {};
              }
            }, {
              key: "getItem",
              value: function getItem(e) {
                return Object.prototype.hasOwnProperty.call(this.inMemoryStorage, e) ? this.inMemoryStorage[e] : null;
              }
            }, {
              key: "key",
              value: function key(e) {
                var t;
                return null !== (t = Object.keys(this.inMemoryStorage)[e]) && void 0 !== t ? t : null;
              }
            }, {
              key: "removeItem",
              value: function removeItem(e) {
                delete this.inMemoryStorage[e];
              }
            }, {
              key: "setItem",
              value: function setItem(e, t) {
                this.inMemoryStorage[e] = String(t);
              }
            }, {
              key: "length",
              get: function get() {
                return Object.keys(this.inMemoryStorage).length;
              }
            }]);
            return _class15;
          }();
        },
        7941: function _(e, t) {
          "use strict";

          var r = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.InMemoryIssuesTable = t.IDBIssuesTable = void 0, t.IDBIssuesTable = /*#__PURE__*/function () {
            function _class16(e) {
              _classCallCheck(this, _class16);
              this.table = e;
            }
            _createClass(_class16, [{
              key: "add",
              value: function add(e) {
                return this.table.add(e);
              }
            }, {
              key: "count",
              value: function count(e) {
                return this.table.countBy("sessionUUID", e);
              }
            }, {
              key: "deleteById",
              value: function deleteById(e) {
                return this.table.deleteByIdx(e);
              }
            }, {
              key: "getBatch",
              value: function getBatch(e, t) {
                return this.table.getBatch(e, t);
              }
            }]);
            return _class16;
          }(), t.InMemoryIssuesTable = /*#__PURE__*/function () {
            function _class17() {
              _classCallCheck(this, _class17);
              this.data = [], this.idCounter = 0;
            }
            _createClass(_class17, [{
              key: "getNextID",
              value: function getNextID() {
                return this.idCounter++;
              }
            }, {
              key: "add",
              value: function add(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
                  var t;
                  return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                    while (1) {
                      switch (_context17.prev = _context17.next) {
                        case 0:
                          t = this.getNextID();
                          this.data.push(Object.assign(Object.assign({}, e), {
                            id: t
                          }));
                        case 2:
                        case "end":
                          return _context17.stop();
                      }
                    }
                  }, _callee17, this);
                }));
              }
            }, {
              key: "count",
              value: function count(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
                  return _regeneratorRuntime().wrap(function _callee18$(_context18) {
                    while (1) {
                      switch (_context18.prev = _context18.next) {
                        case 0:
                          return _context18.abrupt("return", this.data.filter(function (t) {
                            return t.sessionUUID === e;
                          }).length);
                        case 1:
                        case "end":
                          return _context18.stop();
                      }
                    }
                  }, _callee18, this);
                }));
              }
            }, {
              key: "deleteById",
              value: function deleteById(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
                  var t;
                  return _regeneratorRuntime().wrap(function _callee19$(_context19) {
                    while (1) {
                      switch (_context19.prev = _context19.next) {
                        case 0:
                          t = this.data.findIndex(function (t) {
                            return t.id === e;
                          });
                          -1 !== t && this.data.splice(t, 1);
                        case 2:
                        case "end":
                          return _context19.stop();
                      }
                    }
                  }, _callee19, this);
                }));
              }
            }, {
              key: "getBatch",
              value: function getBatch(e, t) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
                  return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                    while (1) {
                      switch (_context20.prev = _context20.next) {
                        case 0:
                          return _context20.abrupt("return", this.data.filter(function (t) {
                            return t.sessionUUID === e;
                          }).slice(0, t));
                        case 1:
                        case "end":
                          return _context20.stop();
                      }
                    }
                  }, _callee20, this);
                }));
              }
            }]);
            return _class17;
          }();
        },
        3856: function _(e, t) {
          "use strict";

          var r = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.InMemoryLogsTable = t.IDBLogsTable = void 0, t.IDBLogsTable = /*#__PURE__*/function () {
            function _class18(e, t) {
              _classCallCheck(this, _class18);
              this.table = e, this.logFactory = t;
            }
            _createClass(_class18, [{
              key: "add",
              value: function add(e) {
                return this.table.add(e);
              }
            }, {
              key: "count",
              value: function count(e) {
                return this.table.countBy("sessionUUID", e);
              }
            }, {
              key: "deleteBatch",
              value: function deleteBatch(e, t) {
                return this.table.deleteBatch(0, t, ["sessionUUID", e]);
              }
            }, {
              key: "deleteOldLogs",
              value: function deleteOldLogs(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
                  var r, n;
                  return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                    while (1) {
                      switch (_context21.prev = _context21.next) {
                        case 0:
                          _context21.next = 2;
                          return this.table.getBatch(e, t);
                        case 2:
                          r = _context21.sent;
                          if (!(r.length <= 1)) {
                            _context21.next = 5;
                            break;
                          }
                          return _context21.abrupt("return");
                        case 5:
                          n = {
                            sessionUUID: e,
                            data: this.logFactory.createGapLog(r.map(function (e) {
                              return e.data;
                            }))
                          };
                          _context21.next = 8;
                          return Promise.all([this.table.patchByIdx(r[0].id, n), this.table.deleteBatch(1, t - 1, ["sessionUUID", e])]);
                        case 8:
                        case "end":
                          return _context21.stop();
                      }
                    }
                  }, _callee21, this);
                }));
              }
            }, {
              key: "getBatch",
              value: function getBatch(e, t) {
                return this.table.getBatch(e, t);
              }
            }]);
            return _class18;
          }(), t.InMemoryLogsTable = /*#__PURE__*/function () {
            function _class19(e, t) {
              _classCallCheck(this, _class19);
              this.logFactory = e, this.storageLimit = t, this.data = [], this.idCounter = 0;
            }
            _createClass(_class19, [{
              key: "getNextID",
              value: function getNextID() {
                return this.idCounter++;
              }
            }, {
              key: "add",
              value: function add(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
                  var _e5, t;
                  return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                    while (1) {
                      switch (_context22.prev = _context22.next) {
                        case 0:
                          if (!(this.data.length >= this.storageLimit)) {
                            _context22.next = 3;
                            break;
                          }
                          _e5 = new Error("InMemory storage quota exceeded");
                          throw _e5.name = "QuotaExceededError", _e5;
                        case 3:
                          t = this.getNextID();
                          this.data.push(Object.assign(Object.assign({}, e), {
                            id: t
                          }));
                        case 5:
                        case "end":
                          return _context22.stop();
                      }
                    }
                  }, _callee22, this);
                }));
              }
            }, {
              key: "count",
              value: function count(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
                  return _regeneratorRuntime().wrap(function _callee23$(_context23) {
                    while (1) {
                      switch (_context23.prev = _context23.next) {
                        case 0:
                          return _context23.abrupt("return", this.data.filter(function (t) {
                            return t.sessionUUID === e;
                          }).length);
                        case 1:
                        case "end":
                          return _context23.stop();
                      }
                    }
                  }, _callee23, this);
                }));
              }
            }, {
              key: "deleteBatch",
              value: function deleteBatch(e, t) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
                  var r, n, o, i;
                  return _regeneratorRuntime().wrap(function _callee24$(_context24) {
                    while (1) {
                      switch (_context24.prev = _context24.next) {
                        case 0:
                          r = [];
                          n = 0;
                          for (o = 0; o < this.data.length; o++) {
                            i = this.data[o];
                            i.sessionUUID === e && n < t ? n++ : r.push(i);
                          }
                          this.data = r;
                        case 4:
                        case "end":
                          return _context24.stop();
                      }
                    }
                  }, _callee24, this);
                }));
              }
            }, {
              key: "deleteOldLogs",
              value: function deleteOldLogs(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
                  var e;
                  return _regeneratorRuntime().wrap(function _callee25$(_context25) {
                    while (1) {
                      switch (_context25.prev = _context25.next) {
                        case 0:
                          e = this.data.slice(0, 10);
                          e.length <= 1 || (this.data[0].data = this.logFactory.createGapLog(e.map(function (e) {
                            return e.data;
                          })), this.data.splice(1, 9));
                        case 2:
                        case "end":
                          return _context25.stop();
                      }
                    }
                  }, _callee25, this);
                }));
              }
            }, {
              key: "getBatch",
              value: function getBatch(e, t) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
                  return _regeneratorRuntime().wrap(function _callee26$(_context26) {
                    while (1) {
                      switch (_context26.prev = _context26.next) {
                        case 0:
                          return _context26.abrupt("return", this.data.filter(function (t) {
                            return t.sessionUUID === e;
                          }).slice(0, t));
                        case 1:
                        case "end":
                          return _context26.stop();
                      }
                    }
                  }, _callee26, this);
                }));
              }
            }]);
            return _class19;
          }();
        },
        253: function _(e, t) {
          "use strict";

          var r = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.InMemorySessionsTable = t.IDBSessionsTable = void 0, t.IDBSessionsTable = /*#__PURE__*/function () {
            function _class20(e) {
              _classCallCheck(this, _class20);
              this.table = e;
            }
            _createClass(_class20, [{
              key: "addIfMissing",
              value: function addIfMissing(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
                  return _regeneratorRuntime().wrap(function _callee27$(_context27) {
                    while (1) {
                      switch (_context27.prev = _context27.next) {
                        case 0:
                          _context27.next = 2;
                          return this.table.countBy("uuid", e.uuid);
                        case 2:
                          _context27.t0 = _context27.sent;
                          if (!(0 === _context27.t0)) {
                            _context27.next = 5;
                            break;
                          }
                          return _context27.abrupt("return", this.table.add(e));
                        case 5:
                        case "end":
                          return _context27.stop();
                      }
                    }
                  }, _callee27, this);
                }));
              }
            }, {
              key: "delete",
              value: function _delete(e) {
                return this.table.deleteByIdx(e);
              }
            }, {
              key: "getAll",
              value: function getAll() {
                return this.table.getAll();
              }
            }, {
              key: "update",
              value: function update(e, t) {
                return this.table.patchByIdx(e, t);
              }
            }]);
            return _class20;
          }(), t.InMemorySessionsTable = /*#__PURE__*/function () {
            function _class21() {
              _classCallCheck(this, _class21);
              this.data = [];
            }
            _createClass(_class21, [{
              key: "addIfMissing",
              value: function addIfMissing(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
                  return _regeneratorRuntime().wrap(function _callee28$(_context28) {
                    while (1) {
                      switch (_context28.prev = _context28.next) {
                        case 0:
                          this.data.some(function (t) {
                            return t.uuid === e.uuid;
                          }) || this.data.push(e);
                        case 1:
                        case "end":
                          return _context28.stop();
                      }
                    }
                  }, _callee28, this);
                }));
              }
            }, {
              key: "delete",
              value: function _delete(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
                  var t;
                  return _regeneratorRuntime().wrap(function _callee29$(_context29) {
                    while (1) {
                      switch (_context29.prev = _context29.next) {
                        case 0:
                          t = this.data.findIndex(function (t) {
                            return t.uuid === e;
                          });
                          -1 !== t && this.data.splice(t, 1);
                        case 2:
                        case "end":
                          return _context29.stop();
                      }
                    }
                  }, _callee29, this);
                }));
              }
            }, {
              key: "getAll",
              value: function getAll() {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
                  return _regeneratorRuntime().wrap(function _callee30$(_context30) {
                    while (1) {
                      switch (_context30.prev = _context30.next) {
                        case 0:
                          return _context30.abrupt("return", _toConsumableArray(this.data));
                        case 1:
                        case "end":
                          return _context30.stop();
                      }
                    }
                  }, _callee30, this);
                }));
              }
            }, {
              key: "update",
              value: function update(e, t) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
                  var r;
                  return _regeneratorRuntime().wrap(function _callee31$(_context31) {
                    while (1) {
                      switch (_context31.prev = _context31.next) {
                        case 0:
                          r = this.data.findIndex(function (t) {
                            return t.uuid === e;
                          });
                          -1 !== r && (this.data[r] = Object.assign(Object.assign({}, this.data[r]), t));
                        case 2:
                        case "end":
                          return _context31.stop();
                      }
                    }
                  }, _callee31, this);
                }));
              }
            }]);
            return _class21;
          }();
        },
        7967: function _(e, t) {
          "use strict";

          var r = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Table = void 0, t.Table = /*#__PURE__*/function () {
            function _class22(e, t) {
              _classCallCheck(this, _class22);
              this.dbPromise = e, this.store = t;
            }
            _createClass(_class22, [{
              key: "add",
              value: function add(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
                  return _regeneratorRuntime().wrap(function _callee32$(_context32) {
                    while (1) {
                      switch (_context32.prev = _context32.next) {
                        case 0:
                          _context32.next = 2;
                          return this.dbPromise;
                        case 2:
                          _context32.next = 4;
                          return _context32.sent.add(this.store, e);
                        case 4:
                        case "end":
                          return _context32.stop();
                      }
                    }
                  }, _callee32, this);
                }));
              }
            }, {
              key: "clear",
              value: function clear() {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
                  return _regeneratorRuntime().wrap(function _callee33$(_context33) {
                    while (1) {
                      switch (_context33.prev = _context33.next) {
                        case 0:
                          _context33.next = 2;
                          return this.dbPromise;
                        case 2:
                          _context33.next = 4;
                          return _context33.sent.clear(this.store);
                        case 4:
                        case "end":
                          return _context33.stop();
                      }
                    }
                  }, _callee33, this);
                }));
              }
            }, {
              key: "countBy",
              value: function countBy(e, t) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
                  var r, n, o, _o, i;
                  return _regeneratorRuntime().wrap(function _callee34$(_context34) {
                    while (1) {
                      switch (_context34.prev = _context34.next) {
                        case 0:
                          _context34.next = 2;
                          return this.dbPromise;
                        case 2:
                          r = _context34.sent.transaction(this.store, "readonly");
                          o = 0;
                          if (!(e !== r.store.keyPath)) {
                            _context34.next = 11;
                            break;
                          }
                          _o = r.store.index(e), i = IDBKeyRange.only(t);
                          _context34.next = 8;
                          return _o.openCursor(i);
                        case 8:
                          n = _context34.sent;
                          _context34.next = 14;
                          break;
                        case 11:
                          _context34.next = 13;
                          return r.store.openCursor(IDBKeyRange.only(t));
                        case 13:
                          n = _context34.sent;
                        case 14:
                          if (!n) {
                            _context34.next = 21;
                            break;
                          }
                          o++;
                          _context34.next = 18;
                          return n.continue();
                        case 18:
                          n = _context34.sent;
                        case 19:
                          _context34.next = 14;
                          break;
                        case 21:
                          return _context34.abrupt("return", o);
                        case 22:
                        case "end":
                          return _context34.stop();
                      }
                    }
                  }, _callee34, this);
                }));
              }
            }, {
              key: "deleteBatch",
              value: function deleteBatch(e, t, n) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
                  var r, o, i, _e6, _t5;
                  return _regeneratorRuntime().wrap(function _callee35$(_context35) {
                    while (1) {
                      switch (_context35.prev = _context35.next) {
                        case 0:
                          _context35.next = 2;
                          return this.dbPromise;
                        case 2:
                          r = _context35.sent.transaction(this.store, "readwrite");
                          i = 0;
                          if (!n) {
                            _context35.next = 17;
                            break;
                          }
                          if (!(n[0] !== r.store.keyPath)) {
                            _context35.next = 12;
                            break;
                          }
                          _e6 = r.store.index(n[0]), _t5 = IDBKeyRange.only(n[1]);
                          _context35.next = 9;
                          return _e6.openCursor(_t5);
                        case 9:
                          o = _context35.sent;
                          _context35.next = 15;
                          break;
                        case 12:
                          _context35.next = 14;
                          return r.store.openCursor(IDBKeyRange.only(n[1]));
                        case 14:
                          o = _context35.sent;
                        case 15:
                          _context35.next = 20;
                          break;
                        case 17:
                          _context35.next = 19;
                          return r.store.openCursor();
                        case 19:
                          o = _context35.sent;
                        case 20:
                          if (!(o && (i >= e && o.delete(), i++, i !== e + t))) {
                            _context35.next = 26;
                            break;
                          }
                          _context35.next = 23;
                          return o.continue();
                        case 23:
                          o = _context35.sent;
                        case 24:
                          _context35.next = 20;
                          break;
                        case 26:
                        case "end":
                          return _context35.stop();
                      }
                    }
                  }, _callee35, this);
                }));
              }
            }, {
              key: "deleteByIdx",
              value: function deleteByIdx(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
                  return _regeneratorRuntime().wrap(function _callee36$(_context36) {
                    while (1) {
                      switch (_context36.prev = _context36.next) {
                        case 0:
                          _context36.next = 2;
                          return this.dbPromise;
                        case 2:
                          return _context36.abrupt("return", _context36.sent.delete(this.store, e));
                        case 3:
                        case "end":
                          return _context36.stop();
                      }
                    }
                  }, _callee36, this);
                }));
              }
            }, {
              key: "getAll",
              value: function getAll() {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
                  return _regeneratorRuntime().wrap(function _callee37$(_context37) {
                    while (1) {
                      switch (_context37.prev = _context37.next) {
                        case 0:
                          _context37.next = 2;
                          return this.dbPromise;
                        case 2:
                          return _context37.abrupt("return", _context37.sent.getAll(this.store));
                        case 3:
                        case "end":
                          return _context37.stop();
                      }
                    }
                  }, _callee37, this);
                }));
              }
            }, {
              key: "getBatch",
              value: function getBatch(e, t) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
                  var r, n, o, i, s;
                  return _regeneratorRuntime().wrap(function _callee38$(_context38) {
                    while (1) {
                      switch (_context38.prev = _context38.next) {
                        case 0:
                          _context38.next = 2;
                          return this.dbPromise;
                        case 2:
                          r = _context38.sent.transaction(this.store, "readonly").store.index("sessionUUID");
                          n = IDBKeyRange.only(e);
                          _context38.next = 6;
                          return r.openCursor(n);
                        case 6:
                          o = _context38.sent;
                          i = [];
                          s = 0;
                        case 9:
                          if (!(o && (i.push(o.value), s++, s !== t))) {
                            _context38.next = 15;
                            break;
                          }
                          _context38.next = 12;
                          return o.continue();
                        case 12:
                          o = _context38.sent;
                        case 13:
                          _context38.next = 9;
                          break;
                        case 15:
                          return _context38.abrupt("return", i);
                        case 16:
                        case "end":
                          return _context38.stop();
                      }
                    }
                  }, _callee38, this);
                }));
              }
            }, {
              key: "patchByIdx",
              value: function patchByIdx(e, t) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
                  var r, n;
                  return _regeneratorRuntime().wrap(function _callee39$(_context39) {
                    while (1) {
                      switch (_context39.prev = _context39.next) {
                        case 0:
                          _context39.next = 2;
                          return this.dbPromise;
                        case 2:
                          r = _context39.sent.transaction(this.store, "readwrite");
                          _context39.next = 5;
                          return r.store.get(e);
                        case 5:
                          n = _context39.sent;
                          _context39.next = 8;
                          return r.store.put(Object.assign(Object.assign({}, n), t));
                        case 8:
                        case "end":
                          return _context39.stop();
                      }
                    }
                  }, _callee39, this);
                }));
              }
            }]);
            return _class22;
          }();
        },
        8955: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Device = void 0;
          var n = r(8177);
          t.Device = /*#__PURE__*/function () {
            function _class23(e, t, r, n) {
              _classCallCheck(this, _class23);
              this.browser = e, this.localStorage = t, this.sdkVersion = r, this.uuidFactory = n;
            }
            _createClass(_class23, [{
              key: "getDeviceData",
              value: function getDeviceData() {
                var e = this.localStorage.getItem(n.LocalStorageKey.DeviceData);
                return null === e && (e = "{}"), JSON.parse(e);
              }
            }, {
              key: "getInfo",
              value: function getInfo(e) {
                return {
                  udid: this.getUDID(),
                  name: e.deviceName,
                  device_type: "",
                  firebase_test_lab: !1,
                  key_values: this.getDeviceData(),
                  language: this.browser.getLanguage(),
                  os_version: this.browser.getOSVersion(),
                  sdk_type: "web",
                  sdk_version: this.sdkVersion.toString(),
                  build: e.build,
                  version: e.version
                };
              }
            }, {
              key: "getUDID",
              value: function getUDID() {
                var e = this.localStorage.getItem(n.LocalStorageKey.DeviceUDID);
                return null === e && (e = this.uuidFactory.create(), this.localStorage.setItem(n.LocalStorageKey.DeviceUDID, e)), e;
              }
            }, {
              key: "setDeviceKey",
              value: function setDeviceKey(e, t) {
                var r = this.getDeviceData();
                null === t ? delete r[e] : r[e] = t, this.localStorage.setItem(n.LocalStorageKey.DeviceData, JSON.stringify(r));
              }
            }]);
            return _class23;
          }();
        },
        2485: function _(e, t, r) {
          "use strict";

          var n = this && this.__decorate || function (e, t, r, n) {
              var o,
                i = arguments.length,
                s = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
              if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t, r, n);else for (var a = e.length - 1; a >= 0; a--) {
                (o = e[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(t, r, s) : o(t, r)) || s);
              }
              return i > 3 && s && Object.defineProperty(t, r, s), s;
            },
            o = this && this.__metadata || function (e, t) {
              if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
            },
            i = this && this.__awaiter || function (e, t, r, n) {
              return new (r || (r = Promise))(function (o, i) {
                function s(e) {
                  try {
                    c(n.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function a(e) {
                  try {
                    c(n.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function c(e) {
                  var t;
                  e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                    e(t);
                  })).then(s, a);
                }
                c((n = n.apply(e, t || [])).next());
              });
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.APIFeatureDetection = void 0;
          var s = r(8593),
            a = new Map(),
            c = (0, s.CacheDecoratorFactory)(a);
          var u = /*#__PURE__*/function () {
            function u(e, t, r, n, o) {
              _classCallCheck(this, u);
              this.indexedDB = e, this.localStorage = t, this.sessionStorage = r, this.broadcastChannel = n, this.worker = o;
            }
            _createClass(u, [{
              key: "isBroadcastChannelSupported",
              value: function isBroadcastChannelSupported() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
                  return _regeneratorRuntime().wrap(function _callee40$(_context40) {
                    while (1) {
                      switch (_context40.prev = _context40.next) {
                        case 0:
                          _context40.t1 = "function" == typeof this.broadcastChannel;
                          if (_context40.t1) {
                            _context40.next = 5;
                            break;
                          }
                          _context40.next = 4;
                          return this.isIndexedDBSupported();
                        case 4:
                          _context40.t1 = _context40.sent;
                        case 5:
                          _context40.t0 = _context40.t1;
                          if (_context40.t0) {
                            _context40.next = 8;
                            break;
                          }
                          _context40.t0 = this.isLocalStorageSupported();
                        case 8:
                          return _context40.abrupt("return", _context40.t0);
                        case 9:
                        case "end":
                          return _context40.stop();
                      }
                    }
                  }, _callee40, this);
                }));
              }
            }, {
              key: "isIndexedDBSupported",
              value: function isIndexedDBSupported() {
                var _this10 = this;
                return new Promise(function (e, t) {
                  var r = _this10.indexedDB.open("bf_sdk_test");
                  r.onerror = function () {
                    return e(!1);
                  }, r.onsuccess = function () {
                    e(!0), r.result.close();
                  };
                });
              }
            }, {
              key: "isLocalStorageSupported",
              value: function isLocalStorageSupported() {
                return this.isStorageSupported(this.localStorage);
              }
            }, {
              key: "isSessionStorageSupported",
              value: function isSessionStorageSupported() {
                return this.isStorageSupported(this.sessionStorage);
              }
            }, {
              key: "isWorkerSupported",
              value: function isWorkerSupported() {
                return !!this.worker;
              }
            }, {
              key: "isStorageSupported",
              value: function isStorageSupported(e) {
                try {
                  var _t6 = "Bf8taM%GhLkg";
                  return e.setItem(_t6, _t6), e.removeItem(_t6), !0;
                } catch (e) {
                  return !1;
                }
              }
            }]);
            return u;
          }();
          n([c(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], u.prototype, "isBroadcastChannelSupported", null), n([c(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], u.prototype, "isIndexedDBSupported", null), n([c(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Boolean)], u.prototype, "isLocalStorageSupported", null), n([c(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Boolean)], u.prototype, "isSessionStorageSupported", null), n([c(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Boolean)], u.prototype, "isWorkerSupported", null), t.APIFeatureDetection = u;
        },
        3095: function _(e, t) {
          "use strict";

          var r,
            n = this && this.__awaiter || function (e, t, r, n) {
              return new (r || (r = Promise))(function (o, i) {
                function s(e) {
                  try {
                    c(n.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function a(e) {
                  try {
                    c(n.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function c(e) {
                  var t;
                  e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                    e(t);
                  })).then(s, a);
                }
                c((n = n.apply(e, t || [])).next());
              });
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.OperationModes = t.OperationMode = void 0, function (e) {
            e.A = "A", e.B = "B", e.C = "C";
          }(r = t.OperationMode || (t.OperationMode = {})), t.OperationModes = /*#__PURE__*/function () {
            function _class24(e) {
              _classCallCheck(this, _class24);
              this.apiFeatures = e;
            }
            _createClass(_class24, [{
              key: "hasLeaderElection",
              value: function hasLeaderElection() {
                return this.apiFeatures.isBroadcastChannelSupported();
              }
            }, {
              key: "hasSharedDB",
              value: function hasSharedDB() {
                return this.apiFeatures.isIndexedDBSupported();
              }
            }, {
              key: "hasSharedDeviceInfo",
              value: function hasSharedDeviceInfo() {
                return this.apiFeatures.isLocalStorageSupported();
              }
            }, {
              key: "getMode",
              value: function getMode() {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
                  var _yield$Promise$all, _yield$Promise$all2, e, t;
                  return _regeneratorRuntime().wrap(function _callee41$(_context41) {
                    while (1) {
                      switch (_context41.prev = _context41.next) {
                        case 0:
                          _context41.next = 2;
                          return Promise.all([this.isMultiTab(), this.isMultiThread()]);
                        case 2:
                          _yield$Promise$all = _context41.sent;
                          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                          e = _yield$Promise$all2[0];
                          t = _yield$Promise$all2[1];
                          return _context41.abrupt("return", e ? t ? r.A : r.B : r.C);
                        case 7:
                        case "end":
                          return _context41.stop();
                      }
                    }
                  }, _callee41, this);
                }));
              }
            }, {
              key: "isMultiTab",
              value: function isMultiTab() {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
                  return _regeneratorRuntime().wrap(function _callee42$(_context42) {
                    while (1) {
                      switch (_context42.prev = _context42.next) {
                        case 0:
                          _context42.next = 2;
                          return this.hasLeaderElection();
                        case 2:
                          _context42.t1 = _context42.sent;
                          if (!_context42.t1) {
                            _context42.next = 7;
                            break;
                          }
                          _context42.next = 6;
                          return this.hasSharedDB();
                        case 6:
                          _context42.t1 = _context42.sent;
                        case 7:
                          _context42.t0 = _context42.t1;
                          if (!_context42.t0) {
                            _context42.next = 10;
                            break;
                          }
                          _context42.t0 = this.hasSharedDeviceInfo();
                        case 10:
                          return _context42.abrupt("return", _context42.t0);
                        case 11:
                        case "end":
                          return _context42.stop();
                      }
                    }
                  }, _callee42, this);
                }));
              }
            }, {
              key: "isMultiThread",
              value: function isMultiThread() {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
                  return _regeneratorRuntime().wrap(function _callee43$(_context43) {
                    while (1) {
                      switch (_context43.prev = _context43.next) {
                        case 0:
                          _context43.next = 2;
                          return this.hasSharedDB();
                        case 2:
                          _context43.t0 = _context43.sent;
                          if (!_context43.t0) {
                            _context43.next = 5;
                            break;
                          }
                          _context43.t0 = this.apiFeatures.isWorkerSupported();
                        case 5:
                          return _context43.abrupt("return", _context43.t0);
                        case 6:
                        case "end":
                          return _context43.stop();
                      }
                    }
                  }, _callee43, this);
                }));
              }
            }]);
            return _class24;
          }();
        },
        9075: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.HttpClient = void 0, t.HttpClient = /*#__PURE__*/function () {
            function _class25(e, t, r) {
              _classCallCheck(this, _class25);
              this.apiURL = e, this.appKey = t, this.sdkUserAgent = r;
            }
            _createClass(_class25, [{
              key: "post",
              value: function post(e, t) {
                var r = new XMLHttpRequest();
                return r.open("POST", this.apiURL + e), r.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), r.setRequestHeader("X-User-Agent", this.sdkUserAgent), r.setRequestHeader("X-App-Token", this.appKey), new Promise(function (e, n) {
                  r.onreadystatechange = function () {
                    4 === r.readyState && (200 !== r.status && 304 !== r.status ? n() : e(JSON.parse(r.responseText)));
                  }, r.send(JSON.stringify(t));
                });
              }
            }]);
            return _class25;
          }();
        },
        8572: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.LogFactory = void 0;
          var n = r(7431);
          t.LogFactory = /*#__PURE__*/function () {
            function _class26() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32e3;
              _classCallCheck(this, _class26);
              this.maxLogLength = e;
            }
            _createClass(_class26, [{
              key: "createFromDeviceKey",
              value: function createFromDeviceKey(e, t, r, n) {
                return this.createFromEntry({
                  tag: "bf_key_value",
                  text: "Set device data \"".concat(e, "\"=\"").concat(t, "\"")
                }, r, n);
              }
            }, {
              key: "createFromEntry",
              value: function createFromEntry(e, t, r) {
                var o, i, s, a, c, u, l, d, f, p;
                var h = null !== (o = e.text) && void 0 !== o ? o : "";
                return h.length >= this.maxLogLength && (h = h.substring(0, this.maxLogLength) + "…"), {
                  x: r.iso,
                  t: h,
                  m: null !== (s = null !== (i = e.method) && void 0 !== i ? i : t.method) && void 0 !== s ? s : "",
                  at: r.epoch,
                  tg: null !== (a = e.tag) && void 0 !== a ? a : "",
                  f: null !== (u = null !== (c = e.file) && void 0 !== c ? c : t.file) && void 0 !== u ? u : "",
                  l: null !== (d = null !== (l = e.line) && void 0 !== l ? l : t.line) && void 0 !== d ? d : 0,
                  ll: null !== (f = e.level) && void 0 !== f ? f : n.LogLevel.Debug,
                  u: null !== (p = e.url) && void 0 !== p ? p : ""
                };
              }
            }, {
              key: "createFromIssue",
              value: function createFromIssue(e, t, r) {
                return this.createFromEntry({
                  level: n.LogLevel.Error,
                  tag: "bf_issue",
                  text: e
                }, t, r);
              }
            }, {
              key: "createGapLog",
              value: function createGapLog(e) {
                var t = JSON.stringify({
                  bf_start_date: e[0].at,
                  bf_end_date: e[e.length - 1].at
                });
                return {
                  x: e[0].x,
                  t: t,
                  m: "",
                  at: e[0].at,
                  tg: "bf_gap_log",
                  f: "",
                  l: 0,
                  ll: 0,
                  u: e[0].u
                };
              }
            }]);
            return _class26;
          }();
        },
        5473: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.NoopLogger = t.ConsoleLogger = void 0;
          var r = /*#__PURE__*/function () {
            function r(e, t) {
              _classCallCheck(this, r);
              this.console = e, this.tag = t;
            }
            _createClass(r, [{
              key: "error",
              value: function error(e, t) {
                e = "[BF-SDK]".concat(this.tag ? "[".concat(this.tag, "] ") : "").concat(e), t ? this.console.log(e, t) : this.console.log(e);
              }
            }, {
              key: "getTagged",
              value: function getTagged(e) {
                return new r(this.console, e);
              }
            }, {
              key: "log",
              value: function log(e, t) {
                e = "[BF-SDK]".concat(this.tag ? "[".concat(this.tag, "] ") : "").concat(e), t ? this.console.log(e, t) : this.console.log(e);
              }
            }]);
            return r;
          }();
          t.ConsoleLogger = r;
          var n = /*#__PURE__*/function () {
            function n() {
              _classCallCheck(this, n);
            }
            _createClass(n, [{
              key: "error",
              value: function error() {}
            }, {
              key: "getTagged",
              value: function getTagged() {
                return new n();
              }
            }, {
              key: "log",
              value: function log() {}
            }]);
            return n;
          }();
          t.NoopLogger = n;
        },
        7935: function _(e, t, r) {
          "use strict";

          var n = this && this.__decorate || function (e, t, r, n) {
              var o,
                i = arguments.length,
                s = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
              if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t, r, n);else for (var a = e.length - 1; a >= 0; a--) {
                (o = e[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(t, r, s) : o(t, r)) || s);
              }
              return i > 3 && s && Object.defineProperty(t, r, s), s;
            },
            o = this && this.__metadata || function (e, t) {
              if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
            },
            i = this && this.__awaiter || function (e, t, r, n) {
              return new (r || (r = Promise))(function (o, i) {
                function s(e) {
                  try {
                    c(n.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function a(e) {
                  try {
                    c(n.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function c(e) {
                  var t;
                  e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                    e(t);
                  })).then(s, a);
                }
                c((n = n.apply(e, t || [])).next());
              });
            },
            s = this && this.__importDefault || function (e) {
              return e && e.__esModule ? e : {
                default: e
              };
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.MainProvider = void 0;
          var a = r(7431),
            c = r(1562),
            u = r(2329),
            l = r(277),
            d = r(5881),
            f = r(6110),
            p = r(6871),
            h = r(3256),
            y = r(6422),
            g = r(7967),
            v = r(1177),
            b = r(8808),
            m = r(7941),
            S = r(3856),
            w = r(253),
            _ = r(8955),
            O = r(9075),
            E = r(8572),
            P = r(5473),
            A = r(6105),
            I = r(7273),
            M = r(1310),
            D = r(3103),
            j = r(5041),
            x = r(6693),
            T = r(84),
            k = r(8593),
            L = s(r(4657)),
            B = r(4319),
            F = new Map(),
            C = (0, k.CacheDecoratorFactory)(F);
          var R = /*#__PURE__*/function () {
            function R(e, t, r, n) {
              _classCallCheck(this, R);
              this.options = e, this.preInitProvider = t, this.sdkUserAgent = r, this.version = n, this.apiFeatures = this.preInitProvider.provideAPIFeatureDetection(), this.commandsQueue = this.preInitProvider.provideCommandsQueue(), this.console = this.preInitProvider.provideWindow().console, this.operationModes = this.preInitProvider.provideOperationModes(), this.uuidFactory = this.preInitProvider.provideUUIDFactory(), this.window = this.preInitProvider.provideWindow();
            }
            _createClass(R, [{
              key: "getApiClient",
              value: function getApiClient() {
                var e = new O.HttpClient(this.options.apiURL, this.options.appKey, this.sdkUserAgent);
                return new c.ApiClient(this.options.appKey, e);
              }
            }, {
              key: "getChannel",
              value: function getChannel() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
                  var e;
                  return _regeneratorRuntime().wrap(function _callee44$(_context44) {
                    while (1) {
                      switch (_context44.prev = _context44.next) {
                        case 0:
                          _context44.next = 2;
                          return this.operationModes.isMultiTab();
                        case 2:
                          if (!_context44.sent) {
                            _context44.next = 6;
                            break;
                          }
                          _context44.t0 = new f.Channel((0, f.createBroadcastChannel)(), this.getLogger("Channel"));
                          _context44.next = 7;
                          break;
                        case 6:
                          _context44.t0 = new f.MonoChannel();
                        case 7:
                          e = _context44.t0;
                          this.getCurrentSession().then(function (t) {
                            e.setCurrentSession(t);
                          });
                          return _context44.abrupt("return", e);
                        case 10:
                        case "end":
                          return _context44.stop();
                      }
                    }
                  }, _callee44, this);
                }));
              }
            }, {
              key: "getConnection",
              value: function getConnection() {
                return new p.Connection(this.window);
              }
            }, {
              key: "getCurrentSession",
              value: function getCurrentSession() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
                  return _regeneratorRuntime().wrap(function _callee45$(_context45) {
                    while (1) {
                      switch (_context45.prev = _context45.next) {
                        case 0:
                          _context45.t0 = h.CurrentSession;
                          _context45.t1 = this.getDevice();
                          _context45.t2 = this.getLogger("CurrentSession");
                          _context45.t3 = this.getSessionStorage();
                          _context45.next = 6;
                          return this.getSessionsTable();
                        case 6:
                          _context45.t4 = _context45.sent;
                          _context45.t5 = this.uuidFactory;
                          return _context45.abrupt("return", new _context45.t0(_context45.t1, _context45.t2, _context45.t3, _context45.t4, _context45.t5));
                        case 9:
                        case "end":
                          return _context45.stop();
                      }
                    }
                  }, _callee45, this);
                }));
              }
            }, {
              key: "getDatabase",
              value: function getDatabase() {
                return new y.Database();
              }
            }, {
              key: "getDevice",
              value: function getDevice() {
                return new _.Device(this.preInitProvider.provideBrowser(), this.getLocalStorage(), this.version, this.uuidFactory);
              }
            }, {
              key: "getInitDeferred",
              value: function getInitDeferred() {
                return (0, k.createDeferred)();
              }
            }, {
              key: "getDeviceKeysTable",
              value: function getDeviceKeysTable() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
                  return _regeneratorRuntime().wrap(function _callee46$(_context46) {
                    while (1) {
                      switch (_context46.prev = _context46.next) {
                        case 0:
                          _context46.next = 2;
                          return this.operationModes.isMultiTab();
                        case 2:
                          if (!_context46.sent) {
                            _context46.next = 6;
                            break;
                          }
                          _context46.t0 = new v.IDBDeviceKeysTable(new g.Table(this.getDatabase().get(), "devicekeys"));
                          _context46.next = 7;
                          break;
                        case 6:
                          _context46.t0 = new v.InMemoryDeviceKeysTable();
                        case 7:
                          return _context46.abrupt("return", _context46.t0);
                        case 8:
                        case "end":
                          return _context46.stop();
                      }
                    }
                  }, _callee46, this);
                }));
              }
            }, {
              key: "getIssuesTable",
              value: function getIssuesTable() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
                  return _regeneratorRuntime().wrap(function _callee47$(_context47) {
                    while (1) {
                      switch (_context47.prev = _context47.next) {
                        case 0:
                          _context47.next = 2;
                          return this.operationModes.isMultiTab();
                        case 2:
                          if (!_context47.sent) {
                            _context47.next = 6;
                            break;
                          }
                          _context47.t0 = new m.IDBIssuesTable(new g.Table(this.getDatabase().get(), "issues"));
                          _context47.next = 7;
                          break;
                        case 6:
                          _context47.t0 = new m.InMemoryIssuesTable();
                        case 7:
                          return _context47.abrupt("return", _context47.t0);
                        case 8:
                        case "end":
                          return _context47.stop();
                      }
                    }
                  }, _callee47, this);
                }));
              }
            }, {
              key: "getLogger",
              value: function getLogger(e) {
                return this.options.debug ? new P.ConsoleLogger(this.console, e) : new P.NoopLogger();
              }
            }, {
              key: "getLogsTable",
              value: function getLogsTable() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
                  return _regeneratorRuntime().wrap(function _callee48$(_context48) {
                    while (1) {
                      switch (_context48.prev = _context48.next) {
                        case 0:
                          _context48.next = 2;
                          return this.operationModes.isMultiTab();
                        case 2:
                          if (!_context48.sent) {
                            _context48.next = 6;
                            break;
                          }
                          _context48.t0 = new S.IDBLogsTable(new g.Table(this.getDatabase().get(), "logs"), new E.LogFactory());
                          _context48.next = 7;
                          break;
                        case 6:
                          _context48.t0 = new S.InMemoryLogsTable(new E.LogFactory(), 3e3);
                        case 7:
                          return _context48.abrupt("return", _context48.t0);
                        case 8:
                        case "end":
                          return _context48.stop();
                      }
                    }
                  }, _callee48, this);
                }));
              }
            }, {
              key: "getOverrideConsoleMethods",
              value: function getOverrideConsoleMethods() {
                return new u.OverrideConsoleMethods(this.commandsQueue, this.window);
              }
            }, {
              key: "getPrintToConsole",
              value: function getPrintToConsole() {
                return new a.PrintToConsole(this.console);
              }
            }, {
              key: "getRegisterBrowserEventsHandler",
              value: function getRegisterBrowserEventsHandler() {
                return new l.RegisterBrowserEventsHandler(this.commandsQueue, this.window);
              }
            }, {
              key: "getRegisterErrorHandler",
              value: function getRegisterErrorHandler() {
                return new a.RegisterErrorHandler(this.window);
              }
            }, {
              key: "getRegisterUIEventsHandler",
              value: function getRegisterUIEventsHandler() {
                return new d.RegisterUIEventsHandler(this.commandsQueue, this.window);
              }
            }, {
              key: "getResetStorage",
              value: function getResetStorage() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
                  return _regeneratorRuntime().wrap(function _callee49$(_context49) {
                    while (1) {
                      switch (_context49.prev = _context49.next) {
                        case 0:
                          _context49.t0 = A.ResetStorage;
                          _context49.t1 = this.apiFeatures;
                          _context49.next = 4;
                          return this.getCurrentSession();
                        case 4:
                          _context49.t2 = _context49.sent;
                          _context49.t3 = this.getDatabase();
                          _context49.t4 = this.getLocalStorage();
                          _context49.t5 = this.getSessionStorage();
                          return _context49.abrupt("return", new _context49.t0(_context49.t1, _context49.t2, _context49.t3, _context49.t4, _context49.t5));
                        case 9:
                        case "end":
                          return _context49.stop();
                      }
                    }
                  }, _callee49, this);
                }));
              }
            }, {
              key: "getStorageGuard",
              value: function getStorageGuard() {
                return new M.StorageGuard(this.getApiClient(), this.getDevice(), this.getLogger("StorageGuard"), this.options);
              }
            }, {
              key: "getStorageProcessor",
              value: function getStorageProcessor() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
                  var e;
                  return _regeneratorRuntime().wrap(function _callee50$(_context50) {
                    while (1) {
                      switch (_context50.prev = _context50.next) {
                        case 0:
                          e = new I.SessionFactory(this.getDevice(), this.version, this.window);
                          _context50.t0 = D.StorageProcessor;
                          _context50.t1 = this.getApiClient();
                          _context50.next = 5;
                          return this.getChannel();
                        case 5:
                          _context50.t2 = _context50.sent;
                          _context50.t3 = this.getConnection();
                          _context50.t4 = this.getLogger("StorageProcessor");
                          _context50.t5 = this.getDevice();
                          _context50.next = 11;
                          return this.getDeviceKeysTable();
                        case 11:
                          _context50.t6 = _context50.sent;
                          _context50.next = 14;
                          return this.getIssuesTable();
                        case 14:
                          _context50.t7 = _context50.sent;
                          _context50.next = 17;
                          return this.getLogsTable();
                        case 17:
                          _context50.t8 = _context50.sent;
                          _context50.t9 = this.options;
                          _context50.t10 = e;
                          _context50.next = 22;
                          return this.getSessionsTable();
                        case 22:
                          _context50.t11 = _context50.sent;
                          _context50.next = 25;
                          return this.getStorageGuard();
                        case 25:
                          _context50.t12 = _context50.sent;
                          return _context50.abrupt("return", new _context50.t0(_context50.t1, _context50.t2, _context50.t3, _context50.t4, _context50.t5, _context50.t6, _context50.t7, _context50.t8, _context50.t9, _context50.t10, _context50.t11, _context50.t12));
                        case 27:
                        case "end":
                          return _context50.stop();
                      }
                    }
                  }, _callee50, this);
                }));
              }
            }, {
              key: "getStorageWriterHub",
              value: function getStorageWriterHub() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
                  var e;
                  return _regeneratorRuntime().wrap(function _callee51$(_context51) {
                    while (1) {
                      switch (_context51.prev = _context51.next) {
                        case 0:
                          _context51.next = 2;
                          return this.operationModes.isMultiThread();
                        case 2:
                          if (!_context51.sent) {
                            _context51.next = 6;
                            break;
                          }
                          _context51.t0 = new L.default();
                          _context51.next = 20;
                          break;
                        case 6:
                          _context51.t1 = x.MainThreadStorageWriterHandler;
                          _context51.t2 = j.StorageWriter;
                          _context51.next = 10;
                          return this.getDeviceKeysTable();
                        case 10:
                          _context51.t3 = _context51.sent;
                          _context51.next = 13;
                          return this.getIssuesTable();
                        case 13:
                          _context51.t4 = _context51.sent;
                          _context51.t5 = new E.LogFactory();
                          _context51.next = 17;
                          return this.getLogsTable();
                        case 17:
                          _context51.t6 = _context51.sent;
                          _context51.t7 = new _context51.t2(_context51.t3, _context51.t4, _context51.t5, _context51.t6);
                          _context51.t0 = new _context51.t1(_context51.t7);
                        case 20:
                          e = _context51.t0;
                          _context51.t8 = T.StorageWriterHub;
                          _context51.next = 24;
                          return this.getChannel();
                        case 24:
                          _context51.t9 = _context51.sent;
                          _context51.t10 = this.getDevice();
                          _context51.t11 = e;
                          _context51.t12 = new B.EventPrinter(this.console, this.options.printToConsole);
                          _context51.t13 = this.options;
                          _context51.t14 = this.getPrintToConsole();
                          _context51.next = 32;
                          return this.getCurrentSession();
                        case 32:
                          _context51.t15 = _context51.sent;
                          _context51.next = 35;
                          return this.getStorageGuard();
                        case 35:
                          _context51.t16 = _context51.sent;
                          _context51.t17 = this.uuidFactory;
                          _context51.t18 = this.window;
                          return _context51.abrupt("return", new _context51.t8(_context51.t9, _context51.t10, _context51.t11, _context51.t12, _context51.t13, _context51.t14, _context51.t15, _context51.t16, _context51.t17, _context51.t18));
                        case 39:
                        case "end":
                          return _context51.stop();
                      }
                    }
                  }, _callee51, this);
                }));
              }
            }, {
              key: "getLocalStorage",
              value: function getLocalStorage() {
                return this.apiFeatures.isLocalStorageSupported() ? this.window.localStorage : new b.InMemoryStorage();
              }
            }, {
              key: "getSessionStorage",
              value: function getSessionStorage() {
                return this.apiFeatures.isSessionStorageSupported() ? this.window.sessionStorage : new b.InMemoryStorage();
              }
            }, {
              key: "getSessionsTable",
              value: function getSessionsTable() {
                return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
                  return _regeneratorRuntime().wrap(function _callee52$(_context52) {
                    while (1) {
                      switch (_context52.prev = _context52.next) {
                        case 0:
                          _context52.next = 2;
                          return this.operationModes.isMultiTab();
                        case 2:
                          if (!_context52.sent) {
                            _context52.next = 6;
                            break;
                          }
                          _context52.t0 = new w.IDBSessionsTable(new g.Table(this.getDatabase().get(), "sessions"));
                          _context52.next = 7;
                          break;
                        case 6:
                          _context52.t0 = new w.InMemorySessionsTable();
                        case 7:
                          return _context52.abrupt("return", _context52.t0);
                        case 8:
                        case "end":
                          return _context52.stop();
                      }
                    }
                  }, _callee52, this);
                }));
              }
            }]);
            return R;
          }();
          n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Object)], R.prototype, "getApiClient", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], R.prototype, "getChannel", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", p.Connection)], R.prototype, "getConnection", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], R.prototype, "getCurrentSession", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", y.Database)], R.prototype, "getDatabase", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Object)], R.prototype, "getDevice", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Object)], R.prototype, "getInitDeferred", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], R.prototype, "getDeviceKeysTable", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], R.prototype, "getIssuesTable", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], R.prototype, "getLogsTable", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", u.OverrideConsoleMethods)], R.prototype, "getOverrideConsoleMethods", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", a.PrintToConsole)], R.prototype, "getPrintToConsole", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", l.RegisterBrowserEventsHandler)], R.prototype, "getRegisterBrowserEventsHandler", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", a.RegisterErrorHandler)], R.prototype, "getRegisterErrorHandler", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", d.RegisterUIEventsHandler)], R.prototype, "getRegisterUIEventsHandler", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], R.prototype, "getResetStorage", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Object)], R.prototype, "getStorageGuard", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], R.prototype, "getStorageProcessor", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], R.prototype, "getStorageWriterHub", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Storage)], R.prototype, "getLocalStorage", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Storage)], R.prototype, "getSessionStorage", null), n([C(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Promise)], R.prototype, "getSessionsTable", null), t.MainProvider = R;
        },
        3758: function _(e, t, r) {
          "use strict";

          var n = this && this.__decorate || function (e, t, r, n) {
              var o,
                i = arguments.length,
                s = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
              if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.decorate) s = Reflect.decorate(e, t, r, n);else for (var a = e.length - 1; a >= 0; a--) {
                (o = e[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(t, r, s) : o(t, r)) || s);
              }
              return i > 3 && s && Object.defineProperty(t, r, s), s;
            },
            o = this && this.__metadata || function (e, t) {
              if ("object" == (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.PreInitProvider = void 0;
          var i = r(7722),
            s = r(1667),
            a = r(7442),
            c = r(2485),
            u = r(3095),
            l = r(7998),
            d = r(5925),
            f = r(7075),
            p = r(8593),
            h = r(6884),
            y = new Map(),
            g = (0, p.CacheDecoratorFactory)(y);
          var v = /*#__PURE__*/function () {
            function v(e) {
              _classCallCheck(this, v);
              this.window = e;
            }
            _createClass(v, [{
              key: "provideAPIFeatureDetection",
              value: function provideAPIFeatureDetection() {
                return new c.APIFeatureDetection(this.window.indexedDB, this.window.localStorage, this.window.sessionStorage, this.window.BroadcastChannel, this.window.Worker);
              }
            }, {
              key: "provideBrowser",
              value: function provideBrowser() {
                return new i.Browser(this.window);
              }
            }, {
              key: "provideCommandsQueue",
              value: function provideCommandsQueue() {
                return new a.CommandsQueue(new s.CallInfoFactory(), new d.Timer(), this.provideUUIDFactory());
              }
            }, {
              key: "provideOperationModes",
              value: function provideOperationModes() {
                return new u.OperationModes(this.provideAPIFeatureDetection());
              }
            }, {
              key: "provideSDKOptionsValidator",
              value: function provideSDKOptionsValidator() {
                return new l.SDKOptionsValidator(this.provideBrowser());
              }
            }, {
              key: "provideUserFeedback",
              value: function provideUserFeedback() {
                return new f.UserFeedback(this.provideCommandsQueue());
              }
            }, {
              key: "provideUUIDFactory",
              value: function provideUUIDFactory() {
                return new h.UUIDFactory();
              }
            }, {
              key: "provideWindow",
              value: function provideWindow() {
                return this.window;
              }
            }]);
            return v;
          }();
          n([g(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", c.APIFeatureDetection)], v.prototype, "provideAPIFeatureDetection", null), n([g(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Object)], v.prototype, "provideBrowser", null), n([g(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", a.CommandsQueue)], v.prototype, "provideCommandsQueue", null), n([g(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", u.OperationModes)], v.prototype, "provideOperationModes", null), n([g(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", l.SDKOptionsValidator)], v.prototype, "provideSDKOptionsValidator", null), n([g(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", f.UserFeedback)], v.prototype, "provideUserFeedback", null), n([g(), o("design:type", Function), o("design:paramtypes", []), o("design:returntype", Object)], v.prototype, "provideUUIDFactory", null), t.PreInitProvider = v;
        },
        6105: function _(e, t, r) {
          "use strict";

          var n = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.ResetStorage = void 0;
          var o = r(8177);
          t.ResetStorage = /*#__PURE__*/function () {
            function _class27(e, t, r, n, o) {
              _classCallCheck(this, _class27);
              this.apiFeatures = e, this.session = t, this.database = r, this.localStorage = n, this.sessionStorage = o;
            }
            _createClass(_class27, [{
              key: "resetIfAppChanged",
              value: function resetIfAppChanged(e) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
                  var _this11 = this;
                  var t, _e7, _t7, _e8;
                  return _regeneratorRuntime().wrap(function _callee53$(_context53) {
                    while (1) {
                      switch (_context53.prev = _context53.next) {
                        case 0:
                          t = this.localStorage.getItem(o.LocalStorageKey.AppID);
                          if (!(null !== t && t !== e)) {
                            _context53.next = 14;
                            break;
                          }
                          _e7 = [o.LocalStorageKey.AppID, o.LocalStorageKey.DeviceData, o.LocalStorageKey.DeviceUDID], _t7 = [o.SessionStorageKey.SessionUDID, o.SessionStorageKey.SessionUUID];
                          _e7.forEach(function (e) {
                            return _this11.localStorage.removeItem(e);
                          });
                          _t7.forEach(function (e) {
                            return _this11.sessionStorage.removeItem(e);
                          });
                          this.session.reset();
                          _context53.next = 8;
                          return this.apiFeatures.isIndexedDBSupported();
                        case 8:
                          if (!_context53.sent) {
                            _context53.next = 14;
                            break;
                          }
                          _context53.next = 11;
                          return this.database.get();
                        case 11:
                          _e8 = _context53.sent;
                          _context53.next = 14;
                          return Promise.all([_e8.clear("devicekeys"), _e8.clear("issues"), _e8.clear("logs"), _e8.clear("sessions")]);
                        case 14:
                          this.localStorage.setItem(o.LocalStorageKey.AppID, e);
                        case 15:
                        case "end":
                          return _context53.stop();
                      }
                    }
                  }, _callee53, this);
                }));
              }
            }]);
            return _class27;
          }();
        },
        7998: function _(e, t, r) {
          "use strict";

          var n = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.SDKOptionsValidator = void 0;
          var o = n(r(6177)),
            i = r(2023),
            s = r(7431);
          t.SDKOptionsValidator = /*#__PURE__*/function () {
            function _class28(e) {
              _classCallCheck(this, _class28);
              this.browser = e, this.rules = {
                appKey: ["required", "string"],
                apiURL: ["string", "url"],
                build: ["string"],
                baseURL: ["string", "url"],
                debug: ["boolean"],
                deviceName: ["string"],
                overrideConsoleMethods: ["boolean"],
                printToConsole: ["boolean"],
                logBrowserEvents: ["boolean"],
                logUIEvents: ["boolean"],
                registerErrorHandler: ["boolean"],
                version: ["string"]
              };
            }
            _createClass(_class28, [{
              key: "init",
              value: function init(e) {
                return e = (0, s.prepareOptions)(e), (0, s.validate)(e, this.rules), Object.assign({
                  appID: o.default.encode(i.sha256.array(e.appKey)).substring(0, 10),
                  apiURL: "https://api.bugfender.com",
                  baseURL: "https://dashboard.bugfender.com",
                  debug: !1,
                  deviceName: this.browser.getDeviceName(),
                  overrideConsoleMethods: !0,
                  printToConsole: !0,
                  logBrowserEvents: !0,
                  logUIEvents: !0,
                  registerErrorHandler: !0,
                  version: "0.0.0",
                  build: "0"
                }, e);
              }
            }]);
            return _class28;
          }();
        },
        7273: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.SessionFactory = void 0, t.SessionFactory = /*#__PURE__*/function () {
            function _class29(e, t, r) {
              _classCallCheck(this, _class29);
              this.device = e, this.sdkVersion = t, this.window = r;
            }
            _createClass(_class29, [{
              key: "create",
              value: function create(e, t) {
                return {
                  device: this.device.getInfo(t),
                  orientation: 0,
                  batteryLevel: -1,
                  ram_total: 0,
                  ram_free: 0,
                  ram_used: 0,
                  language: this.window.navigator.language,
                  time: new Date().toISOString(),
                  sdk_type: "web",
                  sdk_version: this.sdkVersion,
                  session_uid: e,
                  app_version: {
                    app: {
                      key: t.appKey
                    },
                    version: t.version,
                    build: t.build
                  }
                };
              }
            }]);
            return _class29;
          }();
        },
        1310: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.StorageGuard = void 0, t.StorageGuard = /*#__PURE__*/function () {
            function _class30(e, t, r, n) {
              _classCallCheck(this, _class30);
              this.api = e, this.device = t, this.logger = r, this.options = n, this.deviceForceEnabled = !1, this.isAppValid = !0, this.isDeviceEnabled = !1, this.checkIsDeviceEnabled(), setInterval(this.checkIsDeviceEnabled.bind(this), 3e5);
            }
            _createClass(_class30, [{
              key: "canProcess",
              value: function canProcess() {
                return this.logger.log("canProcess", {
                  isAppValid: this.isAppValid,
                  isDeviceEnabled: this.isDeviceEnabled,
                  deviceForceEnabled: this.deviceForceEnabled
                }), this.isAppValid && (this.isDeviceEnabled || this.deviceForceEnabled);
              }
            }, {
              key: "canWrite",
              value: function canWrite() {
                return this.isAppValid;
              }
            }, {
              key: "checkIsDeviceEnabled",
              value: function checkIsDeviceEnabled() {
                var _this12 = this;
                var e = this.device.getInfo(this.options);
                return this.api.getDeviceStatus(e).then(function (e) {
                  _this12.isAppValid = e.isAppValid, _this12.isDeviceEnabled = e.isDeviceEnabled;
                }, function () {});
              }
            }, {
              key: "setDeviceForceEnabled",
              value: function setDeviceForceEnabled(e) {
                this.deviceForceEnabled = e;
              }
            }]);
            return _class30;
          }();
        },
        8177: function _(e, t) {
          "use strict";

          var r, n;
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.SessionStorageKey = t.LocalStorageKey = void 0, (n = t.LocalStorageKey || (t.LocalStorageKey = {})).AppID = "bf_app_id", n.DeviceData = "bf_device_data", n.DeviceUDID = "bf_device_udid", (r = t.SessionStorageKey || (t.SessionStorageKey = {})).SessionUDID = "bf_session_udid", r.SessionUUID = "bf_session_uuid";
        },
        3103: function _(e, t) {
          "use strict";

          var r = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.StorageProcessor = void 0, t.StorageProcessor = /*#__PURE__*/function () {
            function _class31(e, t, r, n, o, i, s, a, c, u, l, d) {
              var _this13 = this;
              _classCallCheck(this, _class31);
              this.api = e, this.channel = t, this.connection = r, this.logger = n, this.device = o, this.deviceKeysTable = i, this.issuesTable = s, this.logsTable = a, this.options = c, this.sessionFactory = u, this.sessionsTable = l, this.storageGuard = d, this.BATCH_SIZE = 500, this.runIntervalMs = 15e3, this.forceSend = !1, this.isRunning = !1, setInterval(this.run.bind(this), this.runIntervalMs), this.channel.onHasBecomeLeader().then(function () {
                _this13.run();
              }), this.channel.onForceSend(function () {
                _this13.forceSend = !0;
              });
            }
            _createClass(_class31, [{
              key: "cleanupSessions",
              value: function cleanupSessions(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
                  var _iterator, _step, _t8, _e9, _r3;
                  return _regeneratorRuntime().wrap(function _callee54$(_context54) {
                    while (1) {
                      switch (_context54.prev = _context54.next) {
                        case 0:
                          _iterator = _createForOfIteratorHelper(e);
                          _context54.prev = 1;
                          _iterator.s();
                        case 3:
                          if ((_step = _iterator.n()).done) {
                            _context54.next = 21;
                            break;
                          }
                          _t8 = _step.value;
                          _context54.next = 7;
                          return this.channel.isSessionActive(_t8.uuid);
                        case 7:
                          _e9 = _context54.sent;
                          _context54.next = 10;
                          return this.hasData(_t8);
                        case 10:
                          _r3 = _context54.sent;
                          if (!(!_e9 && !_r3)) {
                            _context54.next = 19;
                            break;
                          }
                          _context54.prev = 12;
                          _context54.next = 15;
                          return this.sessionsTable.delete(_t8.uuid);
                        case 15:
                          _context54.next = 19;
                          break;
                        case 17:
                          _context54.prev = 17;
                          _context54.t0 = _context54["catch"](12);
                        case 19:
                          _context54.next = 3;
                          break;
                        case 21:
                          _context54.next = 26;
                          break;
                        case 23:
                          _context54.prev = 23;
                          _context54.t1 = _context54["catch"](1);
                          _iterator.e(_context54.t1);
                        case 26:
                          _context54.prev = 26;
                          _iterator.f();
                          return _context54.finish(26);
                        case 29:
                        case "end":
                          return _context54.stop();
                      }
                    }
                  }, _callee54, this, [[1, 23, 26, 29], [12, 17]]);
                }));
              }
            }, {
              key: "hasData",
              value: function hasData(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
                  var _yield$Promise$all3, _yield$Promise$all4, _t9, _r4, n;
                  return _regeneratorRuntime().wrap(function _callee55$(_context55) {
                    while (1) {
                      switch (_context55.prev = _context55.next) {
                        case 0:
                          _context55.prev = 0;
                          _context55.next = 3;
                          return Promise.all([this.logsTable.count(e.uuid), this.issuesTable.count(e.uuid), this.deviceKeysTable.count(e.uuid)]);
                        case 3:
                          _yield$Promise$all3 = _context55.sent;
                          _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 3);
                          _t9 = _yield$Promise$all4[0];
                          _r4 = _yield$Promise$all4[1];
                          n = _yield$Promise$all4[2];
                          return _context55.abrupt("return", _t9 > 0 || _r4 > 0 || n > 0);
                        case 11:
                          _context55.prev = 11;
                          _context55.t0 = _context55["catch"](0);
                          return _context55.abrupt("return", !0);
                        case 14:
                        case "end":
                          return _context55.stop();
                      }
                    }
                  }, _callee55, this, [[0, 11]]);
                }));
              }
            }, {
              key: "registerSession",
              value: function registerSession(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
                  var _t10, _yield$this$api$sendS, _r5;
                  return _regeneratorRuntime().wrap(function _callee56$(_context56) {
                    while (1) {
                      switch (_context56.prev = _context56.next) {
                        case 0:
                          if (e.id) {
                            _context56.next = 7;
                            break;
                          }
                          _t10 = this.sessionFactory.create(e.uuid, this.options);
                          _context56.next = 4;
                          return this.api.sendSession(_t10);
                        case 4:
                          _yield$this$api$sendS = _context56.sent;
                          _r5 = _yield$this$api$sendS.id;
                          e.id = _r5, this.sessionsTable.update(e.uuid, {
                            id: _r5
                          });
                        case 7:
                          return _context56.abrupt("return", e);
                        case 8:
                        case "end":
                          return _context56.stop();
                      }
                    }
                  }, _callee56, this);
                }));
              }
            }, {
              key: "canRun",
              value: function canRun() {
                return this.connection.isOnline() && this.channel.isLeader() && !this.isRunning;
              }
            }, {
              key: "run",
              value: function run() {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
                  var e, t, r, n, o, i, _iterator2, _step2, _e10, _t11, _r6;
                  return _regeneratorRuntime().wrap(function _callee57$(_context57) {
                    while (1) {
                      switch (_context57.prev = _context57.next) {
                        case 0:
                          e = this.canRun();
                          if (!(this.logger.log("Processing...", {
                            forceSend: this.forceSend,
                            isRunning: this.isRunning,
                            isLeader: this.channel.isLeader(),
                            isOnline: this.connection.isOnline(),
                            canRun: e
                          }), !e)) {
                            _context57.next = 3;
                            break;
                          }
                          return _context57.abrupt("return", void this.logger.log("Aborted."));
                        case 3:
                          this.isRunning = !0;
                          t = this.forceSend;
                          _context57.next = 7;
                          return this.sessionsTable.getAll();
                        case 7:
                          r = _context57.sent;
                          n = [];
                          o = this.storageGuard.canProcess() || this.forceSend;
                          i = !1;
                          this.logger.log("Should process device: " + (o ? "Yes" : "No")), this.logger.log("".concat(r.length, " session/s found")), r.sort(function (e, t) {
                            return Number(!!t.id) - Number(!!e.id);
                          });
                          _iterator2 = _createForOfIteratorHelper(r);
                          _context57.prev = 13;
                          _iterator2.s();
                        case 15:
                          if ((_step2 = _iterator2.n()).done) {
                            _context57.next = 26;
                            break;
                          }
                          _e10 = _step2.value;
                          _context57.next = 19;
                          return this.registerSession(_e10);
                        case 19:
                          _t11 = _context57.sent;
                          _context57.next = 22;
                          return this.sendIssues(_t11);
                        case 22:
                          _r6 = _context57.sent;
                          i = i || _r6, _r6 || o ? (n.push(this.sendLogs(_t11)), this.logger.log("Session processed. ID: ".concat(_t11.id), {
                            sessionHasIssues: _r6
                          })) : this.logger.log("Session skipped. ID: ".concat(_t11.id));
                        case 24:
                          _context57.next = 15;
                          break;
                        case 26:
                          _context57.next = 31;
                          break;
                        case 28:
                          _context57.prev = 28;
                          _context57.t0 = _context57["catch"](13);
                          _iterator2.e(_context57.t0);
                        case 31:
                          _context57.prev = 31;
                          _iterator2.f();
                          return _context57.finish(31);
                        case 34:
                          (i || o) && n.push(this.sendDeviceData());
                          _context57.next = 37;
                          return Promise.all(n);
                        case 37:
                          _context57.next = 39;
                          return this.cleanupSessions(r);
                        case 39:
                          this.isRunning = !1;
                          t && (this.forceSend = !1);
                          this.logger.log("Done");
                        case 42:
                        case "end":
                          return _context57.stop();
                      }
                    }
                  }, _callee57, this, [[13, 28, 31, 34]]);
                }));
              }
            }, {
              key: "sendDeviceData",
              value: function sendDeviceData() {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
                  var _this14 = this;
                  var _e11, _t12;
                  return _regeneratorRuntime().wrap(function _callee58$(_context58) {
                    while (1) {
                      switch (_context58.prev = _context58.next) {
                        case 0:
                          _context58.prev = 0;
                          _e11 = {};
                          _context58.next = 4;
                          return this.deviceKeysTable.getAll();
                        case 4:
                          _t12 = _context58.sent;
                          _t12.forEach(function (t) {
                            _e11[t.data.key] = t.data.value;
                          });
                          _context58.t0 = _t12.length;
                          if (!_context58.t0) {
                            _context58.next = 12;
                            break;
                          }
                          _context58.next = 10;
                          return Promise.all(Object.entries(_e11).map(function (_ref) {
                            var _ref2 = _slicedToArray(_ref, 2),
                              e = _ref2[0],
                              t = _ref2[1];
                            return _this14.api.setDeviceKey(_this14.device.getUDID(), e, t);
                          }));
                        case 10:
                          _context58.next = 12;
                          return this.deviceKeysTable.deleteBatch(_t12.length);
                        case 12:
                          _context58.next = 17;
                          break;
                        case 14:
                          _context58.prev = 14;
                          _context58.t1 = _context58["catch"](0);
                          this.logger.error("sendDeviceData error", _context58.t1);
                        case 17:
                        case "end":
                          return _context58.stop();
                      }
                    }
                  }, _callee58, this, [[0, 14]]);
                }));
              }
            }, {
              key: "sendIssues",
              value: function sendIssues(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
                  var _t13, _iterator3, _step3, _r7, _t14, n;
                  return _regeneratorRuntime().wrap(function _callee59$(_context59) {
                    while (1) {
                      switch (_context59.prev = _context59.next) {
                        case 0:
                          _context59.prev = 0;
                          _context59.next = 3;
                          return this.issuesTable.getBatch(e.uuid, this.BATCH_SIZE);
                        case 3:
                          _t13 = _context59.sent;
                          _iterator3 = _createForOfIteratorHelper(_t13);
                          _context59.prev = 5;
                          _iterator3.s();
                        case 7:
                          if ((_step3 = _iterator3.n()).done) {
                            _context59.next = 16;
                            break;
                          }
                          _r7 = _step3.value;
                          _t14 = _r7.data, n = "".concat(this.options.baseURL, "/intent/").concat(this.options.appID, "/issue/").concat(_t14.uuid);
                          _context59.next = 12;
                          return this.api.sendIssue(_t14.uuid, n, _t14.title, _t14.text, _t14.type, e.id);
                        case 12:
                          _context59.next = 14;
                          return this.issuesTable.deleteById(_r7.id);
                        case 14:
                          _context59.next = 7;
                          break;
                        case 16:
                          _context59.next = 21;
                          break;
                        case 18:
                          _context59.prev = 18;
                          _context59.t0 = _context59["catch"](5);
                          _iterator3.e(_context59.t0);
                        case 21:
                          _context59.prev = 21;
                          _iterator3.f();
                          return _context59.finish(21);
                        case 24:
                          return _context59.abrupt("return", _t13.length > 0);
                        case 27:
                          _context59.prev = 27;
                          _context59.t1 = _context59["catch"](0);
                          return _context59.abrupt("return", (this.logger.error("sendIssues error", _context59.t1), !1));
                        case 30:
                        case "end":
                          return _context59.stop();
                      }
                    }
                  }, _callee59, this, [[0, 27], [5, 18, 21, 24]]);
                }));
              }
            }, {
              key: "sendLogs",
              value: function sendLogs(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
                  var _t15;
                  return _regeneratorRuntime().wrap(function _callee60$(_context60) {
                    while (1) {
                      switch (_context60.prev = _context60.next) {
                        case 0:
                          _context60.prev = 0;
                          _context60.next = 3;
                          return this.logsTable.getBatch(e.uuid, this.BATCH_SIZE);
                        case 3:
                          _t15 = _context60.sent.map(function (e) {
                            return e.data;
                          });
                          _context60.t0 = _t15.length;
                          if (!_context60.t0) {
                            _context60.next = 10;
                            break;
                          }
                          _context60.next = 8;
                          return this.api.sendLogs(e.id, _t15);
                        case 8:
                          _context60.next = 10;
                          return this.logsTable.deleteBatch(e.uuid, _t15.length);
                        case 10:
                          _context60.next = 15;
                          break;
                        case 12:
                          _context60.prev = 12;
                          _context60.t1 = _context60["catch"](0);
                          this.logger.error("sendLogs error", _context60.t1);
                        case 15:
                        case "end":
                          return _context60.stop();
                      }
                    }
                  }, _callee60, this, [[0, 12]]);
                }));
              }
            }]);
            return _class31;
          }();
        },
        6693: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.MainThreadStorageWriterHandler = void 0, t.MainThreadStorageWriterHandler = /*#__PURE__*/function () {
            function _class32(e) {
              _classCallCheck(this, _class32);
              this.storageWriter = e;
            }
            _createClass(_class32, [{
              key: "postMessage",
              value: function postMessage(e) {
                this.storageWriter.handleMessage(e);
              }
            }]);
            return _class32;
          }();
        },
        84: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.StorageWriterHub = void 0;
          var n = r(7431),
            o = r(3817),
            i = r(5049),
            s = r(2607);
          t.StorageWriterHub = /*#__PURE__*/function () {
            function _class33(e, t, r, n, i, s, a, c, u, l) {
              _classCallCheck(this, _class33);
              this.channel = e, this.device = t, this.handler = r, this.eventPrinter = n, this.options = i, this.printToConsole = s, this.session = a, this.storageGuard = c, this.uuidFactory = u, this.window = l, this.sanitizer = new o.StorageWriterSanitizer();
            }
            _createClass(_class33, [{
              key: "init",
              value: function init(e) {
                var t = this.session.getUUID();
                this.options = e, this.postMessage({
                  type: "init",
                  data: {
                    options: e,
                    sessionUUID: t
                  }
                }, !1);
              }
            }, {
              key: "postMessage",
              value: function postMessage(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                if (!t || this.storageGuard.canWrite()) try {
                  this.handler.postMessage(this.sanitizer.sanitize(e));
                } catch (e) {}
              }
            }, {
              key: "addDeviceKey",
              value: function addDeviceKey(e) {
                if ("string" != typeof e.key) throw new Error("The device-key 'key' must be a string.");
                this.device.setDeviceKey(e.key, e.value), this.postMessage({
                  type: "device-key",
                  data: {
                    key: e.key,
                    value: e.value,
                    callInfo: e.callInfo,
                    time: e.time
                  }
                }), this.eventPrinter.printDeviceKey(e.key, e.value);
              }
            }, {
              key: "addLogEntry",
              value: function addLogEntry(e) {
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
                var r;
                e.log.url = (null !== (r = e.log.url) && void 0 !== r ? r : this.window) ? this.window.location.href : "";
                var n = this.mapToLogEntryText(e.log);
                this.postMessage({
                  type: "log-entry",
                  data: {
                    log: n,
                    callInfo: e.callInfo,
                    time: e.time
                  }
                }), t && (this.isJsEventLogEntry(n) ? this.eventPrinter.printJsEvent(n) : this.printToConsole.printLog(n));
              }
            }, {
              key: "isJsEventLogEntry",
              value: function isJsEventLogEntry(e) {
                return "js_event" === e.tag && "string" == typeof e.text && "string" == typeof e.url;
              }
            }, {
              key: "mapToLogEntryText",
              value: function mapToLogEntryText(e) {
                return e.text && (e.text = (0, n.formatLogEntryText)(e.text)), e;
              }
            }, {
              key: "addLogMessage",
              value: function addLogMessage(e) {
                var _this$printToConsole, _this$printToConsole2, _this$printToConsole3, _this$printToConsole4, _this$printToConsole5, _this$printToConsole6;
                var t = {};
                switch (t.level = e.level, t.text = (0, n.format)(e.parameters), t.url = this.window ? this.window.location.href : void 0, this.addLogEntry({
                  type: i.CommandType.AddLogEntry,
                  log: t,
                  callInfo: e.callInfo,
                  time: e.time
                }, !1), e.level) {
                  case n.LogLevel.Debug:
                    (_this$printToConsole = this.printToConsole).log.apply(_this$printToConsole, _toConsumableArray(e.parameters));
                    break;
                  case n.LogLevel.Warning:
                    (_this$printToConsole2 = this.printToConsole).warn.apply(_this$printToConsole2, _toConsumableArray(e.parameters));
                    break;
                  case n.LogLevel.Error:
                    (_this$printToConsole3 = this.printToConsole).error.apply(_this$printToConsole3, _toConsumableArray(e.parameters));
                    break;
                  case n.LogLevel.Trace:
                    (_this$printToConsole4 = this.printToConsole).trace.apply(_this$printToConsole4, _toConsumableArray(e.parameters));
                    break;
                  case n.LogLevel.Info:
                    (_this$printToConsole5 = this.printToConsole).info.apply(_this$printToConsole5, _toConsumableArray(e.parameters));
                    break;
                  case n.LogLevel.Fatal:
                    (_this$printToConsole6 = this.printToConsole).error.apply(_this$printToConsole6, _toConsumableArray(e.parameters));
                }
              }
            }, {
              key: "addIssue",
              value: function addIssue(e) {
                if ("string" != typeof e.title) throw new Error("The crash/issue/feedback 'title' must be a string.");
                switch (this.postMessage({
                  type: "issue",
                  data: {
                    type: e.issueType,
                    title: e.title,
                    uuid: e.uuid,
                    text: e.text,
                    callInfo: e.callInfo,
                    time: e.time
                  }
                }), this.forceSendOnce(), e.url.resolve("".concat(this.options.baseURL, "/intent/").concat(this.options.appID, "/issue/").concat(e.uuid)), e.issueType) {
                  case s.IssueType.Issue:
                    this.printToConsole.warn("Issue: ".concat(e.title, ".\n").concat(e.text));
                    break;
                  case s.IssueType.Crash:
                    this.printToConsole.error("Crash: ".concat(e.title, ".\n").concat(e.text));
                    break;
                  case s.IssueType.Feedback:
                    this.printToConsole.info("User Feedback: ".concat(e.title, ".\n").concat(e.text));
                }
              }
            }, {
              key: "forceSendOnce",
              value: function forceSendOnce() {
                this.channel.notifyForceSend();
              }
            }]);
            return _class33;
          }();
        },
        3817: function _(e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.StorageWriterSanitizer = void 0;
          var n = r(7431);
          t.StorageWriterSanitizer = /*#__PURE__*/function () {
            function _class34() {
              _classCallCheck(this, _class34);
            }
            _createClass(_class34, [{
              key: "sanitize",
              value: function sanitize(e) {
                switch (e.type) {
                  case "device-key":
                    {
                      var _t16 = ["boolean", "number", "string"].includes(_typeof(e.data.value));
                      e.data.key = (0, n.mapToString)(e.data.key), _t16 || (e.data.value = (0, n.mapToString)(e.data.value));
                      break;
                    }
                  case "issue":
                    e.data.title = (0, n.mapToString)(e.data.title), e.data.text = (0, n.mapToString)(e.data.text);
                    break;
                  case "log-entry":
                    {
                      var _t17 = ["tag", "method", "file", "text", "url"],
                        _r8 = "line" in e.data.log && void 0 !== e.data.log.line,
                        o = _r8 && "number" == typeof e.data.log.line,
                        i = "level" in e.data.log && void 0 !== e.data.log.level,
                        s = i && n.LOG_LEVELS.includes(e.data.log.level);
                      if (_t17.forEach(function (t) {
                        if (t in e.data.log && void 0 !== e.data.log[t]) try {
                          e.data.log[t] = (0, n.mapToString)(e.data.log[t]);
                        } catch (r) {
                          delete e.data.log[t];
                        }
                      }), _r8 && !o) try {
                        e.data.log.line = (0, n.mapToNumber)(e.data.log.line);
                      } catch (t) {
                        delete e.data.log.line;
                      }
                      if (i && !s) try {
                        e.data.log.level = (0, n.mapToNumber)(e.data.log.level), n.LOG_LEVELS.includes(e.data.log.level) || delete e.data.log.level;
                      } catch (t) {
                        delete e.data.log.level;
                      }
                      break;
                    }
                }
                return e;
              }
            }]);
            return _class34;
          }();
        },
        5041: function _(e, t) {
          "use strict";

          var r = this && this.__awaiter || function (e, t, r, n) {
            return new (r || (r = Promise))(function (o, i) {
              function s(e) {
                try {
                  c(n.next(e));
                } catch (e) {
                  i(e);
                }
              }
              function a(e) {
                try {
                  c(n.throw(e));
                } catch (e) {
                  i(e);
                }
              }
              function c(e) {
                var t;
                e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(s, a);
              }
              c((n = n.apply(e, t || [])).next());
            });
          };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.StorageWriter = void 0, t.StorageWriter = /*#__PURE__*/function () {
            function _class35(e, t, r, n) {
              _classCallCheck(this, _class35);
              this.deviceKeysTable = e, this.issuesTable = t, this.logFactory = r, this.logsTable = n, this.isClearingSpace = !1, this.logsQueue = [];
            }
            _createClass(_class35, [{
              key: "handleMessage",
              value: function handleMessage(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
                  return _regeneratorRuntime().wrap(function _callee61$(_context61) {
                    while (1) {
                      switch (_context61.prev = _context61.next) {
                        case 0:
                          _context61.t0 = e.type;
                          _context61.next = _context61.t0 === "device-key" ? 3 : _context61.t0 === "init" ? 4 : _context61.t0 === "issue" ? 6 : _context61.t0 === "log-entry" ? 7 : 8;
                          break;
                        case 3:
                          return _context61.abrupt("return", this.addDeviceKey(e.data.key, e.data.value, e.data.callInfo, e.data.time));
                        case 4:
                          this.options = e.data.options, this.sessionUUID = e.data.sessionUUID;
                          return _context61.abrupt("break", 8);
                        case 6:
                          return _context61.abrupt("return", this.addIssue(e.data.type, e.data.title, e.data.text, e.data.uuid, e.data.callInfo, e.data.time));
                        case 7:
                          return _context61.abrupt("return", this.addLogEntry(e.data.log, e.data.callInfo, e.data.time));
                        case 8:
                        case "end":
                          return _context61.stop();
                      }
                    }
                  }, _callee61, this);
                }));
              }
            }, {
              key: "addDeviceKey",
              value: function addDeviceKey(e, t, r, n) {
                this.deviceKeysTable.add({
                  sessionUUID: this.sessionUUID,
                  data: {
                    key: e,
                    value: t
                  }
                }), this.addLog(this.logFactory.createFromDeviceKey(e, t, r, n));
              }
            }, {
              key: "addLog",
              value: function addLog(e) {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee62() {
                  var t;
                  return _regeneratorRuntime().wrap(function _callee62$(_context62) {
                    while (1) {
                      switch (_context62.prev = _context62.next) {
                        case 0:
                          t = {
                            sessionUUID: this.sessionUUID,
                            data: e
                          };
                          if (!this.isClearingSpace) {
                            _context62.next = 5;
                            break;
                          }
                          this.logsQueue.push(t);
                          _context62.next = 21;
                          break;
                        case 5:
                          _context62.prev = 5;
                          _context62.next = 8;
                          return this.logsTable.add(t);
                        case 8:
                          _context62.next = 21;
                          break;
                        case 10:
                          _context62.prev = 10;
                          _context62.t0 = _context62["catch"](5);
                          _context62.t1 = this.isQuotaExceededError(_context62.t0);
                          if (!_context62.t1) {
                            _context62.next = 21;
                            break;
                          }
                          this.logsQueue.push(t);
                          this.isClearingSpace = !0;
                          _context62.next = 18;
                          return this.logsTable.deleteOldLogs(this.sessionUUID);
                        case 18:
                          _context62.next = 20;
                          return this.processLogsQueue();
                        case 20:
                          this.isClearingSpace = !1;
                        case 21:
                        case "end":
                          return _context62.stop();
                      }
                    }
                  }, _callee62, this, [[5, 10]]);
                }));
              }
            }, {
              key: "addLogEntry",
              value: function addLogEntry(e, t, r) {
                this.addLog(this.logFactory.createFromEntry(e, t, r));
              }
            }, {
              key: "addIssue",
              value: function addIssue(e, t, r, n, o, i) {
                this.issuesTable.add({
                  sessionUUID: this.sessionUUID,
                  data: {
                    title: t,
                    text: r,
                    type: e,
                    uuid: n
                  }
                }), this.addLog(this.logFactory.createFromIssue(n, o, i));
              }
            }, {
              key: "isQuotaExceededError",
              value: function isQuotaExceededError(e) {
                var t;
                return "QuotaExceededError" === e.name || "QuotaExceededError" === (null === (t = e.inner) || void 0 === t ? void 0 : t.name);
              }
            }, {
              key: "processLogsQueue",
              value: function processLogsQueue() {
                return r(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
                  var _e12;
                  return _regeneratorRuntime().wrap(function _callee63$(_context63) {
                    while (1) {
                      switch (_context63.prev = _context63.next) {
                        case 0:
                          if (!(this.logsQueue.length > 0)) {
                            _context63.next = 16;
                            break;
                          }
                          _e12 = this.logsQueue[0];
                          _context63.prev = 2;
                          _context63.next = 5;
                          return this.logsTable.add(_e12);
                        case 5:
                          this.logsQueue.shift();
                          _context63.next = 14;
                          break;
                        case 8:
                          _context63.prev = 8;
                          _context63.t0 = _context63["catch"](2);
                          _context63.t1 = this.isQuotaExceededError(_context63.t0);
                          if (!_context63.t1) {
                            _context63.next = 14;
                            break;
                          }
                          _context63.next = 14;
                          return this.logsTable.deleteOldLogs(this.sessionUUID);
                        case 14:
                          _context63.next = 0;
                          break;
                        case 16:
                        case "end":
                          return _context63.stop();
                      }
                    }
                  }, _callee63, this, [[2, 8]]);
                }));
              }
            }]);
            return _class35;
          }();
        },
        5925: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Timer = void 0, t.Timer = /*#__PURE__*/function () {
            function _class36() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
                return new Date();
              };
              _classCallCheck(this, _class36);
              this.getNow = e, this.lastAbsoluteTime = 0;
            }
            _createClass(_class36, [{
              key: "getTime",
              value: function getTime() {
                var e = this.getNow();
                var t = e.getTime();
                return t <= this.lastAbsoluteTime && (t = this.lastAbsoluteTime + 1), this.lastAbsoluteTime = t, {
                  iso: e.toISOString(),
                  epoch: t
                };
              }
            }]);
            return _class36;
          }();
        },
        2607: function _(e, t) {
          "use strict";

          var r;
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.IssueType = void 0, (r = t.IssueType || (t.IssueType = {})).Issue = "issue", r.Crash = "crash", r.Feedback = "user-feedback";
        },
        7075: function _(e, t, r) {
          "use strict";

          var n = this && this.__awaiter || function (e, t, r, n) {
              return new (r || (r = Promise))(function (o, i) {
                function s(e) {
                  try {
                    c(n.next(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function a(e) {
                  try {
                    c(n.throw(e));
                  } catch (e) {
                    i(e);
                  }
                }
                function c(e) {
                  var t;
                  e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                    e(t);
                  })).then(s, a);
                }
                c((n = n.apply(e, t || [])).next());
              });
            },
            o = this && this.__importDefault || function (e) {
              return e && e.__esModule ? e : {
                default: e
              };
            };
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.UserFeedback = void 0;
          var i = r(7431),
            s = r(8593),
            a = r(2607),
            c = o(r(5415)),
            u = o(r(3584));
          var l = /*#__PURE__*/function () {
            function l(e, t, r) {
              var _this15 = this;
              _classCallCheck(this, l);
              this.options = e, this.onClose = t, this.onSubmit = r, this.wrapperEl = document.createElement("div"), this.shadow = this.wrapperEl.attachShadow({
                mode: "closed"
              }), this.shadow.innerHTML = u.default, this.titleEl = this.querySelector("[data-bf-title]"), this.titleEl.innerText = this.options.title, this.hintEl = this.querySelector("[data-bf-hint]"), this.options.hint && (this.hintEl.innerText = this.options.hint, this.hintEl.classList.remove("bf-modal__hint--hidden")), this.subjectEl = this.querySelector("[data-bf-subject]"), this.subjectEl.setAttribute("placeholder", this.options.subjectPlaceholder), this.feedbackEl = this.querySelector("[data-bf-feedback]"), this.feedbackEl.setAttribute("placeholder", this.options.feedbackPlaceholder), this.submitEl = this.querySelector("[data-bf-submit]"), this.submitEl.innerText = this.options.submitLabel, this.backdropEl = this.querySelector("[data-bf-backdrop]"), this.backdropEl.addEventListener("click", this.onClose), this.closeEl = this.querySelector("[data-bf-close]"), this.closeEl.addEventListener("click", this.onClose), this.formEl = this.querySelector("[data-bf-form]"), this.submitCb = function (e) {
                e.preventDefault(), e.stopPropagation(), _this15.onSubmit(_this15.subjectEl.value, _this15.feedbackEl.value);
              }, this.formEl.addEventListener("submit", this.submitCb);
              var n = document.querySelector("body");
              n && n.appendChild(this.wrapperEl);
              var o = document.createElement("style");
              o.textContent = c.default.toString(), this.shadow.append(o);
            }
            _createClass(l, [{
              key: "querySelector",
              value: function querySelector(e) {
                var t = this.shadow.querySelector(e);
                if (t) return t;
                throw new Error("Element for selector \"".concat(e, "\" not found."));
              }
            }, {
              key: "drop",
              value: function drop() {
                this.backdropEl.removeEventListener("click", this.onClose), this.closeEl.removeEventListener("click", this.onClose), this.formEl.removeEventListener("submit", this.submitCb), this.backdropEl.remove(), this.closeEl.remove(), this.feedbackEl.remove(), this.formEl.remove(), this.subjectEl.remove(), this.submitEl.remove(), this.titleEl.remove(), this.shadow.innerHTML = "", this.wrapperEl.innerHTML = "", this.wrapperEl.remove();
              }
            }]);
            return l;
          }();
          t.UserFeedback = /*#__PURE__*/function () {
            function _class37(e) {
              _classCallCheck(this, _class37);
              this.commands = e, this.optionsValidator = new i.UserFeedbackOptionsValidator();
            }
            _createClass(_class37, [{
              key: "cancel",
              value: function cancel() {
                this.resolve({
                  isSent: !1
                }), this.drop();
              }
            }, {
              key: "drop",
              value: function drop() {
                var e;
                null === (e = this.modal) || void 0 === e || e.drop(), this.modal = void 0;
              }
            }, {
              key: "resolve",
              value: function resolve(e) {
                var t;
                null === (t = this.deferred) || void 0 === t || t.resolve(e), this.deferred = void 0;
              }
            }, {
              key: "show",
              value: function show(e) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
                  var _this16 = this;
                  return _regeneratorRuntime().wrap(function _callee64$(_context64) {
                    while (1) {
                      switch (_context64.prev = _context64.next) {
                        case 0:
                          return _context64.abrupt("return", (this.deferred || (this.deferred = (0, s.createDeferred)(), this.modal = new l(this.optionsValidator.init(e), function () {
                            return _this16.cancel();
                          }, function (e, t) {
                            return _this16.submit(e, t);
                          })), this.deferred.promise));
                        case 1:
                        case "end":
                          return _context64.stop();
                      }
                    }
                  }, _callee64, this);
                }));
              }
            }, {
              key: "submit",
              value: function submit(e, t) {
                return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
                  var _r9;
                  return _regeneratorRuntime().wrap(function _callee65$(_context65) {
                    while (1) {
                      switch (_context65.prev = _context65.next) {
                        case 0:
                          _context65.prev = 0;
                          _context65.next = 3;
                          return this.commands.addIssue(a.IssueType.Feedback, e, t);
                        case 3:
                          _r9 = _context65.sent;
                          this.resolve({
                            isSent: !0,
                            feedbackURL: _r9
                          });
                          _context65.next = 10;
                          break;
                        case 7:
                          _context65.prev = 7;
                          _context65.t0 = _context65["catch"](0);
                          this.resolve({
                            isSent: !1
                          });
                        case 10:
                          this.drop();
                        case 11:
                        case "end":
                          return _context65.stop();
                      }
                    }
                  }, _callee65, this, [[0, 7]]);
                }));
              }
            }]);
            return _class37;
          }();
        },
        8593: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.getElByXPath = t.getXPath = t.DebounceByElement = t.UnreachableCaseError = t.CacheDecoratorFactory = t.createDeferred = void 0, t.createDeferred = function () {
            var e = {
              isFulfilled: !1,
              isRejected: !1,
              isResolved: !1
            };
            return e.promise = new Promise(function (t, r) {
              e.resolve = function (r) {
                var n = e;
                n.isFulfilled = !0, n.isRejected = !1, n.isResolved = !0, n.value = r, t(r);
              }, e.reject = function (t) {
                var n = e;
                n.isFulfilled = !0, n.isRejected = !0, n.isResolved = !1, n.err = t, r(t);
              };
            }), e;
          }, t.CacheDecoratorFactory = function (e) {
            return function () {
              return function (t, r, n) {
                var o = n.value;
                n.value = function () {
                  return e.has(r) || e.set(r, o.apply(this)), e.get(r);
                };
              };
            };
          };
          var r = /*#__PURE__*/function (_Error) {
            _inherits(r, _Error);
            var _super3 = _createSuper(r);
            function r(e) {
              _classCallCheck(this, r);
              return _super3.call(this, "Unreachable case: ".concat(JSON.stringify(e)));
            }
            return _createClass(r);
          }( /*#__PURE__*/_wrapNativeSuper(Error));
          t.UnreachableCaseError = r, t.DebounceByElement = /*#__PURE__*/function () {
            function _class38(e) {
              _classCallCheck(this, _class38);
              this.wait = e, this.timers = new Map();
            }
            _createClass(_class38, [{
              key: "run",
              value: function run(e, t) {
                var _this17 = this;
                this.timers.has(e) && clearTimeout(this.timers.get(e)), this.timers.set(e, setTimeout(function () {
                  t(), _this17.timers.delete(e);
                }, this.wait));
              }
            }]);
            return _class38;
          }(), t.getXPath = function (e) {
            var t = e;
            if (t instanceof Element && t.id) return '//*[@id="' + t.id + '"]';
            var r = [];
            for (; t && t instanceof Element;) {
              var _e13 = t;
              var n = 0,
                o = !1,
                i = _e13.previousSibling;
              for (; i;) {
                i.nodeType !== Node.DOCUMENT_TYPE_NODE && i.nodeName === _e13.nodeName && n++, i = i.previousSibling;
              }
              for (i = _e13.nextSibling; i;) {
                if (i.nodeName === _e13.nodeName) {
                  o = !0;
                  break;
                }
                i = i.nextSibling;
              }
              var s = _e13.prefix ? _e13.prefix + ":" : "",
                a = n || o ? "[".concat(n + 1, "]") : "";
              r.push(s + _e13.localName + a), t = _e13.parentNode;
            }
            return r.length ? "/" + r.reverse().join("/") : "";
          }, t.getElByXPath = function (e) {
            var t;
            return null !== (t = document.evaluate(e, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue) && void 0 !== t ? t : void 0;
          };
        },
        6884: function _(e, t) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.UUIDFactory = void 0, t.UUIDFactory = /*#__PURE__*/function () {
            function _class39() {
              _classCallCheck(this, _class39);
            }
            _createClass(_class39, [{
              key: "create",
              value: function create() {
                var e = function e() {
                  return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
                };
                return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
              }
            }]);
            return _class39;
          }();
        },
        4810: function _(e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            add: function add() {
              return c;
            },
            getSize: function getSize() {
              return d;
            },
            removeAll: function removeAll() {
              return l;
            },
            runAll: function runAll() {
              return u;
            }
          });
          var n = r(4155),
            o = r(4155),
            i = "[object process]" === Object.prototype.toString.call(void 0 !== o ? o : 0) ? function (e) {
              n.on("exit", function () {
                return e();
              }), n.on("beforeExit", function () {
                return e().then(function () {
                  return n.exit();
                });
              }), n.on("SIGINT", function () {
                return e().then(function () {
                  return n.exit();
                });
              }), n.on("uncaughtException", function (t) {
                return e().then(function () {
                  console.trace(t), n.exit(101);
                });
              });
            } : function (e) {
              if ("function" == typeof WorkerGlobalScope && self instanceof WorkerGlobalScope) {
                var t = self.close.bind(self);
                self.close = function () {
                  return e(), t();
                };
              } else {
                if ("function" != typeof window.addEventListener) return;
                window.addEventListener("beforeunload", function () {
                  e();
                }, !0), window.addEventListener("unload", function () {
                  e();
                }, !0);
              }
            },
            s = new Set(),
            a = !1;
          function c(e) {
            if (a || (a = !0, i(u)), "function" != typeof e) throw new Error("Listener is no function");
            return s.add(e), {
              remove: function remove() {
                return s.delete(e);
              },
              run: function run() {
                return s.delete(e), e();
              }
            };
          }
          function u() {
            var e = [];
            return s.forEach(function (t) {
              e.push(t()), s.delete(t);
            }), Promise.all(e);
          }
          function l() {
            s.clear();
          }
          function d() {
            return s.size;
          }
        },
        384: function _(e) {
          e.exports = function (e) {
            return e && "object" == _typeof(e) && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
          };
        },
        5955: function _(e, t, r) {
          "use strict";

          var n = r(2584),
            o = r(8662),
            i = r(6430),
            s = r(5692);
          function a(e) {
            return e.call.bind(e);
          }
          var c = "undefined" != typeof BigInt,
            u = "undefined" != typeof Symbol,
            l = a(Object.prototype.toString),
            d = a(Number.prototype.valueOf),
            f = a(String.prototype.valueOf),
            p = a(Boolean.prototype.valueOf);
          if (c) var h = a(BigInt.prototype.valueOf);
          if (u) var y = a(Symbol.prototype.valueOf);
          function g(e, t) {
            if ("object" != _typeof(e)) return !1;
            try {
              return t(e), !0;
            } catch (e) {
              return !1;
            }
          }
          function v(e) {
            return "[object Map]" === l(e);
          }
          function b(e) {
            return "[object Set]" === l(e);
          }
          function m(e) {
            return "[object WeakMap]" === l(e);
          }
          function S(e) {
            return "[object WeakSet]" === l(e);
          }
          function w(e) {
            return "[object ArrayBuffer]" === l(e);
          }
          function _(e) {
            return "undefined" != typeof ArrayBuffer && (w.working ? w(e) : e instanceof ArrayBuffer);
          }
          function O(e) {
            return "[object DataView]" === l(e);
          }
          function E(e) {
            return "undefined" != typeof DataView && (O.working ? O(e) : e instanceof DataView);
          }
          t.isArgumentsObject = n, t.isGeneratorFunction = o, t.isTypedArray = s, t.isPromise = function (e) {
            return "undefined" != typeof Promise && e instanceof Promise || null !== e && "object" == _typeof(e) && "function" == typeof e.then && "function" == typeof e.catch;
          }, t.isArrayBufferView = function (e) {
            return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e) : s(e) || E(e);
          }, t.isUint8Array = function (e) {
            return "Uint8Array" === i(e);
          }, t.isUint8ClampedArray = function (e) {
            return "Uint8ClampedArray" === i(e);
          }, t.isUint16Array = function (e) {
            return "Uint16Array" === i(e);
          }, t.isUint32Array = function (e) {
            return "Uint32Array" === i(e);
          }, t.isInt8Array = function (e) {
            return "Int8Array" === i(e);
          }, t.isInt16Array = function (e) {
            return "Int16Array" === i(e);
          }, t.isInt32Array = function (e) {
            return "Int32Array" === i(e);
          }, t.isFloat32Array = function (e) {
            return "Float32Array" === i(e);
          }, t.isFloat64Array = function (e) {
            return "Float64Array" === i(e);
          }, t.isBigInt64Array = function (e) {
            return "BigInt64Array" === i(e);
          }, t.isBigUint64Array = function (e) {
            return "BigUint64Array" === i(e);
          }, v.working = "undefined" != typeof Map && v(new Map()), t.isMap = function (e) {
            return "undefined" != typeof Map && (v.working ? v(e) : e instanceof Map);
          }, b.working = "undefined" != typeof Set && b(new Set()), t.isSet = function (e) {
            return "undefined" != typeof Set && (b.working ? b(e) : e instanceof Set);
          }, m.working = "undefined" != typeof WeakMap && m(new WeakMap()), t.isWeakMap = function (e) {
            return "undefined" != typeof WeakMap && (m.working ? m(e) : e instanceof WeakMap);
          }, S.working = "undefined" != typeof WeakSet && S(new WeakSet()), t.isWeakSet = function (e) {
            return S(e);
          }, w.working = "undefined" != typeof ArrayBuffer && w(new ArrayBuffer()), t.isArrayBuffer = _, O.working = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView && O(new DataView(new ArrayBuffer(1), 0, 1)), t.isDataView = E;
          var P = "undefined" != typeof SharedArrayBuffer ? SharedArrayBuffer : void 0;
          function A(e) {
            return "[object SharedArrayBuffer]" === l(e);
          }
          function I(e) {
            return void 0 !== P && (void 0 === A.working && (A.working = A(new P())), A.working ? A(e) : e instanceof P);
          }
          function M(e) {
            return g(e, d);
          }
          function D(e) {
            return g(e, f);
          }
          function j(e) {
            return g(e, p);
          }
          function x(e) {
            return c && g(e, h);
          }
          function T(e) {
            return u && g(e, y);
          }
          t.isSharedArrayBuffer = I, t.isAsyncFunction = function (e) {
            return "[object AsyncFunction]" === l(e);
          }, t.isMapIterator = function (e) {
            return "[object Map Iterator]" === l(e);
          }, t.isSetIterator = function (e) {
            return "[object Set Iterator]" === l(e);
          }, t.isGeneratorObject = function (e) {
            return "[object Generator]" === l(e);
          }, t.isWebAssemblyCompiledModule = function (e) {
            return "[object WebAssembly.Module]" === l(e);
          }, t.isNumberObject = M, t.isStringObject = D, t.isBooleanObject = j, t.isBigIntObject = x, t.isSymbolObject = T, t.isBoxedPrimitive = function (e) {
            return M(e) || D(e) || j(e) || x(e) || T(e);
          }, t.isAnyArrayBuffer = function (e) {
            return "undefined" != typeof Uint8Array && (_(e) || I(e));
          }, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function (e) {
            Object.defineProperty(t, e, {
              enumerable: !1,
              value: function value() {
                throw new Error(e + " is not supported in userland");
              }
            });
          });
        },
        9539: function _(e, t, r) {
          var n = r(4155),
            o = Object.getOwnPropertyDescriptors || function (e) {
              for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
                r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
              }
              return r;
            },
            i = /%[sdj%]/g;
          t.format = function (e) {
            if (!m(e)) {
              for (var t = [], r = 0; r < arguments.length; r++) {
                t.push(u(arguments[r]));
              }
              return t.join(" ");
            }
            r = 1;
            for (var n = arguments, o = n.length, s = String(e).replace(i, function (e) {
                if ("%%" === e) return "%";
                if (r >= o) return e;
                switch (e) {
                  case "%s":
                    return String(n[r++]);
                  case "%d":
                    return Number(n[r++]);
                  case "%j":
                    try {
                      return JSON.stringify(n[r++]);
                    } catch (e) {
                      return "[Circular]";
                    }
                  default:
                    return e;
                }
              }), a = n[r]; r < o; a = n[++r]) {
              v(a) || !_(a) ? s += " " + a : s += " " + u(a);
            }
            return s;
          }, t.deprecate = function (e, r) {
            if (void 0 !== n && !0 === n.noDeprecation) return e;
            if (void 0 === n) return function () {
              return t.deprecate(e, r).apply(this, arguments);
            };
            var o = !1;
            return function () {
              if (!o) {
                if (n.throwDeprecation) throw new Error(r);
                n.traceDeprecation ? console.trace(r) : console.error(r), o = !0;
              }
              return e.apply(this, arguments);
            };
          };
          var s = {},
            a = /^$/;
          if (n.env.NODE_DEBUG) {
            var c = n.env.NODE_DEBUG;
            c = c.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), a = new RegExp("^" + c + "$", "i");
          }
          function u(e, r) {
            var n = {
              seen: [],
              stylize: d
            };
            return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), g(r) ? n.showHidden = r : r && t._extend(n, r), S(n.showHidden) && (n.showHidden = !1), S(n.depth) && (n.depth = 2), S(n.colors) && (n.colors = !1), S(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), f(n, e, n.depth);
          }
          function l(e, t) {
            var r = u.styles[t];
            return r ? "[" + u.colors[r][0] + "m" + e + "[" + u.colors[r][1] + "m" : e;
          }
          function d(e, t) {
            return e;
          }
          function f(e, r, n) {
            if (e.customInspect && r && P(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
              var o = r.inspect(n, e);
              return m(o) || (o = f(e, o, n)), o;
            }
            var i = function (e, t) {
              if (S(t)) return e.stylize("undefined", "undefined");
              if (m(t)) {
                var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                return e.stylize(r, "string");
              }
              return b(t) ? e.stylize("" + t, "number") : g(t) ? e.stylize("" + t, "boolean") : v(t) ? e.stylize("null", "null") : void 0;
            }(e, r);
            if (i) return i;
            var s = Object.keys(r),
              a = function (e) {
                var t = {};
                return e.forEach(function (e, r) {
                  t[e] = !0;
                }), t;
              }(s);
            if (e.showHidden && (s = Object.getOwnPropertyNames(r)), E(r) && (s.indexOf("message") >= 0 || s.indexOf("description") >= 0)) return p(r);
            if (0 === s.length) {
              if (P(r)) {
                var c = r.name ? ": " + r.name : "";
                return e.stylize("[Function" + c + "]", "special");
              }
              if (w(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
              if (O(r)) return e.stylize(Date.prototype.toString.call(r), "date");
              if (E(r)) return p(r);
            }
            var u,
              l = "",
              d = !1,
              _ = ["{", "}"];
            return y(r) && (d = !0, _ = ["[", "]"]), P(r) && (l = " [Function" + (r.name ? ": " + r.name : "") + "]"), w(r) && (l = " " + RegExp.prototype.toString.call(r)), O(r) && (l = " " + Date.prototype.toUTCString.call(r)), E(r) && (l = " " + p(r)), 0 !== s.length || d && 0 != r.length ? n < 0 ? w(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), u = d ? function (e, t, r, n, o) {
              for (var i = [], s = 0, a = t.length; s < a; ++s) {
                j(t, String(s)) ? i.push(h(e, t, r, n, String(s), !0)) : i.push("");
              }
              return o.forEach(function (o) {
                o.match(/^\d+$/) || i.push(h(e, t, r, n, o, !0));
              }), i;
            }(e, r, n, a, s) : s.map(function (t) {
              return h(e, r, n, a, t, d);
            }), e.seen.pop(), function (e, t, r) {
              return e.reduce(function (e, t) {
                return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
              }, 0) > 60 ? r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
            }(u, l, _)) : _[0] + l + _[1];
          }
          function p(e) {
            return "[" + Error.prototype.toString.call(e) + "]";
          }
          function h(e, t, r, n, o, i) {
            var s, a, c;
            if ((c = Object.getOwnPropertyDescriptor(t, o) || {
              value: t[o]
            }).get ? a = c.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : c.set && (a = e.stylize("[Setter]", "special")), j(n, o) || (s = "[" + o + "]"), a || (e.seen.indexOf(c.value) < 0 ? (a = v(r) ? f(e, c.value, null) : f(e, c.value, r - 1)).indexOf("\n") > -1 && (a = i ? a.split("\n").map(function (e) {
              return "  " + e;
            }).join("\n").slice(2) : "\n" + a.split("\n").map(function (e) {
              return "   " + e;
            }).join("\n")) : a = e.stylize("[Circular]", "special")), S(s)) {
              if (i && o.match(/^\d+$/)) return a;
              (s = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.slice(1, -1), s = e.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = e.stylize(s, "string"));
            }
            return s + ": " + a;
          }
          function y(e) {
            return Array.isArray(e);
          }
          function g(e) {
            return "boolean" == typeof e;
          }
          function v(e) {
            return null === e;
          }
          function b(e) {
            return "number" == typeof e;
          }
          function m(e) {
            return "string" == typeof e;
          }
          function S(e) {
            return void 0 === e;
          }
          function w(e) {
            return _(e) && "[object RegExp]" === A(e);
          }
          function _(e) {
            return "object" == _typeof(e) && null !== e;
          }
          function O(e) {
            return _(e) && "[object Date]" === A(e);
          }
          function E(e) {
            return _(e) && ("[object Error]" === A(e) || e instanceof Error);
          }
          function P(e) {
            return "function" == typeof e;
          }
          function A(e) {
            return Object.prototype.toString.call(e);
          }
          function I(e) {
            return e < 10 ? "0" + e.toString(10) : e.toString(10);
          }
          t.debuglog = function (e) {
            if (e = e.toUpperCase(), !s[e]) if (a.test(e)) {
              var r = n.pid;
              s[e] = function () {
                var n = t.format.apply(t, arguments);
                console.error("%s %d: %s", e, r, n);
              };
            } else s[e] = function () {};
            return s[e];
          }, t.inspect = u, u.colors = {
            bold: [1, 22],
            italic: [3, 23],
            underline: [4, 24],
            inverse: [7, 27],
            white: [37, 39],
            grey: [90, 39],
            black: [30, 39],
            blue: [34, 39],
            cyan: [36, 39],
            green: [32, 39],
            magenta: [35, 39],
            red: [31, 39],
            yellow: [33, 39]
          }, u.styles = {
            special: "cyan",
            number: "yellow",
            boolean: "yellow",
            undefined: "grey",
            null: "bold",
            string: "green",
            date: "magenta",
            regexp: "red"
          }, t.types = r(5955), t.isArray = y, t.isBoolean = g, t.isNull = v, t.isNullOrUndefined = function (e) {
            return null == e;
          }, t.isNumber = b, t.isString = m, t.isSymbol = function (e) {
            return "symbol" == _typeof(e);
          }, t.isUndefined = S, t.isRegExp = w, t.types.isRegExp = w, t.isObject = _, t.isDate = O, t.types.isDate = O, t.isError = E, t.types.isNativeError = E, t.isFunction = P, t.isPrimitive = function (e) {
            return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == _typeof(e) || void 0 === e;
          }, t.isBuffer = r(384);
          var M = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          function D() {
            var e = new Date(),
              t = [I(e.getHours()), I(e.getMinutes()), I(e.getSeconds())].join(":");
            return [e.getDate(), M[e.getMonth()], t].join(" ");
          }
          function j(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }
          t.log = function () {
            console.log("%s - %s", D(), t.format.apply(t, arguments));
          }, t.inherits = r(5717), t._extend = function (e, t) {
            if (!t || !_(t)) return e;
            for (var r = Object.keys(t), n = r.length; n--;) {
              e[r[n]] = t[r[n]];
            }
            return e;
          };
          var x = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
          function T(e, t) {
            if (!e) {
              var r = new Error("Promise was rejected with a falsy value");
              r.reason = e, e = r;
            }
            return t(e);
          }
          t.promisify = function (e) {
            if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
            if (x && e[x]) {
              var t;
              if ("function" != typeof (t = e[x])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
              return Object.defineProperty(t, x, {
                value: t,
                enumerable: !1,
                writable: !1,
                configurable: !0
              }), t;
            }
            function t() {
              for (var t, r, n = new Promise(function (e, n) {
                  t = e, r = n;
                }), o = [], i = 0; i < arguments.length; i++) {
                o.push(arguments[i]);
              }
              o.push(function (e, n) {
                e ? r(e) : t(n);
              });
              try {
                e.apply(this, o);
              } catch (e) {
                r(e);
              }
              return n;
            }
            return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), x && Object.defineProperty(t, x, {
              value: t,
              enumerable: !1,
              writable: !1,
              configurable: !0
            }), Object.defineProperties(t, o(e));
          }, t.promisify.custom = x, t.callbackify = function (e) {
            if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
            function t() {
              for (var t = [], r = 0; r < arguments.length; r++) {
                t.push(arguments[r]);
              }
              var o = t.pop();
              if ("function" != typeof o) throw new TypeError("The last argument must be of type Function");
              var i = this,
                s = function s() {
                  return o.apply(i, arguments);
                };
              e.apply(this, t).then(function (e) {
                n.nextTick(s.bind(null, null, e));
              }, function (e) {
                n.nextTick(T.bind(null, e, s));
              });
            }
            return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, o(e)), t;
          };
        },
        6430: function _(e, t, r) {
          "use strict";

          var n = r(9804),
            o = r(3083),
            i = r(1924),
            s = i("Object.prototype.toString"),
            a = r(6410)(),
            c = "undefined" == typeof globalThis ? r.g : globalThis,
            u = o(),
            l = i("String.prototype.slice"),
            d = {},
            f = r(882),
            p = Object.getPrototypeOf;
          a && f && p && n(u, function (e) {
            if ("function" == typeof c[e]) {
              var t = new c[e]();
              if (Symbol.toStringTag in t) {
                var r = p(t),
                  n = f(r, Symbol.toStringTag);
                if (!n) {
                  var o = p(r);
                  n = f(o, Symbol.toStringTag);
                }
                d[e] = n.get;
              }
            }
          });
          var h = r(5692);
          e.exports = function (e) {
            return !!h(e) && (a && Symbol.toStringTag in e ? function (e) {
              var t = !1;
              return n(d, function (r, n) {
                if (!t) try {
                  var o = r.call(e);
                  o === n && (t = o);
                } catch (e) {}
              }), t;
            }(e) : l(s(e), 8, -1));
          };
        },
        4657: function _(e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            default: function _default() {
              return i;
            }
          });
          var n = r(477),
            o = r.n(n);
          function i() {
            return o()("/*! For license information please see storage-writer.worker.worker.js.LICENSE.txt */\n(()=>{var e={496:(e,t)=>{\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0})},431:function(e,t,r){\"use strict\";var n=this&&this.__createBinding||(Object.create?function(e,t,r,n){void 0===n&&(n=r);var o=Object.getOwnPropertyDescriptor(t,r);o&&!(\"get\"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[r]}}),Object.defineProperty(e,n,o)}:function(e,t,r,n){void 0===n&&(n=r),e[n]=t[r]}),o=this&&this.__exportStar||function(e,t){for(var r in e)\"default\"===r||Object.prototype.hasOwnProperty.call(t,r)||n(t,e,r)};Object.defineProperty(t,\"__esModule\",{value:!0}),o(r(496),t),o(r(704),t),o(r(596),t),o(r(836),t),o(r(758),t),o(r(922),t),o(r(287),t),o(r(484),t),o(r(929),t)},704:(e,t)=>{\"use strict\";var r;Object.defineProperty(t,\"__esModule\",{value:!0}),t.LOG_LEVELS=t.LogLevel=void 0,function(e){e[e.Debug=0]=\"Debug\",e[e.Warning=1]=\"Warning\",e[e.Error=2]=\"Error\",e[e.Trace=3]=\"Trace\",e[e.Info=4]=\"Info\",e[e.Fatal=5]=\"Fatal\"}(r=t.LogLevel||(t.LogLevel={})),t.LOG_LEVELS=[r.Debug,r.Warning,r.Error,r.Trace,r.Info,r.Fatal]},596:function(e,t){\"use strict\";var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},r.apply(this,arguments)};function n(e){Object.entries(e).forEach((function(t){var r=t[0];void 0===t[1]&&delete e[r]}))}Object.defineProperty(t,\"__esModule\",{value:!0}),t.validate=t.removeUndefinedProperties=t.prepareOptions=void 0,t.prepareOptions=function(e){return n(e=r({},e)),function(e,t){[\"build\",\"version\"].forEach((function(t){var r=e[t];\"string\"==typeof r&&\"\"===r.trim()&&delete e[t]}))}(e),e},t.removeUndefinedProperties=n,t.validate=function(e,t){var r=new RegExp(/^http(s)?:\\/\\//i);Object.entries(t).forEach((function(t){var n=t[0],o=t[1],i=e[n];o.forEach((function(e){if(\"required\"===e){if(void 0===i)throw new Error(\"Bugfender requires '\".concat(n,\"' option to initialize.\"))}else if(\"string\"===e){if(![\"string\",\"undefined\"].includes(typeof i))throw new Error(\"'\".concat(n,\"' option must be a string.\"))}else if(\"url\"===e){if(void 0!==i&&!r.test(i))throw new Error(\"'\".concat(n,\"' option must be a valid URL.\"))}else if(\"boolean\"===e&&![\"boolean\",\"undefined\"].includes(typeof i))throw new Error(\"'\".concat(n,\"' option must be a boolean.\"))}))}))}},836:(e,t,r)=>{\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0}),t.PrintToConsole=void 0;var n=r(539),o=r(704),i=function(){function e(e){this.console=e,this.printToConsole=!1}return e.prototype.init=function(e){this.printToConsole=e},e.prototype.error=function(){for(var e,t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];this.printToConsole&&(e=this.console).error.apply(e,t)},e.prototype.info=function(){for(var e,t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];this.printToConsole&&(e=this.console).info.apply(e,t)},e.prototype.log=function(){for(var e,t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];this.printToConsole&&(e=this.console).log.apply(e,t)},e.prototype.debug=function(){for(var e,t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];this.printToConsole&&(e=this.console).debug.apply(e,t)},e.prototype.trace=function(){for(var e,t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];this.printToConsole&&(e=this.console).trace.apply(e,t)},e.prototype.warn=function(){for(var e,t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];this.printToConsole&&(e=this.console).warn.apply(e,t)},e.prototype.printLog=function(e){if(this.printToConsole){var t=[\"log\",\"warn\",\"error\",\"trace\",\"info\",\"error\"][e.level||o.LogLevel.Debug],r=e.tag?\"[\".concat(e.tag,\"] \"):\"\",i=[e.file||\"\",e.method||\"\",e.line||\"\"].filter((function(e){return\"\"!==e})).join(\":\"),a=\"\".concat(r).concat((0,n.format)(e.text),\" \").concat(i);this.console[t](a)}},e}();t.PrintToConsole=i},758:(e,t)=>{\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0}),t.RegisterErrorHandler=void 0;var r=function(){function e(e){this.window=e,this.rejectionsMap=new Map}return e.prototype.init=function(e){var t=this;this.bugfender=e,this.window.addEventListener(\"error\",(function(e){var r=e.message,n=e.lineno,o=e.filename,i=e.error;t.logError(r,o,n,i)})),this.window.addEventListener(\"unhandledrejection\",(function(e){var r=setTimeout((function(){t.logError(\"Potentially unhandled promise\",void 0,void 0,e.reason)}),1);t.rejectionsMap.set(e.promise,r),e.preventDefault()})),this.window.addEventListener(\"rejectionhandled\",(function(e){clearTimeout(t.rejectionsMap.get(e.promise)),t.rejectionsMap.delete(e.promise)}))},e.prototype.logError=function(e,t,r,n){var o;n&&n.stack&&(o=n.stack),\"string\"==typeof e&&this.bugfender.sendCrash(e,[\"Error: \".concat(e),\"URL: \".concat(null!=t?t:\"N/A\"),\"Line: \".concat(null!=r?r:\"N/A\"),\"Stack: \".concat(null!=o?o:\"N/A\")].join(\"\\n\"))},e}();t.RegisterErrorHandler=r},922:function(e,t,r){\"use strict\";var n=this&&this.__spreadArray||function(e,t,r){if(r||2===arguments.length)for(var n,o=0,i=t.length;o<i;o++)!n&&o in t||(n||(n=Array.prototype.slice.call(t,0,o)),n[o]=t[o]);return e.concat(n||Array.prototype.slice.call(t))};Object.defineProperty(t,\"__esModule\",{value:!0}),t.formatLogEntryText=t.format=void 0;var o=r(539),i=r(287);function a(e){var t=e.slice(1),r=e[0];try{r=(0,i.mapToString)(r)}catch(e){r=(0,o.format)(r)}return t.length>0?o.format.apply(void 0,n([r],t,!1)):r}t.format=a,t.formatLogEntryText=function(e){return\"string\"==typeof e?e:function(e){return Array.isArray(e)}(e)?a(e):\"\"}},287:(e,t)=>{\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0}),t.mapToString=t.mapToNumber=void 0,t.mapToNumber=function(e){var t=Number(e);if(isNaN(t))throw new Error(\"Can't be casted to number\");return t},t.mapToString=function(e){if([\"string\",\"symbol\",\"bigint\",\"function\"].includes(typeof e)||e instanceof Error)try{return String(e)}catch(t){return JSON.stringify(e)}else try{return JSON.stringify(e)}catch(t){return String(e)}}},929:function(e,t){\"use strict\";var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},r.apply(this,arguments)};Object.defineProperty(t,\"__esModule\",{value:!0}),t.UserFeedbackOptionsValidator=void 0;var n={title:\"Feedback\",hint:\"Please insert your feedback here and click send\",subjectPlaceholder:\"Subject\u2026\",feedbackPlaceholder:\"Your feedback\u2026\",submitLabel:\"Send\",closeLabel:\"Close\"},o=function(){function e(){}return e.prototype.init=function(e){return r(r({},n),null!=e?e:{})},e}();t.UserFeedbackOptionsValidator=o},484:(e,t)=>{\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0})},924:(e,t,r)=>{\"use strict\";var n=r(210),o=r(559),i=o(n(\"String.prototype.indexOf\"));e.exports=function(e,t){var r=n(e,!!t);return\"function\"==typeof r&&i(e,\".prototype.\")>-1?o(r):r}},559:(e,t,r)=>{\"use strict\";var n=r(612),o=r(210),i=o(\"%Function.prototype.apply%\"),a=o(\"%Function.prototype.call%\"),s=o(\"%Reflect.apply%\",!0)||n.call(a,i),c=o(\"%Object.getOwnPropertyDescriptor%\",!0),u=o(\"%Object.defineProperty%\",!0),l=o(\"%Math.max%\");if(u)try{u({},\"a\",{value:1})}catch(e){u=null}e.exports=function(e){var t=s(n,a,arguments);if(c&&u){var r=c(t,\"length\");r.configurable&&u(t,\"length\",{value:1+l(0,e.length-(arguments.length-1))})}return t};var f=function(){return s(n,i,arguments)};u?u(e.exports,\"apply\",{value:f}):e.exports.apply=f},804:e=>{var t=Object.prototype.hasOwnProperty,r=Object.prototype.toString;e.exports=function(e,n,o){if(\"[object Function]\"!==r.call(n))throw new TypeError(\"iterator must be a function\");var i=e.length;if(i===+i)for(var a=0;a<i;a++)n.call(o,e[a],a,e);else for(var s in e)t.call(e,s)&&n.call(o,e[s],s,e)}},648:e=>{\"use strict\";var t=\"Function.prototype.bind called on incompatible \",r=Array.prototype.slice,n=Object.prototype.toString,o=\"[object Function]\";e.exports=function(e){var i=this;if(\"function\"!=typeof i||n.call(i)!==o)throw new TypeError(t+i);for(var a,s=r.call(arguments,1),c=function(){if(this instanceof a){var t=i.apply(this,s.concat(r.call(arguments)));return Object(t)===t?t:this}return i.apply(e,s.concat(r.call(arguments)))},u=Math.max(0,i.length-s.length),l=[],f=0;f<u;f++)l.push(\"$\"+f);if(a=Function(\"binder\",\"return function (\"+l.join(\",\")+\"){ return binder.apply(this,arguments); }\")(c),i.prototype){var p=function(){};p.prototype=i.prototype,a.prototype=new p,p.prototype=null}return a}},612:(e,t,r)=>{\"use strict\";var n=r(648);e.exports=Function.prototype.bind||n},210:(e,t,r)=>{\"use strict\";var n,o=SyntaxError,i=Function,a=TypeError,s=function(e){try{return i('\"use strict\"; return ('+e+\").constructor;\")()}catch(e){}},c=Object.getOwnPropertyDescriptor;if(c)try{c({},\"\")}catch(e){c=null}var u=function(){throw new a},l=c?function(){try{return u}catch(e){try{return c(arguments,\"callee\").get}catch(e){return u}}}():u,f=r(405)(),p=Object.getPrototypeOf||function(e){return e.__proto__},y={},d=\"undefined\"==typeof Uint8Array?n:p(Uint8Array),h={\"%AggregateError%\":\"undefined\"==typeof AggregateError?n:AggregateError,\"%Array%\":Array,\"%ArrayBuffer%\":\"undefined\"==typeof ArrayBuffer?n:ArrayBuffer,\"%ArrayIteratorPrototype%\":f?p([][Symbol.iterator]()):n,\"%AsyncFromSyncIteratorPrototype%\":n,\"%AsyncFunction%\":y,\"%AsyncGenerator%\":y,\"%AsyncGeneratorFunction%\":y,\"%AsyncIteratorPrototype%\":y,\"%Atomics%\":\"undefined\"==typeof Atomics?n:Atomics,\"%BigInt%\":\"undefined\"==typeof BigInt?n:BigInt,\"%Boolean%\":Boolean,\"%DataView%\":\"undefined\"==typeof DataView?n:DataView,\"%Date%\":Date,\"%decodeURI%\":decodeURI,\"%decodeURIComponent%\":decodeURIComponent,\"%encodeURI%\":encodeURI,\"%encodeURIComponent%\":encodeURIComponent,\"%Error%\":Error,\"%eval%\":eval,\"%EvalError%\":EvalError,\"%Float32Array%\":\"undefined\"==typeof Float32Array?n:Float32Array,\"%Float64Array%\":\"undefined\"==typeof Float64Array?n:Float64Array,\"%FinalizationRegistry%\":\"undefined\"==typeof FinalizationRegistry?n:FinalizationRegistry,\"%Function%\":i,\"%GeneratorFunction%\":y,\"%Int8Array%\":\"undefined\"==typeof Int8Array?n:Int8Array,\"%Int16Array%\":\"undefined\"==typeof Int16Array?n:Int16Array,\"%Int32Array%\":\"undefined\"==typeof Int32Array?n:Int32Array,\"%isFinite%\":isFinite,\"%isNaN%\":isNaN,\"%IteratorPrototype%\":f?p(p([][Symbol.iterator]())):n,\"%JSON%\":\"object\"==typeof JSON?JSON:n,\"%Map%\":\"undefined\"==typeof Map?n:Map,\"%MapIteratorPrototype%\":\"undefined\"!=typeof Map&&f?p((new Map)[Symbol.iterator]()):n,\"%Math%\":Math,\"%Number%\":Number,\"%Object%\":Object,\"%parseFloat%\":parseFloat,\"%parseInt%\":parseInt,\"%Promise%\":\"undefined\"==typeof Promise?n:Promise,\"%Proxy%\":\"undefined\"==typeof Proxy?n:Proxy,\"%RangeError%\":RangeError,\"%ReferenceError%\":ReferenceError,\"%Reflect%\":\"undefined\"==typeof Reflect?n:Reflect,\"%RegExp%\":RegExp,\"%Set%\":\"undefined\"==typeof Set?n:Set,\"%SetIteratorPrototype%\":\"undefined\"!=typeof Set&&f?p((new Set)[Symbol.iterator]()):n,\"%SharedArrayBuffer%\":\"undefined\"==typeof SharedArrayBuffer?n:SharedArrayBuffer,\"%String%\":String,\"%StringIteratorPrototype%\":f?p(\"\"[Symbol.iterator]()):n,\"%Symbol%\":f?Symbol:n,\"%SyntaxError%\":o,\"%ThrowTypeError%\":l,\"%TypedArray%\":d,\"%TypeError%\":a,\"%Uint8Array%\":\"undefined\"==typeof Uint8Array?n:Uint8Array,\"%Uint8ClampedArray%\":\"undefined\"==typeof Uint8ClampedArray?n:Uint8ClampedArray,\"%Uint16Array%\":\"undefined\"==typeof Uint16Array?n:Uint16Array,\"%Uint32Array%\":\"undefined\"==typeof Uint32Array?n:Uint32Array,\"%URIError%\":URIError,\"%WeakMap%\":\"undefined\"==typeof WeakMap?n:WeakMap,\"%WeakRef%\":\"undefined\"==typeof WeakRef?n:WeakRef,\"%WeakSet%\":\"undefined\"==typeof WeakSet?n:WeakSet},g=function e(t){var r;if(\"%AsyncFunction%\"===t)r=s(\"async function () {}\");else if(\"%GeneratorFunction%\"===t)r=s(\"function* () {}\");else if(\"%AsyncGeneratorFunction%\"===t)r=s(\"async function* () {}\");else if(\"%AsyncGenerator%\"===t){var n=e(\"%AsyncGeneratorFunction%\");n&&(r=n.prototype)}else if(\"%AsyncIteratorPrototype%\"===t){var o=e(\"%AsyncGenerator%\");o&&(r=p(o.prototype))}return h[t]=r,r},b={\"%ArrayBufferPrototype%\":[\"ArrayBuffer\",\"prototype\"],\"%ArrayPrototype%\":[\"Array\",\"prototype\"],\"%ArrayProto_entries%\":[\"Array\",\"prototype\",\"entries\"],\"%ArrayProto_forEach%\":[\"Array\",\"prototype\",\"forEach\"],\"%ArrayProto_keys%\":[\"Array\",\"prototype\",\"keys\"],\"%ArrayProto_values%\":[\"Array\",\"prototype\",\"values\"],\"%AsyncFunctionPrototype%\":[\"AsyncFunction\",\"prototype\"],\"%AsyncGenerator%\":[\"AsyncGeneratorFunction\",\"prototype\"],\"%AsyncGeneratorPrototype%\":[\"AsyncGeneratorFunction\",\"prototype\",\"prototype\"],\"%BooleanPrototype%\":[\"Boolean\",\"prototype\"],\"%DataViewPrototype%\":[\"DataView\",\"prototype\"],\"%DatePrototype%\":[\"Date\",\"prototype\"],\"%ErrorPrototype%\":[\"Error\",\"prototype\"],\"%EvalErrorPrototype%\":[\"EvalError\",\"prototype\"],\"%Float32ArrayPrototype%\":[\"Float32Array\",\"prototype\"],\"%Float64ArrayPrototype%\":[\"Float64Array\",\"prototype\"],\"%FunctionPrototype%\":[\"Function\",\"prototype\"],\"%Generator%\":[\"GeneratorFunction\",\"prototype\"],\"%GeneratorPrototype%\":[\"GeneratorFunction\",\"prototype\",\"prototype\"],\"%Int8ArrayPrototype%\":[\"Int8Array\",\"prototype\"],\"%Int16ArrayPrototype%\":[\"Int16Array\",\"prototype\"],\"%Int32ArrayPrototype%\":[\"Int32Array\",\"prototype\"],\"%JSONParse%\":[\"JSON\",\"parse\"],\"%JSONStringify%\":[\"JSON\",\"stringify\"],\"%MapPrototype%\":[\"Map\",\"prototype\"],\"%NumberPrototype%\":[\"Number\",\"prototype\"],\"%ObjectPrototype%\":[\"Object\",\"prototype\"],\"%ObjProto_toString%\":[\"Object\",\"prototype\",\"toString\"],\"%ObjProto_valueOf%\":[\"Object\",\"prototype\",\"valueOf\"],\"%PromisePrototype%\":[\"Promise\",\"prototype\"],\"%PromiseProto_then%\":[\"Promise\",\"prototype\",\"then\"],\"%Promise_all%\":[\"Promise\",\"all\"],\"%Promise_reject%\":[\"Promise\",\"reject\"],\"%Promise_resolve%\":[\"Promise\",\"resolve\"],\"%RangeErrorPrototype%\":[\"RangeError\",\"prototype\"],\"%ReferenceErrorPrototype%\":[\"ReferenceError\",\"prototype\"],\"%RegExpPrototype%\":[\"RegExp\",\"prototype\"],\"%SetPrototype%\":[\"Set\",\"prototype\"],\"%SharedArrayBufferPrototype%\":[\"SharedArrayBuffer\",\"prototype\"],\"%StringPrototype%\":[\"String\",\"prototype\"],\"%SymbolPrototype%\":[\"Symbol\",\"prototype\"],\"%SyntaxErrorPrototype%\":[\"SyntaxError\",\"prototype\"],\"%TypedArrayPrototype%\":[\"TypedArray\",\"prototype\"],\"%TypeErrorPrototype%\":[\"TypeError\",\"prototype\"],\"%Uint8ArrayPrototype%\":[\"Uint8Array\",\"prototype\"],\"%Uint8ClampedArrayPrototype%\":[\"Uint8ClampedArray\",\"prototype\"],\"%Uint16ArrayPrototype%\":[\"Uint16Array\",\"prototype\"],\"%Uint32ArrayPrototype%\":[\"Uint32Array\",\"prototype\"],\"%URIErrorPrototype%\":[\"URIError\",\"prototype\"],\"%WeakMapPrototype%\":[\"WeakMap\",\"prototype\"],\"%WeakSetPrototype%\":[\"WeakSet\",\"prototype\"]},v=r(612),m=r(642),w=v.call(Function.call,Array.prototype.concat),O=v.call(Function.apply,Array.prototype.splice),S=v.call(Function.call,String.prototype.replace),j=v.call(Function.call,String.prototype.slice),P=/[^%.[\\]]+|\\[(?:(-?\\d+(?:\\.\\d+)?)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|%$))/g,A=/\\\\(\\\\)?/g,I=function(e){var t=j(e,0,1),r=j(e,-1);if(\"%\"===t&&\"%\"!==r)throw new o(\"invalid intrinsic syntax, expected closing `%`\");if(\"%\"===r&&\"%\"!==t)throw new o(\"invalid intrinsic syntax, expected opening `%`\");var n=[];return S(e,P,(function(e,t,r,o){n[n.length]=r?S(o,A,\"$1\"):t||e})),n},E=function(e,t){var r,n=e;if(m(b,n)&&(n=\"%\"+(r=b[n])[0]+\"%\"),m(h,n)){var i=h[n];if(i===y&&(i=g(n)),void 0===i&&!t)throw new a(\"intrinsic \"+e+\" exists, but is not available. Please file an issue!\");return{alias:r,name:n,value:i}}throw new o(\"intrinsic \"+e+\" does not exist!\")};e.exports=function(e,t){if(\"string\"!=typeof e||0===e.length)throw new a(\"intrinsic name must be a non-empty string\");if(arguments.length>1&&\"boolean\"!=typeof t)throw new a('\"allowMissing\" argument must be a boolean');var r=I(e),n=r.length>0?r[0]:\"\",i=E(\"%\"+n+\"%\",t),s=i.name,u=i.value,l=!1,f=i.alias;f&&(n=f[0],O(r,w([0,1],f)));for(var p=1,y=!0;p<r.length;p+=1){var d=r[p],g=j(d,0,1),b=j(d,-1);if(('\"'===g||\"'\"===g||\"`\"===g||'\"'===b||\"'\"===b||\"`\"===b)&&g!==b)throw new o(\"property names with quotes must have matching quotes\");if(\"constructor\"!==d&&y||(l=!0),m(h,s=\"%\"+(n+=\".\"+d)+\"%\"))u=h[s];else if(null!=u){if(!(d in u)){if(!t)throw new a(\"base intrinsic for \"+e+\" exists, but the property is not available.\");return}if(c&&p+1>=r.length){var v=c(u,d);u=(y=!!v)&&\"get\"in v&&!(\"originalValue\"in v.get)?v.get:u[d]}else y=m(u,d),u=u[d];y&&!l&&(h[s]=u)}}return u}},405:(e,t,r)=>{\"use strict\";var n=r.g.Symbol,o=r(419);e.exports=function(){return\"function\"==typeof n&&\"function\"==typeof Symbol&&\"symbol\"==typeof n(\"foo\")&&\"symbol\"==typeof Symbol(\"bar\")&&o()}},419:e=>{\"use strict\";e.exports=function(){if(\"function\"!=typeof Symbol||\"function\"!=typeof Object.getOwnPropertySymbols)return!1;if(\"symbol\"==typeof Symbol.iterator)return!0;var e={},t=Symbol(\"test\"),r=Object(t);if(\"string\"==typeof t)return!1;if(\"[object Symbol]\"!==Object.prototype.toString.call(t))return!1;if(\"[object Symbol]\"!==Object.prototype.toString.call(r))return!1;for(t in e[t]=42,e)return!1;if(\"function\"==typeof Object.keys&&0!==Object.keys(e).length)return!1;if(\"function\"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(e).length)return!1;var n=Object.getOwnPropertySymbols(e);if(1!==n.length||n[0]!==t)return!1;if(!Object.prototype.propertyIsEnumerable.call(e,t))return!1;if(\"function\"==typeof Object.getOwnPropertyDescriptor){var o=Object.getOwnPropertyDescriptor(e,t);if(42!==o.value||!0!==o.enumerable)return!1}return!0}},608:e=>{\"use strict\";e.exports=function(){if(\"function\"!=typeof Symbol||\"function\"!=typeof Object.getOwnPropertySymbols)return!1;if(\"symbol\"==typeof Symbol.iterator)return!0;var e={},t=Symbol(\"test\"),r=Object(t);if(\"string\"==typeof t)return!1;if(\"[object Symbol]\"!==Object.prototype.toString.call(t))return!1;if(\"[object Symbol]\"!==Object.prototype.toString.call(r))return!1;for(t in e[t]=42,e)return!1;if(\"function\"==typeof Object.keys&&0!==Object.keys(e).length)return!1;if(\"function\"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(e).length)return!1;var n=Object.getOwnPropertySymbols(e);if(1!==n.length||n[0]!==t)return!1;if(!Object.prototype.propertyIsEnumerable.call(e,t))return!1;if(\"function\"==typeof Object.getOwnPropertyDescriptor){var o=Object.getOwnPropertyDescriptor(e,t);if(42!==o.value||!0!==o.enumerable)return!1}return!0}},410:(e,t,r)=>{\"use strict\";var n=r(608);e.exports=function(){return n()&&!!Symbol.toStringTag}},642:(e,t,r)=>{\"use strict\";var n=r(612);e.exports=n.call(Function.call,Object.prototype.hasOwnProperty)},717:e=>{\"function\"==typeof Object.create?e.exports=function(e,t){t&&(e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}))}:e.exports=function(e,t){if(t){e.super_=t;var r=function(){};r.prototype=t.prototype,e.prototype=new r,e.prototype.constructor=e}}},584:(e,t,r)=>{\"use strict\";var n=r(410)(),o=r(924)(\"Object.prototype.toString\"),i=function(e){return!(n&&e&&\"object\"==typeof e&&Symbol.toStringTag in e)&&\"[object Arguments]\"===o(e)},a=function(e){return!!i(e)||null!==e&&\"object\"==typeof e&&\"number\"==typeof e.length&&e.length>=0&&\"[object Array]\"!==o(e)&&\"[object Function]\"===o(e.callee)},s=function(){return i(arguments)}();i.isLegacyArguments=a,e.exports=s?i:a},662:(e,t,r)=>{\"use strict\";var n,o=Object.prototype.toString,i=Function.prototype.toString,a=/^\\s*(?:function)?\\*/,s=r(410)(),c=Object.getPrototypeOf;e.exports=function(e){if(\"function\"!=typeof e)return!1;if(a.test(i.call(e)))return!0;if(!s)return\"[object GeneratorFunction]\"===o.call(e);if(!c)return!1;if(void 0===n){var t=function(){if(!s)return!1;try{return Function(\"return function*() {}\")()}catch(e){}}();n=!!t&&c(t)}return c(e)===n}},692:(e,t,r)=>{\"use strict\";var n=r(804),o=r(83),i=r(924),a=i(\"Object.prototype.toString\"),s=r(410)(),c=\"undefined\"==typeof globalThis?r.g:globalThis,u=o(),l=i(\"Array.prototype.indexOf\",!0)||function(e,t){for(var r=0;r<e.length;r+=1)if(e[r]===t)return r;return-1},f=i(\"String.prototype.slice\"),p={},y=r(882),d=Object.getPrototypeOf;s&&y&&d&&n(u,(function(e){var t=new c[e];if(Symbol.toStringTag in t){var r=d(t),n=y(r,Symbol.toStringTag);if(!n){var o=d(r);n=y(o,Symbol.toStringTag)}p[e]=n.get}})),e.exports=function(e){if(!e||\"object\"!=typeof e)return!1;if(!s||!(Symbol.toStringTag in e)){var t=f(a(e),8,-1);return l(u,t)>-1}return!!y&&function(e){var t=!1;return n(p,(function(r,n){if(!t)try{t=r.call(e)===n}catch(e){}})),t}(e)}},155:e=>{var t,r,n=e.exports={};function o(){throw new Error(\"setTimeout has not been defined\")}function i(){throw new Error(\"clearTimeout has not been defined\")}function a(e){if(t===setTimeout)return setTimeout(e,0);if((t===o||!t)&&setTimeout)return t=setTimeout,setTimeout(e,0);try{return t(e,0)}catch(r){try{return t.call(null,e,0)}catch(r){return t.call(this,e,0)}}}!function(){try{t=\"function\"==typeof setTimeout?setTimeout:o}catch(e){t=o}try{r=\"function\"==typeof clearTimeout?clearTimeout:i}catch(e){r=i}}();var s,c=[],u=!1,l=-1;function f(){u&&s&&(u=!1,s.length?c=s.concat(c):l=-1,c.length&&p())}function p(){if(!u){var e=a(f);u=!0;for(var t=c.length;t;){for(s=c,c=[];++l<t;)s&&s[l].run();l=-1,t=c.length}s=null,u=!1,function(e){if(r===clearTimeout)return clearTimeout(e);if((r===i||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(e);try{r(e)}catch(t){try{return r.call(null,e)}catch(t){return r.call(this,e)}}}(e)}}function y(e,t){this.fun=e,this.array=t}function d(){}n.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)t[r-1]=arguments[r];c.push(new y(e,t)),1!==c.length||u||a(p)},y.prototype.run=function(){this.fun.apply(null,this.array)},n.title=\"browser\",n.browser=!0,n.env={},n.argv=[],n.version=\"\",n.versions={},n.on=d,n.addListener=d,n.once=d,n.off=d,n.removeListener=d,n.removeAllListeners=d,n.emit=d,n.prependListener=d,n.prependOnceListener=d,n.listeners=function(e){return[]},n.binding=function(e){throw new Error(\"process.binding is not supported\")},n.cwd=function(){return\"/\"},n.chdir=function(e){throw new Error(\"process.chdir is not supported\")},n.umask=function(){return 0}},422:function(e,t,r){\"use strict\";var n=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function a(e){try{c(n.next(e))}catch(e){i(e)}}function s(e){try{c(n.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(a,s)}c((n=n.apply(e,t||[])).next())}))},o=this&&this.__asyncValues||function(e){if(!Symbol.asyncIterator)throw new TypeError(\"Symbol.asyncIterator is not defined.\");var t,r=e[Symbol.asyncIterator];return r?r.call(e):(e=\"function\"==typeof __values?__values(e):e[Symbol.iterator](),t={},n(\"next\"),n(\"throw\"),n(\"return\"),t[Symbol.asyncIterator]=function(){return this},t);function n(r){t[r]=e[r]&&function(t){return new Promise((function(n,o){!function(e,t,r,n){Promise.resolve(n).then((function(t){e({value:t,done:r})}),t)}(n,o,(t=e[r](t)).done,t.value)}))}}};Object.defineProperty(t,\"__esModule\",{value:!0}),t.Database=void 0;const i=r(998),a=r(593);var s;!function(e){e[e.New=0]=\"New\",e[e.V1=10]=\"V1\",e[e.V2=20]=\"V2\"}(s||(s={})),t.Database=class{constructor(e){this.db=(0,a.createDeferred)(),this.name=null!=e?e:\"bf_sdk\",this.init()}init(){return n(this,void 0,void 0,(function*(){const e=yield(0,i.openDB)(this.name,s.V2,{upgrade(e,t,r,i){var a,c,u,l;return n(this,void 0,void 0,(function*(){if(t===s.New&&(e.createObjectStore(\"devicekeys\",{keyPath:\"id\",autoIncrement:!0}).createIndex(\"sessionUUID\",\"sessionUUID\"),e.createObjectStore(\"issues\",{keyPath:\"id\",autoIncrement:!0}).createIndex(\"sessionUUID\",\"sessionUUID\"),e.createObjectStore(\"logs\",{keyPath:\"id\",autoIncrement:!0}).createIndex(\"sessionUUID\",\"sessionUUID\"),e.createObjectStore(\"sessions\",{keyPath:\"uuid\"})),t===s.V1){const e=i.objectStore(\"issues\");try{for(var r,n=!0,f=o(e);r=yield f.next(),!(a=r.done);){l=r.value,n=!1;try{const e=l,t=Object.assign({},e.value);t.data.text=t.data.markdown,delete t.data.markdown,e.update(t)}finally{n=!0}}}catch(e){c={error:e}}finally{try{n||a||!(u=f.return)||(yield u.call(f))}finally{if(c)throw c.error}}}}))}});this.db.resolve(e)}))}get(){return this.db.promise}}},177:function(e,t){\"use strict\";var r=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function a(e){try{c(n.next(e))}catch(e){i(e)}}function s(e){try{c(n.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(a,s)}c((n=n.apply(e,t||[])).next())}))};Object.defineProperty(t,\"__esModule\",{value:!0}),t.InMemoryDeviceKeysTable=t.IDBDeviceKeysTable=void 0,t.IDBDeviceKeysTable=class{constructor(e){this.table=e}add(e){return this.table.add(e)}count(e){return this.table.countBy(\"sessionUUID\",e)}deleteBatch(e){return this.table.deleteBatch(0,e)}getAll(){return this.table.getAll()}},t.InMemoryDeviceKeysTable=class{constructor(){this.data=[],this.idCounter=0}getNextID(){return this.idCounter++}add(e){return r(this,void 0,void 0,(function*(){const t=this.getNextID();this.data.push(Object.assign(Object.assign({},e),{id:t}))}))}count(e){return r(this,void 0,void 0,(function*(){return this.data.filter((t=>t.sessionUUID===e)).length}))}deleteBatch(e){return r(this,void 0,void 0,(function*(){this.data.splice(0,e)}))}getAll(){return r(this,void 0,void 0,(function*(){return[...this.data]}))}}},941:function(e,t){\"use strict\";var r=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function a(e){try{c(n.next(e))}catch(e){i(e)}}function s(e){try{c(n.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(a,s)}c((n=n.apply(e,t||[])).next())}))};Object.defineProperty(t,\"__esModule\",{value:!0}),t.InMemoryIssuesTable=t.IDBIssuesTable=void 0,t.IDBIssuesTable=class{constructor(e){this.table=e}add(e){return this.table.add(e)}count(e){return this.table.countBy(\"sessionUUID\",e)}deleteById(e){return this.table.deleteByIdx(e)}getBatch(e,t){return this.table.getBatch(e,t)}},t.InMemoryIssuesTable=class{constructor(){this.data=[],this.idCounter=0}getNextID(){return this.idCounter++}add(e){return r(this,void 0,void 0,(function*(){const t=this.getNextID();this.data.push(Object.assign(Object.assign({},e),{id:t}))}))}count(e){return r(this,void 0,void 0,(function*(){return this.data.filter((t=>t.sessionUUID===e)).length}))}deleteById(e){return r(this,void 0,void 0,(function*(){const t=this.data.findIndex((t=>t.id===e));-1!==t&&this.data.splice(t,1)}))}getBatch(e,t){return r(this,void 0,void 0,(function*(){return this.data.filter((t=>t.sessionUUID===e)).slice(0,t)}))}}},856:function(e,t){\"use strict\";var r=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function a(e){try{c(n.next(e))}catch(e){i(e)}}function s(e){try{c(n.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(a,s)}c((n=n.apply(e,t||[])).next())}))};Object.defineProperty(t,\"__esModule\",{value:!0}),t.InMemoryLogsTable=t.IDBLogsTable=void 0,t.IDBLogsTable=class{constructor(e,t){this.table=e,this.logFactory=t}add(e){return this.table.add(e)}count(e){return this.table.countBy(\"sessionUUID\",e)}deleteBatch(e,t){return this.table.deleteBatch(0,t,[\"sessionUUID\",e])}deleteOldLogs(e,t=10){return r(this,void 0,void 0,(function*(){const r=yield this.table.getBatch(e,t);if(r.length<=1)return;const n={sessionUUID:e,data:this.logFactory.createGapLog(r.map((e=>e.data)))};yield Promise.all([this.table.patchByIdx(r[0].id,n),this.table.deleteBatch(1,t-1,[\"sessionUUID\",e])])}))}getBatch(e,t){return this.table.getBatch(e,t)}},t.InMemoryLogsTable=class{constructor(e,t){this.logFactory=e,this.storageLimit=t,this.data=[],this.idCounter=0}getNextID(){return this.idCounter++}add(e){return r(this,void 0,void 0,(function*(){if(this.data.length>=this.storageLimit){const e=new Error(\"InMemory storage quota exceeded\");throw e.name=\"QuotaExceededError\",e}const t=this.getNextID();this.data.push(Object.assign(Object.assign({},e),{id:t}))}))}count(e){return r(this,void 0,void 0,(function*(){return this.data.filter((t=>t.sessionUUID===e)).length}))}deleteBatch(e,t){return r(this,void 0,void 0,(function*(){const r=[];let n=0;for(let o=0;o<this.data.length;o++){const i=this.data[o];i.sessionUUID===e&&n<t?n++:r.push(i)}this.data=r}))}deleteOldLogs(e){return r(this,void 0,void 0,(function*(){const e=this.data.slice(0,10);e.length<=1||(this.data[0].data=this.logFactory.createGapLog(e.map((e=>e.data))),this.data.splice(1,9))}))}getBatch(e,t){return r(this,void 0,void 0,(function*(){return this.data.filter((t=>t.sessionUUID===e)).slice(0,t)}))}}},967:function(e,t){\"use strict\";var r=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function a(e){try{c(n.next(e))}catch(e){i(e)}}function s(e){try{c(n.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(a,s)}c((n=n.apply(e,t||[])).next())}))};Object.defineProperty(t,\"__esModule\",{value:!0}),t.Table=void 0,t.Table=class{constructor(e,t){this.dbPromise=e,this.store=t}add(e){return r(this,void 0,void 0,(function*(){yield(yield this.dbPromise).add(this.store,e)}))}clear(){return r(this,void 0,void 0,(function*(){yield(yield this.dbPromise).clear(this.store)}))}countBy(e,t){return r(this,void 0,void 0,(function*(){const r=(yield this.dbPromise).transaction(this.store,\"readonly\");let n,o=0;if(e!==r.store.keyPath){const o=r.store.index(e),i=IDBKeyRange.only(t);n=yield o.openCursor(i)}else n=yield r.store.openCursor(IDBKeyRange.only(t));for(;n;)o++,n=yield n.continue();return o}))}deleteBatch(e,t,n){return r(this,void 0,void 0,(function*(){const r=(yield this.dbPromise).transaction(this.store,\"readwrite\");let o,i=0;if(n)if(n[0]!==r.store.keyPath){const e=r.store.index(n[0]),t=IDBKeyRange.only(n[1]);o=yield e.openCursor(t)}else o=yield r.store.openCursor(IDBKeyRange.only(n[1]));else o=yield r.store.openCursor();for(;o&&(i>=e&&o.delete(),i++,i!==e+t);)o=yield o.continue()}))}deleteByIdx(e){return r(this,void 0,void 0,(function*(){return(yield this.dbPromise).delete(this.store,e)}))}getAll(){return r(this,void 0,void 0,(function*(){return(yield this.dbPromise).getAll(this.store)}))}getBatch(e,t){return r(this,void 0,void 0,(function*(){const r=(yield this.dbPromise).transaction(this.store,\"readonly\").store.index(\"sessionUUID\"),n=IDBKeyRange.only(e);let o=yield r.openCursor(n);const i=[];let a=0;for(;o&&(i.push(o.value),a++,a!==t);)o=yield o.continue();return i}))}patchByIdx(e,t){return r(this,void 0,void 0,(function*(){const r=(yield this.dbPromise).transaction(this.store,\"readwrite\"),n=yield r.store.get(e);yield r.store.put(Object.assign(Object.assign({},n),t))}))}}},572:(e,t,r)=>{\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0}),t.LogFactory=void 0;const n=r(431);t.LogFactory=class{constructor(e=32e3){this.maxLogLength=e}createFromDeviceKey(e,t,r,n){return this.createFromEntry({tag:\"bf_key_value\",text:`Set device data \"${e}\"=\"${t}\"`},r,n)}createFromEntry(e,t,r){var o,i,a,s,c,u,l,f,p,y;let d=null!==(o=e.text)&&void 0!==o?o:\"\";return d.length>=this.maxLogLength&&(d=d.substring(0,this.maxLogLength)+\"\u2026\"),{x:r.iso,t:d,m:null!==(a=null!==(i=e.method)&&void 0!==i?i:t.method)&&void 0!==a?a:\"\",at:r.epoch,tg:null!==(s=e.tag)&&void 0!==s?s:\"\",f:null!==(u=null!==(c=e.file)&&void 0!==c?c:t.file)&&void 0!==u?u:\"\",l:null!==(f=null!==(l=e.line)&&void 0!==l?l:t.line)&&void 0!==f?f:0,ll:null!==(p=e.level)&&void 0!==p?p:n.LogLevel.Debug,u:null!==(y=e.url)&&void 0!==y?y:\"\"}}createFromIssue(e,t,r){return this.createFromEntry({level:n.LogLevel.Error,tag:\"bf_issue\",text:e},t,r)}createGapLog(e){const t=JSON.stringify({bf_start_date:e[0].at,bf_end_date:e[e.length-1].at});return{x:e[0].x,t,m:\"\",at:e[0].at,tg:\"bf_gap_log\",f:\"\",l:0,ll:0,u:e[0].u}}}},41:function(e,t){\"use strict\";var r=this&&this.__awaiter||function(e,t,r,n){return new(r||(r=Promise))((function(o,i){function a(e){try{c(n.next(e))}catch(e){i(e)}}function s(e){try{c(n.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(a,s)}c((n=n.apply(e,t||[])).next())}))};Object.defineProperty(t,\"__esModule\",{value:!0}),t.StorageWriter=void 0,t.StorageWriter=class{constructor(e,t,r,n){this.deviceKeysTable=e,this.issuesTable=t,this.logFactory=r,this.logsTable=n,this.isClearingSpace=!1,this.logsQueue=[]}handleMessage(e){return r(this,void 0,void 0,(function*(){switch(e.type){case\"device-key\":return this.addDeviceKey(e.data.key,e.data.value,e.data.callInfo,e.data.time);case\"init\":this.options=e.data.options,this.sessionUUID=e.data.sessionUUID;break;case\"issue\":return this.addIssue(e.data.type,e.data.title,e.data.text,e.data.uuid,e.data.callInfo,e.data.time);case\"log-entry\":return this.addLogEntry(e.data.log,e.data.callInfo,e.data.time)}}))}addDeviceKey(e,t,r,n){this.deviceKeysTable.add({sessionUUID:this.sessionUUID,data:{key:e,value:t}}),this.addLog(this.logFactory.createFromDeviceKey(e,t,r,n))}addLog(e){return r(this,void 0,void 0,(function*(){const t={sessionUUID:this.sessionUUID,data:e};if(this.isClearingSpace)this.logsQueue.push(t);else try{yield this.logsTable.add(t)}catch(e){this.isQuotaExceededError(e)&&(this.logsQueue.push(t),this.isClearingSpace=!0,yield this.logsTable.deleteOldLogs(this.sessionUUID),yield this.processLogsQueue(),this.isClearingSpace=!1)}}))}addLogEntry(e,t,r){this.addLog(this.logFactory.createFromEntry(e,t,r))}addIssue(e,t,r,n,o,i){this.issuesTable.add({sessionUUID:this.sessionUUID,data:{title:t,text:r,type:e,uuid:n}}),this.addLog(this.logFactory.createFromIssue(n,o,i))}isQuotaExceededError(e){var t;return\"QuotaExceededError\"===e.name||\"QuotaExceededError\"===(null===(t=e.inner)||void 0===t?void 0:t.name)}processLogsQueue(){return r(this,void 0,void 0,(function*(){for(;this.logsQueue.length>0;){const e=this.logsQueue[0];try{yield this.logsTable.add(e),this.logsQueue.shift()}catch(e){this.isQuotaExceededError(e)&&(yield this.logsTable.deleteOldLogs(this.sessionUUID))}}}))}}},593:(e,t)=>{\"use strict\";Object.defineProperty(t,\"__esModule\",{value:!0}),t.getElByXPath=t.getXPath=t.DebounceByElement=t.UnreachableCaseError=t.CacheDecoratorFactory=t.createDeferred=void 0,t.createDeferred=function(){const e={isFulfilled:!1,isRejected:!1,isResolved:!1};return e.promise=new Promise(((t,r)=>{e.resolve=r=>{const n=e;n.isFulfilled=!0,n.isRejected=!1,n.isResolved=!0,n.value=r,t(r)},e.reject=t=>{const n=e;n.isFulfilled=!0,n.isRejected=!0,n.isResolved=!1,n.err=t,r(t)}})),e},t.CacheDecoratorFactory=function(e){return function(){return function(t,r,n){const o=n.value;n.value=function(){return e.has(r)||e.set(r,o.apply(this)),e.get(r)}}}};class r extends Error{constructor(e){super(`Unreachable case: ${JSON.stringify(e)}`)}}t.UnreachableCaseError=r,t.DebounceByElement=class{constructor(e){this.wait=e,this.timers=new Map}run(e,t){this.timers.has(e)&&clearTimeout(this.timers.get(e)),this.timers.set(e,setTimeout((()=>{t(),this.timers.delete(e)}),this.wait))}},t.getXPath=function(e){let t=e;if(t instanceof Element&&t.id)return'//*[@id=\"'+t.id+'\"]';const r=[];for(;t&&t instanceof Element;){const e=t;let n=0,o=!1,i=e.previousSibling;for(;i;)i.nodeType!==Node.DOCUMENT_TYPE_NODE&&i.nodeName===e.nodeName&&n++,i=i.previousSibling;for(i=e.nextSibling;i;){if(i.nodeName===e.nodeName){o=!0;break}i=i.nextSibling}const a=e.prefix?e.prefix+\":\":\"\",s=n||o?`[${n+1}]`:\"\";r.push(a+e.localName+s),t=e.parentNode}return r.length?\"/\"+r.reverse().join(\"/\"):\"\"},t.getElByXPath=function(e){var t;return null!==(t=document.evaluate(e,document,null,XPathResult.FIRST_ORDERED_NODE_TYPE,null).singleNodeValue)&&void 0!==t?t:void 0}},384:e=>{e.exports=function(e){return e&&\"object\"==typeof e&&\"function\"==typeof e.copy&&\"function\"==typeof e.fill&&\"function\"==typeof e.readUInt8}},955:(e,t,r)=>{\"use strict\";var n=r(584),o=r(662),i=r(430),a=r(692);function s(e){return e.call.bind(e)}var c=\"undefined\"!=typeof BigInt,u=\"undefined\"!=typeof Symbol,l=s(Object.prototype.toString),f=s(Number.prototype.valueOf),p=s(String.prototype.valueOf),y=s(Boolean.prototype.valueOf);if(c)var d=s(BigInt.prototype.valueOf);if(u)var h=s(Symbol.prototype.valueOf);function g(e,t){if(\"object\"!=typeof e)return!1;try{return t(e),!0}catch(e){return!1}}function b(e){return\"[object Map]\"===l(e)}function v(e){return\"[object Set]\"===l(e)}function m(e){return\"[object WeakMap]\"===l(e)}function w(e){return\"[object WeakSet]\"===l(e)}function O(e){return\"[object ArrayBuffer]\"===l(e)}function S(e){return\"undefined\"!=typeof ArrayBuffer&&(O.working?O(e):e instanceof ArrayBuffer)}function j(e){return\"[object DataView]\"===l(e)}function P(e){return\"undefined\"!=typeof DataView&&(j.working?j(e):e instanceof DataView)}t.isArgumentsObject=n,t.isGeneratorFunction=o,t.isTypedArray=a,t.isPromise=function(e){return\"undefined\"!=typeof Promise&&e instanceof Promise||null!==e&&\"object\"==typeof e&&\"function\"==typeof e.then&&\"function\"==typeof e.catch},t.isArrayBufferView=function(e){return\"undefined\"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(e):a(e)||P(e)},t.isUint8Array=function(e){return\"Uint8Array\"===i(e)},t.isUint8ClampedArray=function(e){return\"Uint8ClampedArray\"===i(e)},t.isUint16Array=function(e){return\"Uint16Array\"===i(e)},t.isUint32Array=function(e){return\"Uint32Array\"===i(e)},t.isInt8Array=function(e){return\"Int8Array\"===i(e)},t.isInt16Array=function(e){return\"Int16Array\"===i(e)},t.isInt32Array=function(e){return\"Int32Array\"===i(e)},t.isFloat32Array=function(e){return\"Float32Array\"===i(e)},t.isFloat64Array=function(e){return\"Float64Array\"===i(e)},t.isBigInt64Array=function(e){return\"BigInt64Array\"===i(e)},t.isBigUint64Array=function(e){return\"BigUint64Array\"===i(e)},b.working=\"undefined\"!=typeof Map&&b(new Map),t.isMap=function(e){return\"undefined\"!=typeof Map&&(b.working?b(e):e instanceof Map)},v.working=\"undefined\"!=typeof Set&&v(new Set),t.isSet=function(e){return\"undefined\"!=typeof Set&&(v.working?v(e):e instanceof Set)},m.working=\"undefined\"!=typeof WeakMap&&m(new WeakMap),t.isWeakMap=function(e){return\"undefined\"!=typeof WeakMap&&(m.working?m(e):e instanceof WeakMap)},w.working=\"undefined\"!=typeof WeakSet&&w(new WeakSet),t.isWeakSet=function(e){return w(e)},O.working=\"undefined\"!=typeof ArrayBuffer&&O(new ArrayBuffer),t.isArrayBuffer=S,j.working=\"undefined\"!=typeof ArrayBuffer&&\"undefined\"!=typeof DataView&&j(new DataView(new ArrayBuffer(1),0,1)),t.isDataView=P;var A=\"undefined\"!=typeof SharedArrayBuffer?SharedArrayBuffer:void 0;function I(e){return\"[object SharedArrayBuffer]\"===l(e)}function E(e){return void 0!==A&&(void 0===I.working&&(I.working=I(new A)),I.working?I(e):e instanceof A)}function D(e){return g(e,f)}function x(e){return g(e,p)}function U(e){return g(e,y)}function B(e){return c&&g(e,d)}function T(e){return u&&g(e,h)}t.isSharedArrayBuffer=E,t.isAsyncFunction=function(e){return\"[object AsyncFunction]\"===l(e)},t.isMapIterator=function(e){return\"[object Map Iterator]\"===l(e)},t.isSetIterator=function(e){return\"[object Set Iterator]\"===l(e)},t.isGeneratorObject=function(e){return\"[object Generator]\"===l(e)},t.isWebAssemblyCompiledModule=function(e){return\"[object WebAssembly.Module]\"===l(e)},t.isNumberObject=D,t.isStringObject=x,t.isBooleanObject=U,t.isBigIntObject=B,t.isSymbolObject=T,t.isBoxedPrimitive=function(e){return D(e)||x(e)||U(e)||B(e)||T(e)},t.isAnyArrayBuffer=function(e){return\"undefined\"!=typeof Uint8Array&&(S(e)||E(e))},[\"isProxy\",\"isExternal\",\"isModuleNamespaceObject\"].forEach((function(e){Object.defineProperty(t,e,{enumerable:!1,value:function(){throw new Error(e+\" is not supported in userland\")}})}))},539:(e,t,r)=>{var n=r(155),o=Object.getOwnPropertyDescriptors||function(e){for(var t=Object.keys(e),r={},n=0;n<t.length;n++)r[t[n]]=Object.getOwnPropertyDescriptor(e,t[n]);return r},i=/%[sdj%]/g;t.format=function(e){if(!m(e)){for(var t=[],r=0;r<arguments.length;r++)t.push(u(arguments[r]));return t.join(\" \")}r=1;for(var n=arguments,o=n.length,a=String(e).replace(i,(function(e){if(\"%%\"===e)return\"%\";if(r>=o)return e;switch(e){case\"%s\":return String(n[r++]);case\"%d\":return Number(n[r++]);case\"%j\":try{return JSON.stringify(n[r++])}catch(e){return\"[Circular]\"}default:return e}})),s=n[r];r<o;s=n[++r])b(s)||!S(s)?a+=\" \"+s:a+=\" \"+u(s);return a},t.deprecate=function(e,r){if(void 0!==n&&!0===n.noDeprecation)return e;if(void 0===n)return function(){return t.deprecate(e,r).apply(this,arguments)};var o=!1;return function(){if(!o){if(n.throwDeprecation)throw new Error(r);n.traceDeprecation?console.trace(r):console.error(r),o=!0}return e.apply(this,arguments)}};var a={},s=/^$/;if(n.env.NODE_DEBUG){var c=n.env.NODE_DEBUG;c=c.replace(/[|\\\\{}()[\\]^$+?.]/g,\"\\\\$&\").replace(/\\*/g,\".*\").replace(/,/g,\"$|^\").toUpperCase(),s=new RegExp(\"^\"+c+\"$\",\"i\")}function u(e,r){var n={seen:[],stylize:f};return arguments.length>=3&&(n.depth=arguments[2]),arguments.length>=4&&(n.colors=arguments[3]),g(r)?n.showHidden=r:r&&t._extend(n,r),w(n.showHidden)&&(n.showHidden=!1),w(n.depth)&&(n.depth=2),w(n.colors)&&(n.colors=!1),w(n.customInspect)&&(n.customInspect=!0),n.colors&&(n.stylize=l),p(n,e,n.depth)}function l(e,t){var r=u.styles[t];return r?\"\x1B[\"+u.colors[r][0]+\"m\"+e+\"\x1B[\"+u.colors[r][1]+\"m\":e}function f(e,t){return e}function p(e,r,n){if(e.customInspect&&r&&A(r.inspect)&&r.inspect!==t.inspect&&(!r.constructor||r.constructor.prototype!==r)){var o=r.inspect(n,e);return m(o)||(o=p(e,o,n)),o}var i=function(e,t){if(w(t))return e.stylize(\"undefined\",\"undefined\");if(m(t)){var r=\"'\"+JSON.stringify(t).replace(/^\"|\"$/g,\"\").replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"')+\"'\";return e.stylize(r,\"string\")}return v(t)?e.stylize(\"\"+t,\"number\"):g(t)?e.stylize(\"\"+t,\"boolean\"):b(t)?e.stylize(\"null\",\"null\"):void 0}(e,r);if(i)return i;var a=Object.keys(r),s=function(e){var t={};return e.forEach((function(e,r){t[e]=!0})),t}(a);if(e.showHidden&&(a=Object.getOwnPropertyNames(r)),P(r)&&(a.indexOf(\"message\")>=0||a.indexOf(\"description\")>=0))return y(r);if(0===a.length){if(A(r)){var c=r.name?\": \"+r.name:\"\";return e.stylize(\"[Function\"+c+\"]\",\"special\")}if(O(r))return e.stylize(RegExp.prototype.toString.call(r),\"regexp\");if(j(r))return e.stylize(Date.prototype.toString.call(r),\"date\");if(P(r))return y(r)}var u,l=\"\",f=!1,S=[\"{\",\"}\"];return h(r)&&(f=!0,S=[\"[\",\"]\"]),A(r)&&(l=\" [Function\"+(r.name?\": \"+r.name:\"\")+\"]\"),O(r)&&(l=\" \"+RegExp.prototype.toString.call(r)),j(r)&&(l=\" \"+Date.prototype.toUTCString.call(r)),P(r)&&(l=\" \"+y(r)),0!==a.length||f&&0!=r.length?n<0?O(r)?e.stylize(RegExp.prototype.toString.call(r),\"regexp\"):e.stylize(\"[Object]\",\"special\"):(e.seen.push(r),u=f?function(e,t,r,n,o){for(var i=[],a=0,s=t.length;a<s;++a)U(t,String(a))?i.push(d(e,t,r,n,String(a),!0)):i.push(\"\");return o.forEach((function(o){o.match(/^\\d+$/)||i.push(d(e,t,r,n,o,!0))})),i}(e,r,n,s,a):a.map((function(t){return d(e,r,n,s,t,f)})),e.seen.pop(),function(e,t,r){return e.reduce((function(e,t){return t.indexOf(\"\\n\"),e+t.replace(/\\u001b\\[\\d\\d?m/g,\"\").length+1}),0)>60?r[0]+(\"\"===t?\"\":t+\"\\n \")+\" \"+e.join(\",\\n  \")+\" \"+r[1]:r[0]+t+\" \"+e.join(\", \")+\" \"+r[1]}(u,l,S)):S[0]+l+S[1]}function y(e){return\"[\"+Error.prototype.toString.call(e)+\"]\"}function d(e,t,r,n,o,i){var a,s,c;if((c=Object.getOwnPropertyDescriptor(t,o)||{value:t[o]}).get?s=c.set?e.stylize(\"[Getter/Setter]\",\"special\"):e.stylize(\"[Getter]\",\"special\"):c.set&&(s=e.stylize(\"[Setter]\",\"special\")),U(n,o)||(a=\"[\"+o+\"]\"),s||(e.seen.indexOf(c.value)<0?(s=b(r)?p(e,c.value,null):p(e,c.value,r-1)).indexOf(\"\\n\")>-1&&(s=i?s.split(\"\\n\").map((function(e){return\"  \"+e})).join(\"\\n\").slice(2):\"\\n\"+s.split(\"\\n\").map((function(e){return\"   \"+e})).join(\"\\n\")):s=e.stylize(\"[Circular]\",\"special\")),w(a)){if(i&&o.match(/^\\d+$/))return s;(a=JSON.stringify(\"\"+o)).match(/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?(a=a.slice(1,-1),a=e.stylize(a,\"name\")):(a=a.replace(/'/g,\"\\\\'\").replace(/\\\\\"/g,'\"').replace(/(^\"|\"$)/g,\"'\"),a=e.stylize(a,\"string\"))}return a+\": \"+s}function h(e){return Array.isArray(e)}function g(e){return\"boolean\"==typeof e}function b(e){return null===e}function v(e){return\"number\"==typeof e}function m(e){return\"string\"==typeof e}function w(e){return void 0===e}function O(e){return S(e)&&\"[object RegExp]\"===I(e)}function S(e){return\"object\"==typeof e&&null!==e}function j(e){return S(e)&&\"[object Date]\"===I(e)}function P(e){return S(e)&&(\"[object Error]\"===I(e)||e instanceof Error)}function A(e){return\"function\"==typeof e}function I(e){return Object.prototype.toString.call(e)}function E(e){return e<10?\"0\"+e.toString(10):e.toString(10)}t.debuglog=function(e){if(e=e.toUpperCase(),!a[e])if(s.test(e)){var r=n.pid;a[e]=function(){var n=t.format.apply(t,arguments);console.error(\"%s %d: %s\",e,r,n)}}else a[e]=function(){};return a[e]},t.inspect=u,u.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},u.styles={special:\"cyan\",number:\"yellow\",boolean:\"yellow\",undefined:\"grey\",null:\"bold\",string:\"green\",date:\"magenta\",regexp:\"red\"},t.types=r(955),t.isArray=h,t.isBoolean=g,t.isNull=b,t.isNullOrUndefined=function(e){return null==e},t.isNumber=v,t.isString=m,t.isSymbol=function(e){return\"symbol\"==typeof e},t.isUndefined=w,t.isRegExp=O,t.types.isRegExp=O,t.isObject=S,t.isDate=j,t.types.isDate=j,t.isError=P,t.types.isNativeError=P,t.isFunction=A,t.isPrimitive=function(e){return null===e||\"boolean\"==typeof e||\"number\"==typeof e||\"string\"==typeof e||\"symbol\"==typeof e||void 0===e},t.isBuffer=r(384);var D=[\"Jan\",\"Feb\",\"Mar\",\"Apr\",\"May\",\"Jun\",\"Jul\",\"Aug\",\"Sep\",\"Oct\",\"Nov\",\"Dec\"];function x(){var e=new Date,t=[E(e.getHours()),E(e.getMinutes()),E(e.getSeconds())].join(\":\");return[e.getDate(),D[e.getMonth()],t].join(\" \")}function U(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.log=function(){console.log(\"%s - %s\",x(),t.format.apply(t,arguments))},t.inherits=r(717),t._extend=function(e,t){if(!t||!S(t))return e;for(var r=Object.keys(t),n=r.length;n--;)e[r[n]]=t[r[n]];return e};var B=\"undefined\"!=typeof Symbol?Symbol(\"util.promisify.custom\"):void 0;function T(e,t){if(!e){var r=new Error(\"Promise was rejected with a falsy value\");r.reason=e,e=r}return t(e)}t.promisify=function(e){if(\"function\"!=typeof e)throw new TypeError('The \"original\" argument must be of type Function');if(B&&e[B]){var t;if(\"function\"!=typeof(t=e[B]))throw new TypeError('The \"util.promisify.custom\" argument must be of type Function');return Object.defineProperty(t,B,{value:t,enumerable:!1,writable:!1,configurable:!0}),t}function t(){for(var t,r,n=new Promise((function(e,n){t=e,r=n})),o=[],i=0;i<arguments.length;i++)o.push(arguments[i]);o.push((function(e,n){e?r(e):t(n)}));try{e.apply(this,o)}catch(e){r(e)}return n}return Object.setPrototypeOf(t,Object.getPrototypeOf(e)),B&&Object.defineProperty(t,B,{value:t,enumerable:!1,writable:!1,configurable:!0}),Object.defineProperties(t,o(e))},t.promisify.custom=B,t.callbackify=function(e){if(\"function\"!=typeof e)throw new TypeError('The \"original\" argument must be of type Function');function t(){for(var t=[],r=0;r<arguments.length;r++)t.push(arguments[r]);var o=t.pop();if(\"function\"!=typeof o)throw new TypeError(\"The last argument must be of type Function\");var i=this,a=function(){return o.apply(i,arguments)};e.apply(this,t).then((function(e){n.nextTick(a.bind(null,null,e))}),(function(e){n.nextTick(T.bind(null,e,a))}))}return Object.setPrototypeOf(t,Object.getPrototypeOf(e)),Object.defineProperties(t,o(e)),t}},430:(e,t,r)=>{\"use strict\";var n=r(804),o=r(83),i=r(924),a=i(\"Object.prototype.toString\"),s=r(410)(),c=\"undefined\"==typeof globalThis?r.g:globalThis,u=o(),l=i(\"String.prototype.slice\"),f={},p=r(882),y=Object.getPrototypeOf;s&&p&&y&&n(u,(function(e){if(\"function\"==typeof c[e]){var t=new c[e];if(Symbol.toStringTag in t){var r=y(t),n=p(r,Symbol.toStringTag);if(!n){var o=y(r);n=p(o,Symbol.toStringTag)}f[e]=n.get}}}));var d=r(692);e.exports=function(e){return!!d(e)&&(s&&Symbol.toStringTag in e?function(e){var t=!1;return n(f,(function(r,n){if(!t)try{var o=r.call(e);o===n&&(t=o)}catch(e){}})),t}(e):l(a(e),8,-1))}},83:(e,t,r)=>{\"use strict\";var n=[\"BigInt64Array\",\"BigUint64Array\",\"Float32Array\",\"Float64Array\",\"Int16Array\",\"Int32Array\",\"Int8Array\",\"Uint16Array\",\"Uint32Array\",\"Uint8Array\",\"Uint8ClampedArray\"],o=\"undefined\"==typeof globalThis?r.g:globalThis;e.exports=function(){for(var e=[],t=0;t<n.length;t++)\"function\"==typeof o[n[t]]&&(e[e.length]=n[t]);return e}},882:(e,t,r)=>{\"use strict\";var n=r(210)(\"%Object.getOwnPropertyDescriptor%\",!0);if(n)try{n([],\"length\")}catch(e){n=null}e.exports=n},998:(e,t,r)=>{\"use strict\";r.r(t),r.d(t,{deleteDB:()=>b,openDB:()=>g,unwrap:()=>h,wrap:()=>d});const n=(e,t)=>t.some((t=>e instanceof t));let o,i;const a=new WeakMap,s=new WeakMap,c=new WeakMap,u=new WeakMap,l=new WeakMap;let f={get(e,t,r){if(e instanceof IDBTransaction){if(\"done\"===t)return s.get(e);if(\"objectStoreNames\"===t)return e.objectStoreNames||c.get(e);if(\"store\"===t)return r.objectStoreNames[1]?void 0:r.objectStore(r.objectStoreNames[0])}return d(e[t])},set:(e,t,r)=>(e[t]=r,!0),has:(e,t)=>e instanceof IDBTransaction&&(\"done\"===t||\"store\"===t)||t in e};function p(e){f=e(f)}function y(e){return\"function\"==typeof e?(t=e)!==IDBDatabase.prototype.transaction||\"objectStoreNames\"in IDBTransaction.prototype?(i||(i=[IDBCursor.prototype.advance,IDBCursor.prototype.continue,IDBCursor.prototype.continuePrimaryKey])).includes(t)?function(...e){return t.apply(h(this),e),d(a.get(this))}:function(...e){return d(t.apply(h(this),e))}:function(e,...r){const n=t.call(h(this),e,...r);return c.set(n,e.sort?e.sort():[e]),d(n)}:(e instanceof IDBTransaction&&function(e){if(s.has(e))return;const t=new Promise(((t,r)=>{const n=()=>{e.removeEventListener(\"complete\",o),e.removeEventListener(\"error\",i),e.removeEventListener(\"abort\",i)},o=()=>{t(),n()},i=()=>{r(e.error||new DOMException(\"AbortError\",\"AbortError\")),n()};e.addEventListener(\"complete\",o),e.addEventListener(\"error\",i),e.addEventListener(\"abort\",i)}));s.set(e,t)}(e),n(e,o||(o=[IDBDatabase,IDBObjectStore,IDBIndex,IDBCursor,IDBTransaction]))?new Proxy(e,f):e);var t}function d(e){if(e instanceof IDBRequest)return function(e){const t=new Promise(((t,r)=>{const n=()=>{e.removeEventListener(\"success\",o),e.removeEventListener(\"error\",i)},o=()=>{t(d(e.result)),n()},i=()=>{r(e.error),n()};e.addEventListener(\"success\",o),e.addEventListener(\"error\",i)}));return t.then((t=>{t instanceof IDBCursor&&a.set(t,e)})).catch((()=>{})),l.set(t,e),t}(e);if(u.has(e))return u.get(e);const t=y(e);return t!==e&&(u.set(e,t),l.set(t,e)),t}const h=e=>l.get(e);function g(e,t,{blocked:r,upgrade:n,blocking:o,terminated:i}={}){const a=indexedDB.open(e,t),s=d(a);return n&&a.addEventListener(\"upgradeneeded\",(e=>{n(d(a.result),e.oldVersion,e.newVersion,d(a.transaction),e)})),r&&a.addEventListener(\"blocked\",(e=>r(e.oldVersion,e.newVersion,e))),s.then((e=>{i&&e.addEventListener(\"close\",(()=>i())),o&&e.addEventListener(\"versionchange\",(e=>o(e.oldVersion,e.newVersion,e)))})).catch((()=>{})),s}function b(e,{blocked:t}={}){const r=indexedDB.deleteDatabase(e);return t&&r.addEventListener(\"blocked\",(e=>t(e.oldVersion,e))),d(r).then((()=>{}))}const v=[\"get\",\"getKey\",\"getAll\",\"getAllKeys\",\"count\"],m=[\"put\",\"add\",\"delete\",\"clear\"],w=new Map;function O(e,t){if(!(e instanceof IDBDatabase)||t in e||\"string\"!=typeof t)return;if(w.get(t))return w.get(t);const r=t.replace(/FromIndex$/,\"\"),n=t!==r,o=m.includes(r);if(!(r in(n?IDBIndex:IDBObjectStore).prototype)||!o&&!v.includes(r))return;const i=async function(e,...t){const i=this.transaction(e,o?\"readwrite\":\"readonly\");let a=i.store;return n&&(a=a.index(t.shift())),(await Promise.all([a[r](...t),o&&i.done]))[0]};return w.set(t,i),i}p((e=>({...e,get:(t,r,n)=>O(t,r)||e.get(t,r,n),has:(t,r)=>!!O(t,r)||e.has(t,r)})));const S=[\"continue\",\"continuePrimaryKey\",\"advance\"],j={},P=new WeakMap,A=new WeakMap,I={get(e,t){if(!S.includes(t))return e[t];let r=j[t];return r||(r=j[t]=function(...e){P.set(this,A.get(this)[t](...e))}),r}};async function*E(...e){let t=this;if(t instanceof IDBCursor||(t=await t.openCursor(...e)),!t)return;const r=new Proxy(t,I);for(A.set(r,t),l.set(r,h(t));t;)yield r,t=await(P.get(r)||t.continue()),P.delete(r)}function D(e,t){return t===Symbol.asyncIterator&&n(e,[IDBIndex,IDBObjectStore,IDBCursor])||\"iterate\"===t&&n(e,[IDBIndex,IDBObjectStore])}p((e=>({...e,get:(t,r,n)=>D(t,r)?E:e.get(t,r,n),has:(t,r)=>D(t,r)||e.has(t,r)})))}},t={};function r(n){var o=t[n];if(void 0!==o)return o.exports;var i=t[n]={exports:{}};return e[n].call(i.exports,i,i.exports,r),i.exports}r.d=(e,t)=>{for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.g=function(){if(\"object\"==typeof globalThis)return globalThis;try{return this||new Function(\"return this\")()}catch(e){if(\"object\"==typeof window)return window}}(),r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:\"Module\"}),Object.defineProperty(e,\"__esModule\",{value:!0})},(()=>{\"use strict\";const e=r(422),t=r(967),n=r(572),o=r(177),i=r(941),a=r(856),s=r(41),c=new e.Database,u=new n.LogFactory,l=new o.IDBDeviceKeysTable(new t.Table(c.get(),\"devicekeys\")),f=new i.IDBIssuesTable(new t.Table(c.get(),\"issues\")),p=new a.IDBLogsTable(new t.Table(c.get(),\"logs\"),u),y=new s.StorageWriter(l,f,u,p);self.addEventListener(\"message\",(e=>{y.handleMessage(e.data)}))})()})();\n", "Worker", void 0, void 0);
          }
        },
        477: function _(e) {
          "use strict";

          e.exports = function (e, t, r, n) {
            var o = self || window;
            try {
              try {
                var i;
                try {
                  i = new o.Blob([e]);
                } catch (t) {
                  (i = new (o.BlobBuilder || o.WebKitBlobBuilder || o.MozBlobBuilder || o.MSBlobBuilder)()).append(e), i = i.getBlob();
                }
                var s = o.URL || o.webkitURL,
                  a = s.createObjectURL(i),
                  c = new o[t](a, r);
                return s.revokeObjectURL(a), c;
              } catch (n) {
                return new o[t]("data:application/javascript,".concat(encodeURIComponent(e)), r);
              }
            } catch (e) {
              if (!n) throw Error("Inline worker is not supported");
              return new o[t](n, r);
            }
          };
        },
        8698: function _(e) {
          function t(r) {
            return e.exports = t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
          }
          e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
        },
        3083: function _(e, t, r) {
          "use strict";

          var n = ["BigInt64Array", "BigUint64Array", "Float32Array", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray"],
            o = "undefined" == typeof globalThis ? r.g : globalThis;
          e.exports = function () {
            for (var e = [], t = 0; t < n.length; t++) {
              "function" == typeof o[n[t]] && (e[e.length] = n[t]);
            }
            return e;
          };
        },
        882: function _(e, t, r) {
          "use strict";

          var n = r(210)("%Object.getOwnPropertyDescriptor%", !0);
          if (n) try {
            n([], "length");
          } catch (e) {
            n = null;
          }
          e.exports = n;
        },
        2998: function _(e, t, r) {
          "use strict";

          r.r(t), r.d(t, {
            deleteDB: function deleteDB() {
              return v;
            },
            openDB: function openDB() {
              return g;
            },
            unwrap: function unwrap() {
              return y;
            },
            wrap: function wrap() {
              return h;
            }
          });
          var n = function n(e, t) {
            return t.some(function (t) {
              return e instanceof t;
            });
          };
          var o, i;
          var s = new WeakMap(),
            a = new WeakMap(),
            c = new WeakMap(),
            u = new WeakMap(),
            l = new WeakMap();
          var d = {
            get: function get(e, t, r) {
              if (e instanceof IDBTransaction) {
                if ("done" === t) return a.get(e);
                if ("objectStoreNames" === t) return e.objectStoreNames || c.get(e);
                if ("store" === t) return r.objectStoreNames[1] ? void 0 : r.objectStore(r.objectStoreNames[0]);
              }
              return h(e[t]);
            },
            set: function set(e, t, r) {
              return e[t] = r, !0;
            },
            has: function has(e, t) {
              return e instanceof IDBTransaction && ("done" === t || "store" === t) || t in e;
            }
          };
          function f(e) {
            d = e(d);
          }
          function p(e) {
            return "function" == typeof e ? (t = e) !== IDBDatabase.prototype.transaction || "objectStoreNames" in IDBTransaction.prototype ? (i || (i = [IDBCursor.prototype.advance, IDBCursor.prototype.continue, IDBCursor.prototype.continuePrimaryKey])).includes(t) ? function () {
              for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                e[_key9] = arguments[_key9];
              }
              return t.apply(y(this), e), h(s.get(this));
            } : function () {
              for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
                e[_key10] = arguments[_key10];
              }
              return h(t.apply(y(this), e));
            } : function (e) {
              var _t18;
              for (var _len11 = arguments.length, r = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
                r[_key11 - 1] = arguments[_key11];
              }
              var n = (_t18 = t).call.apply(_t18, [y(this), e].concat(r));
              return c.set(n, e.sort ? e.sort() : [e]), h(n);
            } : (e instanceof IDBTransaction && function (e) {
              if (a.has(e)) return;
              var t = new Promise(function (t, r) {
                var n = function n() {
                    e.removeEventListener("complete", o), e.removeEventListener("error", i), e.removeEventListener("abort", i);
                  },
                  o = function o() {
                    t(), n();
                  },
                  i = function i() {
                    r(e.error || new DOMException("AbortError", "AbortError")), n();
                  };
                e.addEventListener("complete", o), e.addEventListener("error", i), e.addEventListener("abort", i);
              });
              a.set(e, t);
            }(e), n(e, o || (o = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction])) ? new Proxy(e, d) : e);
            var t;
          }
          function h(e) {
            if (e instanceof IDBRequest) return function (e) {
              var t = new Promise(function (t, r) {
                var n = function n() {
                    e.removeEventListener("success", o), e.removeEventListener("error", i);
                  },
                  o = function o() {
                    t(h(e.result)), n();
                  },
                  i = function i() {
                    r(e.error), n();
                  };
                e.addEventListener("success", o), e.addEventListener("error", i);
              });
              return t.then(function (t) {
                t instanceof IDBCursor && s.set(t, e);
              }).catch(function () {}), l.set(t, e), t;
            }(e);
            if (u.has(e)) return u.get(e);
            var t = p(e);
            return t !== e && (u.set(e, t), l.set(t, e)), t;
          }
          var y = function y(e) {
            return l.get(e);
          };
          function g(e, t) {
            var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
              r = _ref3.blocked,
              n = _ref3.upgrade,
              o = _ref3.blocking,
              i = _ref3.terminated;
            var s = indexedDB.open(e, t),
              a = h(s);
            return n && s.addEventListener("upgradeneeded", function (e) {
              n(h(s.result), e.oldVersion, e.newVersion, h(s.transaction), e);
            }), r && s.addEventListener("blocked", function (e) {
              return r(e.oldVersion, e.newVersion, e);
            }), a.then(function (e) {
              i && e.addEventListener("close", function () {
                return i();
              }), o && e.addEventListener("versionchange", function (e) {
                return o(e.oldVersion, e.newVersion, e);
              });
            }).catch(function () {}), a;
          }
          function v(e) {
            var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
              t = _ref4.blocked;
            var r = indexedDB.deleteDatabase(e);
            return t && r.addEventListener("blocked", function (e) {
              return t(e.oldVersion, e);
            }), h(r).then(function () {});
          }
          var b = ["get", "getKey", "getAll", "getAllKeys", "count"],
            m = ["put", "add", "delete", "clear"],
            S = new Map();
          function w(e, t) {
            if (!(e instanceof IDBDatabase) || t in e || "string" != typeof t) return;
            if (S.get(t)) return S.get(t);
            var r = t.replace(/FromIndex$/, ""),
              n = t !== r,
              o = m.includes(r);
            if (!(r in (n ? IDBIndex : IDBObjectStore).prototype) || !o && !b.includes(r)) return;
            var i = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee66(e) {
                var _s2;
                var i,
                  s,
                  _len12,
                  t,
                  _key12,
                  _args66 = arguments;
                return _regeneratorRuntime().wrap(function _callee66$(_context66) {
                  while (1) {
                    switch (_context66.prev = _context66.next) {
                      case 0:
                        i = this.transaction(e, o ? "readwrite" : "readonly");
                        s = i.store;
                        for (_len12 = _args66.length, t = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
                          t[_key12 - 1] = _args66[_key12];
                        }
                        n && (s = s.index(t.shift()));
                        _context66.next = 6;
                        return Promise.all([(_s2 = s)[r].apply(_s2, t), o && i.done]);
                      case 6:
                        return _context66.abrupt("return", _context66.sent[0]);
                      case 7:
                      case "end":
                        return _context66.stop();
                    }
                  }
                }, _callee66, this);
              }));
              return function i(_x2) {
                return _ref5.apply(this, arguments);
              };
            }();
            return S.set(t, i), i;
          }
          f(function (e) {
            return _objectSpread(_objectSpread({}, e), {}, {
              get: function get(t, r, n) {
                return w(t, r) || e.get(t, r, n);
              },
              has: function has(t, r) {
                return !!w(t, r) || e.has(t, r);
              }
            });
          });
          var _ = ["continue", "continuePrimaryKey", "advance"],
            O = {},
            E = new WeakMap(),
            P = new WeakMap(),
            A = {
              get: function get(e, t) {
                if (!_.includes(t)) return e[t];
                var r = O[t];
                return r || (r = O[t] = function () {
                  var _P$get;
                  E.set(this, (_P$get = P.get(this))[t].apply(_P$get, arguments));
                }), r;
              }
            };
          function I() {
            return _I.apply(this, arguments);
          }
          function _I() {
            _I = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
              var _t19;
              var t,
                r,
                _args67 = arguments;
              return _regeneratorRuntime().wrap(function _callee67$(_context67) {
                while (1) {
                  switch (_context67.prev = _context67.next) {
                    case 0:
                      t = this;
                      _context67.t0 = t instanceof IDBCursor;
                      if (_context67.t0) {
                        _context67.next = 6;
                        break;
                      }
                      _context67.next = 5;
                      return _awaitAsyncGenerator((_t19 = t).openCursor.apply(_t19, _args67));
                    case 5:
                      t = _context67.sent;
                    case 6:
                      if (t) {
                        _context67.next = 8;
                        break;
                      }
                      return _context67.abrupt("return");
                    case 8:
                      r = new Proxy(t, A);
                      P.set(r, t), l.set(r, y(t));
                    case 10:
                      if (!t) {
                        _context67.next = 19;
                        break;
                      }
                      _context67.next = 13;
                      return r;
                    case 13:
                      _context67.next = 15;
                      return _awaitAsyncGenerator(E.get(r) || t.continue());
                    case 15:
                      t = _context67.sent;
                      E.delete(r);
                    case 17:
                      _context67.next = 10;
                      break;
                    case 19:
                    case "end":
                      return _context67.stop();
                  }
                }
              }, _callee67, this);
            }));
            return _I.apply(this, arguments);
          }
          function M(e, t) {
            return t === Symbol.asyncIterator && n(e, [IDBIndex, IDBObjectStore, IDBCursor]) || "iterate" === t && n(e, [IDBIndex, IDBObjectStore]);
          }
          f(function (e) {
            return _objectSpread(_objectSpread({}, e), {}, {
              get: function get(t, r, n) {
                return M(t, r) ? I : e.get(t, r, n);
              },
              has: function has(t, r) {
                return M(t, r) || e.has(t, r);
              }
            });
          });
        }
      },
      __webpack_module_cache__ = {};
    function __webpack_require__(e) {
      var t = __webpack_module_cache__[e];
      if (void 0 !== t) return t.exports;
      var r = __webpack_module_cache__[e] = {
        id: e,
        loaded: !1,
        exports: {}
      };
      return __webpack_modules__[e].call(r.exports, r, r.exports, __webpack_require__), r.loaded = !0, r.exports;
    }
    __webpack_require__.amdO = {}, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return __webpack_require__.d(t, {
        a: t
      }), t;
    }, __webpack_require__.d = function (e, t) {
      for (var r in t) {
        __webpack_require__.o(t, r) && !__webpack_require__.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, __webpack_require__.g = function () {
      if ("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis))) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) return window;
      }
    }(), __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.nmd = function (e) {
      return e.paths = [], e.children || (e.children = []), e;
    };
    var __webpack_exports__ = {};
    return function () {
      "use strict";

      var e = __webpack_exports__;
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.LogLevel = e.BugfenderClass = e.Bugfender = void 0;
      var t = __webpack_require__(7431);
      Object.defineProperty(e, "LogLevel", {
        enumerable: !0,
        get: function get() {
          return t.LogLevel;
        }
      });
      var r = __webpack_require__(2853);
      Object.defineProperty(e, "BugfenderClass", {
        enumerable: !0,
        get: function get() {
          return r.Bugfender;
        }
      });
      var n = new (__webpack_require__(3758).PreInitProvider)(window),
        o = new r.Bugfender(n, "bugfender-web/20230309 (v2.2.4-bd29575-lib)", 20230309);
      e.Bugfender = o;
    }(), __webpack_exports__;
  }();
});